


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { formatEventTriggerDisplay as formatEventTriggerDisplayUtil } from '@/utils/utils';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ApprovalStatusBadge from '@/components/UI/ApprovalStatusBadge.vue';
import ApprovedByColumn from '@/components/UI/ApprovedByColumn.vue';
import Card from '@/components/UI/Card.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import CollapseCard from '@/components/UI/CollapseCard.vue'
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import ColumnTitleContent from '@/components/UI/Table/ColumnTitleContent.vue';
import vSelect from '@/components/UI/vSelect.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {SelectBox} from '@/interfaces/global-data';
import {formatPurchasePriceDeviationPercent} from '@/utils/eventTriggerTypes';
import {PriceImportMode, UniqSkuData} from '@/interfaces/server-data'

import {
    ApprovalStatus,
    ChangesPrices,
    DetailReportsPricesAndCodes,
    FtpDownloadProgress,
    InternalCodesWithCorrPrices,
    PackageParamsInDetailReportFilters,
    ReportDetailColumnsForAddOrDelete,
    ReportDetailFieldsView,
    ReportDetailParams,
    ReportDetailSegments,
    ResultTableDetailReports,
    ResultTableHeaders,
    SortingField,
    TaskAndFile,
    TaskData,
    TaskIdToInternalCode,
    TaskStatus,
    TaskType,
    ApproveReportElementsSelectedCheckboxesData,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import {FormatNumber} from '@/numberFormatter';
import { isValidNumberValue } from "@/utils/utils";
import { Formatter } from '@/helpers/formatters';
import {BModal} from 'bootstrap-vue';
import moment from 'moment';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import draggable from 'vuedraggable';

interface commonFilters {
    groups: [];
    categories: [];
    subcategories: [];
    storeFormat: [];
    storeRegion: [];
    storeCluster: [];
}

interface IFilterOptions {
    groups: Array<{ id: number | string, name: string }>;
    categories: Array<{ id: number | string, name: string }>;
    subcategories: Array<{ id: number | string, name: string }>;
    storeFormat: Array<{ id: number | string, name: string }>;
    storeRegion: Array<{ id: number | string, name: string }>;
    storeCluster: Array<{ id: number | string, name: string }>;
}

interface IInfoPayloadData {
    groups: string[];
    categories: string[];
    subcategories: string[];
    storeFormat: string[];
    storeRegion: string[];
    storeCluster: string[];
    tradingId: number;
    type: string;
}

interface IColumnLight {
    dataIndex: string;
    title: string;
    customRender?: (value: any, record?: any, index?: number) => any;
    formatter?: (value: any, key?: string, item?: any) => any;
}

@Component({
    components: {
        ColumnTitleContent,
        MultiSelect,
        MarketSelect,
        vSelect,
        LocalData,
        CollapseCard,
        Card,
        CSelect,
        draggable,
        SwitchWithLabel,
        ApprovalStatusBadge,
        ApprovedByColumn,
    },
    computed: {
        isValidNumberValue() {
            return isValidNumberValue;
        }
    },
    methods: {
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') { // "KVI"
                        if (!item.activeProduct) {
                            return 'blue strikethroughRow'
                        } else {
                            return 'blue';
                        }
                }
                if (item.ctm === 'ДА') { // "CTM"
                    if (!item.activeProduct) {
                        return 'pale-yellow strikethroughRow'
                    } else {
                        return 'pale-yellow';
                    }
                }
                if (item.resultType === 'COMPETITOR') { // this.$t('regular.tooltips.competitivePricingProduct') as string
                    if (!item.activeProduct) {
                        return 'light-pink strikethroughRow'
                    } else {
                        return 'light-pink';
                    }
                }
                if (item.newPrice > item.limitRetailPrice) { // this.$t('regular.tooltips.newPriceAboveMaxAllowed') as string
                    if (!item.activeProduct) {
                        return 'bright-yellow strikethroughRow'
                    } else {
                        return 'bright-yellow';
                    }
                }
                if (item.wasPromoInRotationPeriod) { // this.$t('regular.tooltips.productInPromoRotation') as string
                    if (!item.activeProduct) {
                        return 'aqua strikethroughRow'
                    } else {
                        return 'aqua';
                    }
                }
                if (!item.activeProduct) {
                        return 'strikethroughRow'
                }
                if (item.eventTrigger) { // this.$t('regular.tooltips.eventProduct') as string
                        return 'table eventTriggerColor'
                    }
                }
            },
            replaceCommaFormatter(value) {
                return value.replace(',', '.')
            },

        },
        filters: {
            formatDate: (v: any) => {
                if (v) {
                    return moment(new Date(+v)).format('DD/MM/YYYY');
                }
            },
        },
    })
export default class AllSkusTab extends Mixins(LocalData, Toast, Http) {
        // @ts-ignore
        @Prop() taskData: TaskAndFile | null;
        formatEventTriggerDisplay = formatEventTriggerDisplayUtil;
        correctedPricesFile: File | null = null;
        correctedPromoPricesFile: File | null = null;
        progressCounter: number = 0;
        loadProgress: boolean = false;
        subTaskIdForSendToFTP: number = -1;
        detailUserFields: ReportDetailFieldsView[] = [];
        detailColumnsListForAddFields: ReportDetailFieldsView[] = [];
        detailColumnsListForDeleteFields: ReportDetailFieldsView[] = [];
        showSendToFTPReportModal: boolean = false;
        showSortingModal: boolean = false;
        showSendToFTPSubTaskReportModal: boolean = false;
        tableIsLoading: boolean = false;
        isAllSkusSelected: boolean = true;
        includedSkusProperties: Array<{ internalCode: string, taskId: number }> = [];
        excludedSkusProperties: Array<{ internalCode: string, taskId: number }> = [];
        arrayOfPushedInactiveSkus: Array<{ internalCode: string, taskId: number }> = [];
        filteredSkusSnapshot: Array<{ internalCode: string, taskId: number }> = [];
        isFilterActive: boolean = false;
        tableCheckboxesPrevConfiguration: {
            selectActiveProductsOnly: boolean,
            isAllSkusSelected: boolean,
            includedSkusProperties: Array<{ internalCode: string, taskId: number }>,
            excludedSkusProperties: Array<{ internalCode: string, taskId: number }>,
        } = {
            selectActiveProductsOnly: true,
            isAllSkusSelected: true,
            includedSkusProperties: [],
            excludedSkusProperties: [],
        };
        resultGeneralSubtasksTableHeaders: ResultTableHeaders[] = [];
        isGeneralRegularPackage: boolean = false;
        subtasksTotalRows: number = 1;
        subtasksListPerPage: number = 25;
        subtasksListCurrentPage: number = 1;
        showGeneralComparableBlock: boolean = true;
        resultDetailReportPerPage: number = 100;
        detailTableIdName: string = 'resultDetailReport';
        downloadLastExcelDetailByFilters: boolean = false;
        resultTableDetailReports: ResultTableDetailReports[] = [];
        reportType: 'regular' | 'promo' | 'sales' = 'regular';
        isPackageOrScheduleReport: boolean = false;
        isPackagePromoReport: boolean = false;
        showDeletedItems: boolean = false;
        isDownloadAllFiltersName: boolean = false;
        downloadLastExcelHeaderByFilters: boolean = false;
        refreshHeaderTableId = -1;
        refreshDetailTableId = -1;
        skuListCurrentPage: number = 1;
        detailTableSkuFilter: string = '';
        selectActiveProductsOnly: boolean = true;
        showApproveSingleLineModal: boolean = false;
        singleLineToApprove: ResultTableDetailReports | null = null;
        showApproveAllDisplayedLinesModal: boolean = false;

        sortingField: SortingField | null = null;
        defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};
        detailReportTotalRows: number = 0;
        disableSelectedReports: boolean = true;
        defaultStringFiltersValue = {value: '', label: this.$t('regular.common.all') as string};
        paramsForDetail: DetailReportsPricesAndCodes = new DetailReportsPricesAndCodes()
        changesPrices: ChangesPrices[] = []
        allTaskIdWithInternalCodesByFilters: TaskIdToInternalCode[] = []
        hasCorrectedPrices: boolean = false
        regularColumnsForManageModal: Array<IColumnLight> = [
            { dataIndex: "internalCode", title: this.$t('regular.columns.internalCode') as string },
            { dataIndex: "skuName", title: this.$t('regular.columns.skuName') as string },
            { dataIndex: "isApproved", title: this.$t('regular.columns.approval') as string },
            { dataIndex: "approvedByFio", title: this.$t('regular.columns.approvedBy') as string },
            { dataIndex: "status", title: this.$t('regular.columns.status') as string },
            { dataIndex: "detailedStatus", title: this.$t('regular.columns.detailedStatus') as string },
            { dataIndex: "uploadFile", title: this.$t('regular.columns.uploadFile') as string },
            { dataIndex: "newPrice", title: this.$t('regular.columns.newPrice') as string },
            { dataIndex: "newPriceHistory", title: this.$t('regular.columns.newPriceHistory') as string },
            { dataIndex: "correctedRegularPrice", title: this.$t('regular.columns.correctedPrice') as string },
            { dataIndex: "newMarginPc", title: this.$t('regular.columns.newMargin') as string },
            { dataIndex: "newPI", title: this.$t('regular.columns.newPi') as string },
            { dataIndex: "deltaDiffPrice", title: this.$t('regular.columns.deltaPrice') as string },
            { dataIndex: "priceDiffPc", title: this.$t('regular.columns.pctPriceChange') as string },
            { dataIndex: "marginDiff", title: this.$t('regular.columns.marginChangePp') as string },
            { dataIndex: "changedPI", title: this.$t('regular.columns.piChangePp') as string },
            { dataIndex: "exitSegment", title: this.$t('regular.columns.segmentExit') as string },
            { dataIndex: "coeffElasticity", title: this.$t('regular.columns.elasticityCoeff') as string },
            { dataIndex: "remains", title: this.$t('regular.columns.stock') as string },
            { dataIndex: "salesForecast", title: this.$t('regular.columns.forecastSalesUnits') as string },
            { dataIndex: "revenueForecast", title: this.$t('regular.columns.forecastRevenue') as string },
            { dataIndex: "marginForecast", title: this.$t('regular.columns.forecastMargin') as string },
            { dataIndex: "marginForecastPc", title: this.$t('regular.columns.forecastMarginPercent') as string },
            { dataIndex: "changeSales", title: this.$t('regular.columns.changeSalesUnits') as string },
            { dataIndex: "changeRevenue", title: this.$t('regular.columns.changeRevenue') as string },
            { dataIndex: "changeMargin", title: this.$t('regular.columns.changeMargin') as string },
            { dataIndex: "salesDiffPc", title: this.$t('regular.columns.pctChangeSales') as string },
            { dataIndex: "revenueDiffPc", title: this.$t('regular.columns.pctChangeRevenue') as string },
            { dataIndex: "marginDiffPc", title: this.$t('regular.columns.pctChangeMargin') as string },
            { dataIndex: "marginDiffSecond", title: this.$t('regular.columns.marginChangePp') as string },
            { dataIndex: "salesForecastByRegularPrice", title: this.$t('regular.columns.forecastSalesCurrent') as string },
            { dataIndex: "revenueForecastByRegularPrice", title: this.$t('regular.columns.forecastRevenueCurrent') as string },
            { dataIndex: "marginForecastByRegularPrice", title: this.$t('regular.columns.forecastMarginCurrent') as string },
            { dataIndex: "marginForecastByRegularPricePc", title: this.$t('regular.columns.forecastMarginCurrentPercent') as string },
            { dataIndex: "changeSalesByRegularPrice", title: this.$t('regular.columns.changeSalesCurrentUnits') as string },
            { dataIndex: "changeRevenueByRegularPrice", title: this.$t('regular.columns.changeRevenueCurrent') as string },
            { dataIndex: "changeMarginByRegularPrice", title: this.$t('regular.columns.changeMarginCurrent') as string },
            { dataIndex: "salesDiffPcByRegularPrice", title: this.$t('regular.columns.pctChangeSalesCurrent') as string },
            { dataIndex: "revenueDiffPcByRegularPrice", title: this.$t('regular.columns.pctChangeRevenueCurrent') as string },
            { dataIndex: "marginDiffPcByRegularPrice", title: this.$t('regular.columns.pctChangeMarginCurrent') as string },
            { dataIndex: "marginDiffSecondByRegularPrice", title: this.$t('regular.columns.marginChangeCurrentPp') as string },
            { dataIndex: "taskId", title: this.$t('regular.columns.reportNo') as string },
            { dataIndex: "groupName", title: this.$t('regular.columns.productGroup') as string },
            { dataIndex: "categoryName", title: this.$t('regular.columns.productCategory') as string },
            { dataIndex: "subCategoryName", title: this.$t('regular.columns.productSubcategory') as string },
            { dataIndex: "formatName", title: this.$t('regular.columns.formatChannel') as string },
            { dataIndex: "regionName", title: this.$t('regular.columns.storeRegion') as string },
            { dataIndex: "clusterName", title: this.$t('regular.columns.storeCluster') as string },
            { dataIndex: "productSegmentName", title: this.$t('regular.columns.productSegment') as string },
            { dataIndex: "batchNumber", title: this.$t('regular.columns.batchNumber') as string },
            { dataIndex: "recipeAttribute", title: this.$t('regular.columns.prc') as string },
            { dataIndex: "treatmentAttribute", title: this.$t('regular.columns.pkl') as string },
            { dataIndex: "vitalMedicine", title: this.$t('regular.columns.essentialDrugs') as string },
            { dataIndex: "producerPrice", title: this.$t('regular.columns.producerPriceVat') as string },
            { dataIndex: "extraChargePc", title: this.$t('regular.columns.markupPercent') as string },
            { dataIndex: "registrationPrice", title: this.$t('regular.columns.registrationPriceVat') as string },
            { dataIndex: "eventTrigger", title: this.$t('regular.columns.eventTrigger') as string },
            { dataIndex: "purchasePriceDeviationPercent", title: this.$t('regular.columns.purchasePriceDeviationPercent') as string, customRender: (value: number | null) => formatPurchasePriceDeviationPercent(value)},
            { dataIndex: "kvi", title: "KVI", customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctm", title: this.$t('regular.columns.ctm') as string, customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctmBrand", title: this.$t('regular.columns.ctmBrandTarget') as string },
            { dataIndex: "ctmPriceGap", title: this.$t('regular.columns.ctmPriceGap') as string },
            { dataIndex: "minRetailPrice", title: this.$t('regular.columns.minRetailPrice') as string },
            { dataIndex: "maxRetailPrice", title: this.$t('regular.columns.maxRetailPrice') as string },
            { dataIndex: "omnichannelStrategy", title: this.$t('regular.columns.omnichannelStrategy') as string },
            { dataIndex: "omnichannelFixedGapType", title: this.$t('regular.columns.omnichannelFixedGapType') as string },
            { dataIndex: "omnichannelGap", title: this.$t('regular.columns.omnichannelGap') as string },
            { dataIndex: "omnichannelApplyCompetitorPrices", title: this.$t('regular.columns.omnichannelApplyCompetitorPrices') as string },
            { dataIndex: "omnichannelMinProfitabilityLimit", title: this.$t('regular.columns.omnichannelMinProfitabilityLimit') as string },
            { dataIndex: "omnichannelBaseChannelPrice", title: this.$t('regular.columns.omnichannelBaseChannelPrice') as string },
            { dataIndex: "keyProduct1", title: this.$t('regular.columns.kht1') as string },
            { dataIndex: "keyProduct2", title: this.$t('regular.columns.kht2') as string },
            { dataIndex: "keyProduct3", title: this.$t('regular.columns.kht3') as string },
            { dataIndex: "keyProduct4", title: this.$t('regular.columns.kht4') as string },
            { dataIndex: "keyProduct5", title: this.$t('regular.columns.kht5') as string },
            { dataIndex: "segment", title: this.$t('regular.columns.segment') as string },
            { dataIndex: "skuLine", title: this.$t('regular.columns.skuPriceLine') as string },
            { dataIndex: "purchasePrice", title: this.$t('regular.columns.purchasePrice') as string },
            { dataIndex: "avgRegularPrice", title: this.$t('regular.columns.avgRegularPrice') as string },
            { dataIndex: "avgCashPrice", title: this.$t('regular.columns.avgCashierPrice') as string },
            { dataIndex: "avgCheckPrice", title: this.$t('regular.columns.avgReceiptPrice') as string },
            { dataIndex: "regularPrice", title: this.$t('regular.columns.currentRegularPrice') as string },
            { dataIndex: "marginLastPrice", title: this.$t('regular.columns.lastPriceMargin') as string },
            { dataIndex: "minCompetitorPrice", title: this.$t('regular.columns.minCompetitorPrice') as string },
            { dataIndex: "minCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "maxCompetitorPrice", title: this.$t('regular.columns.maxCompetitorPrice') as string },
            { dataIndex: "maxCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "avgCompetitorPrice", title: this.$t('regular.columns.avgCompetitorPrice') as string },
            { dataIndex: "lastCompetitorPrice", title: this.$t('regular.columns.lastCompetitorPrice') as string },
            { dataIndex: "pi", title: "PI" },
            { dataIndex: "actualSales", title: this.$t('regular.columns.actualSalesUnitsFull') as string },
            { dataIndex: "actualRevenue", title: this.$t('regular.columns.actualRevenueFull') as string },
            { dataIndex: "actualMargin", title: this.$t('regular.columns.actualMarginFull') as string },
            { dataIndex: "actualMarginPercent", title: this.$t('regular.columns.actualMarginPercentFull') as string },
            { dataIndex: "comparableSales", title: this.$t('regular.columns.compSalesUnitsFull') as string },
            { dataIndex: "comparableRevenue", title: this.$t('regular.columns.compRevenueFull') as string },
            { dataIndex: "comparableMargin", title: this.$t('regular.columns.compMarginFull') as string },
            { dataIndex: "comparableMarginPc", title: this.$t('regular.columns.compMarginPercentFull') as string },
            { dataIndex: "logisticCostsPercentage", title: this.$t('regular.columns.logisticsCostPercent') as string },
            { dataIndex: "logisticCostsAmount", title: this.$t('regular.columns.logisticsCostNoVat') as string },
            { dataIndex: "marketingPaymentsPercentage", title: this.$t('regular.columns.marketingPayments') as string },
            { dataIndex: "limitRetailPrice", title: this.$t('regular.columns.maxRetailPriceRub') as string },
            { dataIndex: "markupPercentage", title: this.$t('regular.columns.maxMarkup') as string },
            { dataIndex: "vatPercentage", title: this.$t('regular.columns.vatPercent') as string },
            { dataIndex: "basePrice", title: this.$t('regular.columns.producerPriceNoVat') as string },
            { dataIndex: "individualPriceOptStrategy", title: this.$t('regular.columns.priceOptStrategy') as string },
            { dataIndex: "individualPriceIncreaseLimit", title: this.$t('regular.columns.increaseLimit') as string },
            { dataIndex: "individualPeriodPriceIncreaseLimit", title: this.$t('regular.columns.periodIncreaseLimitPercent') as string },
            { dataIndex: "individualPeriod", title: this.$t('regular.columns.period') as string },
            { dataIndex: "individualMarginalProfit", title: this.$t('regular.columns.minSkuProfitFull') as string },
            { dataIndex: "individualKviStrategy", title: this.$t('regular.columns.kviStrategy') as string },
            { dataIndex: "individualPercentCorrection", title: this.$t('regular.columns.adjustment') as string },
            { dataIndex: "individualNewProductPriceStrategy", title: this.$t('regular.columns.newProductPricingStrategy') as string },
            { dataIndex: "individualPriceGapPercent", title: this.$t('regular.columns.priceGapPercent') as string },
            { dataIndex: "productVerticalLine", title: this.$t('regular.columns.vlName') as string },
            { dataIndex: "productVolume", title: this.$t('regular.columns.vgh') as string },
            { dataIndex: "measurementUnit", title: this.$t('regular.columns.unit') as string },
            { dataIndex: "isVerticalLineBase", title: this.$t('regular.columns.base') as string },
            { dataIndex: "vlStrategyStr", title: this.$t('regular.columns.vlStrategy') as string },
            { dataIndex: "vlGapPc", title: this.$t('regular.columns.verticalLineGap') as string,
              customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType) },
            { dataIndex: "comment", title: this.$t('regular.columns.comment') as string },
        ];

        promoColumnsForManageModal: Array<IColumnLight> = [
            { dataIndex: "internalCode", title: this.$t('regular.columns.internalCode') as string },
            { dataIndex: "skuName", title: this.$t('regular.columns.skuName') as string },
            { dataIndex: "salePointCode", title: this.$t('regular.columns.storeCode') as string },
            { dataIndex: "taskId", title: this.$t('regular.columns.reportNo') as string },
            { dataIndex: "status", title: this.$t('regular.columns.status') as string },
            { dataIndex: "detailedStatus", title: this.$t('regular.columns.detailedStatus') as string },
            { dataIndex: "isApproved", title: this.$t('regular.columns.approval') as string },
            { dataIndex: "approvedByFio", title: this.$t('regular.columns.approvedBy') as string },
            { dataIndex: "newPrice", title: this.$t('regular.columns.newPrice') as string },
            { dataIndex: "newPriceHistory", title: this.$t('regular.columns.newPriceHistory') as string },
            { dataIndex: "optimalNewPromoPrice", title: this.$t('regular.columns.optimalPromoPrice') as string },
            { dataIndex: "optimalDiscountDepth", title: this.$t('regular.columns.optimalDiscountDepth') as string },
            { dataIndex: "firstDiscountForPromotion", title: this.$t('regular.columns.periodDiscount') as string },
            { dataIndex: "minPriceForPromotion", title: this.$t('regular.columns.minPrice') as string },
            { dataIndex: "maxPriceForPromotion", title: this.$t('regular.columns.maxPrice') as string },
            { dataIndex: "minDiscountForPromotion", title: this.$t('regular.columns.minPromoDiscount') as string },
            { dataIndex: "maxDiscountForPromotion", title: this.$t('regular.columns.maxPromoDiscount') as string },
            { dataIndex: "minMarginForPromotion", title: this.$t('regular.columns.minPromoMargin') as string },
            { dataIndex: "marginLoss", title: this.$t('regular.columns.grossIncomeLosses') as string },
            { dataIndex: "marginLossPc", title: this.$t('regular.columns.grossIncomeLossesPercent') as string },
            { dataIndex: "remains", title: this.$t('regular.columns.stock') as string },
            { dataIndex: "groupName", title: this.$t('regular.columns.productGroup') as string },
            { dataIndex: "categoryName", title: this.$t('regular.columns.productCategory') as string },
            { dataIndex: "subCategoryName", title: this.$t('regular.columns.productSubcategory') as string },
            { dataIndex: "formatName", title: this.$t('regular.columns.formatChannel') as string },
            { dataIndex: "regionName", title: this.$t('regular.columns.storeRegion') as string },
            { dataIndex: "clusterName", title: this.$t('regular.columns.storeCluster') as string },
            { dataIndex: "productSegmentName", title: this.$t('regular.columns.productSegment') as string },
            { dataIndex: "recipeAttribute", title: this.$t('regular.columns.prc') as string },
            { dataIndex: "treatmentAttribute", title: this.$t('regular.columns.pkl') as string },
            { dataIndex: "vitalMedicine", title: this.$t('regular.columns.essentialDrugs') as string },
            { dataIndex: "producerPrice", title: this.$t('regular.columns.producerPriceVat') as string },
            { dataIndex: "extraChargePc", title: this.$t('regular.columns.markupPercent') as string },
            { dataIndex: "registrationPrice", title: this.$t('regular.columns.registrationPriceVat') as string },
            { dataIndex: "eventTrigger", title: this.$t('regular.columns.eventTrigger') as string },
            { dataIndex: "purchasePriceDeviationPercent", title: this.$t('regular.columns.purchasePriceDeviationPercent') as string, customRender: (value: number | null) => formatPurchasePriceDeviationPercent(value)},
            { dataIndex: "kvi", title: "KVI", customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctm", title: this.$t('regular.columns.ctm') as string, customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctmBrand", title: this.$t('regular.columns.ctmBrandTarget') as string },
            { dataIndex: "ctmPriceGap", title: this.$t('regular.columns.ctmPriceGap') as string },
            { dataIndex: "minRetailPrice", title: this.$t('regular.columns.minRetailPrice') as string },
            { dataIndex: "maxRetailPrice", title: this.$t('regular.columns.maxRetailPrice') as string },
            { dataIndex: "omnichannelStrategy", title: this.$t('regular.columns.omnichannelStrategy') as string },
            { dataIndex: "omnichannelFixedGapType", title: this.$t('regular.columns.omnichannelFixedGapType') as string },
            { dataIndex: "omnichannelGap", title: this.$t('regular.columns.omnichannelGap') as string },
            { dataIndex: "omnichannelApplyCompetitorPrices", title: this.$t('regular.columns.omnichannelApplyCompetitorPrices') as string },
            { dataIndex: "omnichannelMinProfitabilityLimit", title: this.$t('regular.columns.omnichannelMinProfitabilityLimit') as string },
            { dataIndex: "omnichannelBaseChannelPrice", title: this.$t('regular.columns.omnichannelBaseChannelPrice') as string },
            { dataIndex: "keyProduct1", title: this.$t('regular.columns.kht1') as string },
            { dataIndex: "keyProduct2", title: this.$t('regular.columns.kht2') as string },
            { dataIndex: "keyProduct3", title: this.$t('regular.columns.kht3') as string },
            { dataIndex: "keyProduct4", title: this.$t('regular.columns.kht4') as string },
            { dataIndex: "keyProduct5", title: this.$t('regular.columns.kht5') as string },
            { dataIndex: "segment", title: this.$t('regular.columns.segment') as string },
            { dataIndex: "skuLine", title: this.$t('regular.columns.skuPriceLine') as string },
            { dataIndex: "purchasePrice", title: this.$t('regular.columns.purchasePrice') as string },
            { dataIndex: "promoPurchasePrice", title: this.$t('regular.columns.purchasePriceForPromo') as string },
            { dataIndex: "avgRegularPrice", title: this.$t('regular.columns.avgRegularPrice') as string },
            { dataIndex: "avgCashPrice", title: this.$t('regular.columns.avgCashierPrice') as string },
            { dataIndex: "avgCheckPrice", title: this.$t('regular.columns.avgReceiptPrice') as string },
            { dataIndex: "regularPrice", title: this.$t('regular.columns.currentRegularPrice') as string },
            { dataIndex: "marginLastPrice", title: this.$t('regular.columns.lastPriceMargin') as string },
            { dataIndex: "minCompetitorPrice", title: this.$t('regular.columns.minCompetitorPrice') as string },
            { dataIndex: "minCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "minCompetitorCode", title: this.$t('regular.columns.competitorCode') as string },
            { dataIndex: "maxCompetitorPrice", title: this.$t('regular.columns.maxCompetitorPrice') as string },
            { dataIndex: "maxCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "maxCompetitorCode", title: this.$t('regular.columns.competitorCode') as string },
            { dataIndex: "avgCompetitorPrice", title: this.$t('regular.columns.avgCompetitorPrice') as string },
            { dataIndex: "lastCompetitorPrice", title: this.$t('regular.columns.lastCompetitorPrice') as string },
            { dataIndex: "minPromoCompetitorPrice", title: this.$t('regular.columns.minPromoCompetitorPrice') as string },
            { dataIndex: "minPromoCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "minPromoCompetitorCode", title: this.$t('regular.columns.competitorCode') as string },
            { dataIndex: "maxPromoCompetitorPrice", title: this.$t('regular.columns.maxPromoCompetitorPrice') as string },
            { dataIndex: "maxPromoCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "maxPromoCompetitorCode", title: this.$t('regular.columns.competitorCode') as string },
            { dataIndex: "medianPromoCompetitorPrice", title: this.$t('regular.columns.medianPromoCompPrice') as string },
            { dataIndex: "lastPromoCompetitorPrice", title: this.$t('regular.columns.lastPromoCompetitorPrice') as string },
            { dataIndex: "pi", title: "PI" },
            { dataIndex: "promoPi", title: this.$t('regular.columns.promoPi') as string },
            { dataIndex: "actualSales", title: this.$t('regular.columns.actualSalesUnitsFull') as string },
            { dataIndex: "actualRevenue", title: this.$t('regular.columns.actualRevenueFull') as string },
            { dataIndex: "actualMargin", title: this.$t('regular.columns.actualMarginFull') as string },
            { dataIndex: "actualMarginPercent", title: this.$t('regular.columns.actualMarginPercentFull') as string },
            { dataIndex: "comparableSales", title: this.$t('regular.columns.compSalesUnitsFull') as string },
            { dataIndex: "comparableRevenue", title: this.$t('regular.columns.compRevenueFull') as string },
            { dataIndex: "comparableMargin", title: this.$t('regular.columns.compMarginFull') as string },
            { dataIndex: "comparableMarginPc", title: this.$t('regular.columns.compMarginPercentFull') as string },
            { dataIndex: "newPromoPrice", title: this.$t('regular.columns.promoPriceWithComp') as string },
            { dataIndex: "correctedPromoPrice", title: this.$t('regular.columns.correctedPromoPrice') as string },
            { dataIndex: "newMarginPc", title: this.$t('regular.columns.newMargin') as string },
            { dataIndex: "newPI", title: this.$t('regular.columns.newPi') as string },
            { dataIndex: "deltaDiffPrice", title: this.$t('regular.columns.deltaPrice') as string },
            { dataIndex: "priceDiffPc", title: this.$t('regular.columns.pctPriceChange') as string },
            { dataIndex: "marginDiff", title: this.$t('regular.columns.marginChangePp') as string },
            { dataIndex: "changedPI", title: this.$t('regular.columns.piChangePp') as string },
            { dataIndex: "discountDepth", title: this.$t('regular.columns.discountDepthWithComp') as string },
            { dataIndex: "discountDuration", title: this.$t('regular.columns.discountLength') as string },
            { dataIndex: "exitSegment", title: this.$t('regular.columns.segmentExit') as string },
            { dataIndex: "coeffElasticity", title: this.$t('regular.columns.elasticityCoeff') as string },
            { dataIndex: "promoCoeffElasticity", title: this.$t('regular.columns.promoElasticity') as string },
            { dataIndex: "salesForecast", title: this.$t('regular.columns.forecastSalesUnits') as string },
            { dataIndex: "revenueForecast", title: this.$t('regular.columns.forecastRevenue') as string },
            { dataIndex: "marginForecast", title: this.$t('regular.columns.forecastMargin') as string },
            { dataIndex: "marginForecastPc", title: this.$t('regular.columns.forecastMarginPercent') as string },
            { dataIndex: "changeSales", title: this.$t('regular.columns.changeSalesUnits') as string },
            { dataIndex: "changeRevenue", title: this.$t('regular.columns.changeRevenue') as string },
            { dataIndex: "changeMargin", title: this.$t('regular.columns.changeMargin') as string },
            { dataIndex: "salesDiffPc", title: this.$t('regular.columns.pctChangeSales') as string },
            { dataIndex: "revenueDiffPc", title: this.$t('regular.columns.pctChangeRevenue') as string },
            { dataIndex: "marginDiffPc", title: this.$t('regular.columns.pctChangeMargin') as string },
            { dataIndex: "marginDiffSecond", title: this.$t('regular.columns.marginChangePp') as string },
            { dataIndex: "individualPromoType", title: this.$t('regular.columns.promoType') as string },
            { dataIndex: "individualPromoLift", title: this.$t('regular.columns.regularPriceAdjustment') as string },
            { dataIndex: "individualPriceOptStrategy", title: this.$t('regular.columns.priceOptStrategy') as string },
            { dataIndex: "individualPriceIncreaseLimit", title: this.$t('regular.columns.increaseLimit') as string },
            { dataIndex: "individualPeriodPriceIncreaseLimit", title: this.$t('regular.columns.periodIncreaseLimitPercent') as string },
            { dataIndex: "individualPeriod", title: this.$t('regular.columns.period') as string },
            { dataIndex: "individualMarginalProfit", title: this.$t('regular.columns.minSkuProfitFull') as string },
            { dataIndex: "individualKviStrategy", title: this.$t('regular.columns.kviStrategy') as string },
            { dataIndex: "individualPercentCorrection", title: this.$t('regular.columns.adjustment') as string },
            { dataIndex: "individualNewProductPriceStrategy", title: this.$t('regular.columns.newProductPricingStrategy') as string },
            { dataIndex: "individualPriceGapPercent", title: this.$t('regular.columns.priceGapPercent') as string },
            { dataIndex: "comment", title: this.$t('regular.columns.comment') as string },
            { dataIndex: "logisticCostsPercentage", title: this.$t('regular.columns.logisticsCostPercent') as string },
            { dataIndex: "logisticCostsAmount", title: this.$t('regular.columns.logisticsCostNoVat') as string },
            { dataIndex: "marketingPaymentsPercentage", title: this.$t('regular.columns.marketingPayments') as string },
            { dataIndex: "basePrice", title: this.$t('regular.columns.producerPriceNoVat') as string },
            { dataIndex: "vatPercentage", title: this.$t('regular.columns.vatPercent') as string },
            { dataIndex: "markupPercentage", title: this.$t('regular.columns.maxMarkup') as string },
        ];

        salesColumnsForManageModal: Array<IColumnLight> = [
            { dataIndex: "internalCode", title: this.$t('regular.columns.internalCode') as string },
            { dataIndex: "skuName", title: this.$t('regular.columns.skuName') as string },
            { dataIndex: "salePointCode", title: this.$t('regular.columns.storeCode') as string },
            { dataIndex: "taskId", title: this.$t('regular.columns.reportNo') as string },
            { dataIndex: "status", title: this.$t('regular.columns.status') as string },
            { dataIndex: "detailedStatus", title: this.$t('regular.columns.detailedStatus') as string },
            { dataIndex: "isApproved", title: this.$t('regular.columns.approval') as string },
            { dataIndex: "approvedByFio", title: this.$t('regular.columns.approvedBy') as string },
            { dataIndex: "newPrice", title: this.$t('regular.columns.regularPrice') as string },
            { dataIndex: "newPriceHistory", title: this.$t('regular.columns.newPriceHistory') as string },
            { dataIndex: "optimalNewPromoPrice", title: this.$t('regular.columns.optimalPromoPrice') as string },
            { dataIndex: "optimalDiscountDepth", title: this.$t('regular.columns.optimalDiscountDepth') as string },
            { dataIndex: "firstDiscountForSale", title: this.$t('regular.columns.discount1stPeriod') as string },
            { dataIndex: "secondDiscountForSale", title: this.$t('regular.columns.discount2ndPeriod') as string },
            { dataIndex: "thirdDiscountForSale", title: this.$t('regular.columns.discount3rdPeriod') as string },
            { dataIndex: "fourthDiscountForSale", title: this.$t('regular.columns.discount4thPeriod') as string },
            { dataIndex: "minPriceForSale", title: this.$t('regular.columns.minSalePrice') as string },
            { dataIndex: "maxPriceForSale", title: this.$t('regular.columns.maxSalePrice') as string },
            { dataIndex: "minDiscountForSale", title: this.$t('regular.columns.minSaleDiscount') as string },
            { dataIndex: "maxDiscountForSale", title: this.$t('regular.columns.minSaleDiscount') as string },
            { dataIndex: "minMarginForSale", title: this.$t('regular.columns.minSaleMargin') as string },
            { dataIndex: "marginLoss", title: this.$t('regular.columns.grossIncomeLosses') as string },
            { dataIndex: "marginLossPc", title: this.$t('regular.columns.grossIncomeLossesPercent') as string },
            { dataIndex: "remains", title: this.$t('regular.columns.stock') as string },
            { dataIndex: "initialRemains", title: this.$t('regular.columns.initialRemains') as string },
            { dataIndex: "realizationPercent", title: this.$t('regular.columns.realizationPercent') as string },
            { dataIndex: "groupName", title: this.$t('regular.columns.productGroup') as string },
            { dataIndex: "categoryName", title: this.$t('regular.columns.productCategory') as string },
            { dataIndex: "subCategoryName", title: this.$t('regular.columns.productSubcategory') as string },
            { dataIndex: "formatName", title: this.$t('regular.columns.formatChannel') as string },
            { dataIndex: "regionName", title: this.$t('regular.columns.storeRegion') as string },
            { dataIndex: "clusterName", title: this.$t('regular.columns.storeCluster') as string },
            { dataIndex: "productSegmentName", title: this.$t('regular.columns.productSegment') as string },
            { dataIndex: "recipeAttribute", title: this.$t('regular.columns.prc') as string },
            { dataIndex: "treatmentAttribute", title: this.$t('regular.columns.pkl') as string },
            { dataIndex: "vitalMedicine", title: this.$t('regular.columns.essentialDrugs') as string },
            { dataIndex: "producerPrice", title: this.$t('regular.columns.producerPriceVat') as string },
            { dataIndex: "extraChargePc", title: this.$t('regular.columns.markupPercent') as string },
            { dataIndex: "registrationPrice", title: this.$t('regular.columns.registrationPriceVat') as string },
            { dataIndex: "eventTrigger", title: this.$t('regular.columns.eventTrigger') as string },
            { dataIndex: "purchasePriceDeviationPercent", title: this.$t('regular.columns.purchasePriceDeviationPercent') as string, customRender: (value: number | null) => formatPurchasePriceDeviationPercent(value)},
            { dataIndex: "kvi", title: "KVI", customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctm", title: this.$t('regular.columns.ctm') as string, customRender: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value },
            { dataIndex: "ctmBrand", title: this.$t('regular.columns.ctmBrandTarget') as string },
            { dataIndex: "ctmPriceGap", title: this.$t('regular.columns.ctmPriceGap') as string },
            { dataIndex: "minRetailPrice", title: this.$t('regular.columns.minRetailPrice') as string },
            { dataIndex: "maxRetailPrice", title: this.$t('regular.columns.maxRetailPrice') as string },
            { dataIndex: "omnichannelStrategy", title: this.$t('regular.columns.omnichannelStrategy') as string },
            { dataIndex: "omnichannelFixedGapType", title: this.$t('regular.columns.omnichannelFixedGapType') as string },
            { dataIndex: "omnichannelGap", title: this.$t('regular.columns.omnichannelGap') as string },
            { dataIndex: "omnichannelApplyCompetitorPrices", title: this.$t('regular.columns.omnichannelApplyCompetitorPrices') as string },
            { dataIndex: "omnichannelMinProfitabilityLimit", title: this.$t('regular.columns.omnichannelMinProfitabilityLimit') as string },
            { dataIndex: "omnichannelBaseChannelPrice", title: this.$t('regular.columns.omnichannelBaseChannelPrice') as string },
            { dataIndex: "keyProduct1", title: this.$t('regular.columns.kht1') as string },
            { dataIndex: "keyProduct2", title: this.$t('regular.columns.kht2') as string },
            { dataIndex: "keyProduct3", title: this.$t('regular.columns.kht3') as string },
            { dataIndex: "keyProduct4", title: this.$t('regular.columns.kht4') as string },
            { dataIndex: "keyProduct5", title: this.$t('regular.columns.kht5') as string },
            { dataIndex: "segment", title: this.$t('regular.columns.segment') as string },
            { dataIndex: "skuLine", title: this.$t('regular.columns.skuPriceLine') as string },
            { dataIndex: "purchasePrice", title: this.$t('regular.columns.purchasePrice') as string },
            { dataIndex: "promoPurchasePrice", title: this.$t('regular.columns.purchasePriceForPromo') as string },
            { dataIndex: "avgRegularPrice", title: this.$t('regular.columns.avgRegularPrice') as string },
            { dataIndex: "avgCashPrice", title: this.$t('regular.columns.avgCashierPrice') as string },
            { dataIndex: "avgCheckPrice", title: this.$t('regular.columns.avgReceiptPrice') as string },
            { dataIndex: "regularPrice", title: this.$t('regular.columns.currentRegularPrice') as string },
            { dataIndex: "marginLastPrice", title: this.$t('regular.columns.lastPriceMargin') as string },
            { dataIndex: "minCompetitorPrice", title: this.$t('regular.columns.minCompetitorPrice') as string },
            { dataIndex: "minCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "minCompetitorCode", title: this.$t('regular.columns.competitorCode') as string },
            { dataIndex: "maxCompetitorPrice", title: this.$t('regular.columns.maxCompetitorPrice') as string },
            { dataIndex: "maxCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "maxCompetitorCode", title: this.$t('regular.columns.competitorCode') as string },
            { dataIndex: "avgCompetitorPrice", title: this.$t('regular.columns.avgCompetitorPrice') as string },
            { dataIndex: "lastCompetitorPrice", title: this.$t('regular.columns.lastCompetitorPrice') as string },
            { dataIndex: "minPromoCompetitorPrice", title: this.$t('regular.columns.minPromoCompetitorPrice') as string },
            { dataIndex: "minPromoCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "minPromoCompetitorCode", title: this.$t('regular.columns.competitorCode') as string },
            { dataIndex: "maxPromoCompetitorPrice", title: this.$t('regular.columns.maxPromoCompetitorPrice') as string },
            { dataIndex: "maxPromoCompetitorName", title: this.$t('regular.columns.competitor') as string },
            { dataIndex: "maxPromoCompetitorCode", title: this.$t('regular.columns.competitorCode') as string },
            { dataIndex: "medianPromoCompetitorPrice", title: this.$t('regular.columns.medianPromoCompPrice') as string },
            { dataIndex: "lastPromoCompetitorPrice", title: this.$t('regular.columns.lastPromoCompetitorPrice') as string },
            { dataIndex: "pi", title: "PI" },
            { dataIndex: "promoPi", title: this.$t('regular.columns.promoPi') as string },
            { dataIndex: "actualSales", title: this.$t('regular.columns.actualSalesUnitsFull') as string },
            { dataIndex: "actualRevenue", title: this.$t('regular.columns.actualRevenueFull') as string },
            { dataIndex: "actualMargin", title: this.$t('regular.columns.actualMarginFull') as string },
            { dataIndex: "actualMarginPercent", title: this.$t('regular.columns.actualMarginPercentFull') as string },
            { dataIndex: "comparableSales", title: this.$t('regular.columns.compSalesUnitsFull') as string },
            { dataIndex: "comparableRevenue", title: this.$t('regular.columns.compRevenueFull') as string },
            { dataIndex: "comparableMargin", title: this.$t('regular.columns.compMarginFull') as string },
            { dataIndex: "comparableMarginPc", title: this.$t('regular.columns.compMarginPercentFull') as string },
            { dataIndex: "newPromoPrice", title: this.$t('regular.columns.promoPriceWithComp') as string },
            { dataIndex: "correctedPromoPrice", title: this.$t('regular.columns.correctedPromoPrice') as string },
            { dataIndex: "newMarginPc", title: this.$t('regular.columns.newMargin') as string },
            { dataIndex: "newPI", title: this.$t('regular.columns.newPi') as string },
            { dataIndex: "deltaDiffPrice", title: this.$t('regular.columns.deltaPrice') as string },
            { dataIndex: "priceDiffPc", title: this.$t('regular.columns.pctPriceChange') as string },
            { dataIndex: "marginDiff", title: this.$t('regular.columns.marginChangePp') as string },
            { dataIndex: "changedPI", title: this.$t('regular.columns.piChangePp') as string },
            { dataIndex: "discountDepth", title: this.$t('regular.columns.discountDepthWithComp') as string },
            { dataIndex: "discountDuration", title: this.$t('regular.columns.discountLength') as string },
            { dataIndex: "exitSegment", title: this.$t('regular.columns.segmentExit') as string },
            { dataIndex: "coeffElasticity", title: this.$t('regular.columns.elasticityCoeff') as string },
            { dataIndex: "promoCoeffElasticity", title: this.$t('regular.columns.promoElasticity') as string },
            { dataIndex: "salesForecast", title: this.$t('regular.columns.forecastSalesUnits') as string },
            { dataIndex: "revenueForecast", title: this.$t('regular.columns.forecastRevenue') as string },
            { dataIndex: "marginForecast", title: this.$t('regular.columns.forecastMargin') as string },
            { dataIndex: "marginForecastPc", title: this.$t('regular.columns.forecastMarginPercent') as string },
            { dataIndex: "changeSales", title: this.$t('regular.columns.changeSalesUnits') as string },
            { dataIndex: "changeRevenue", title: this.$t('regular.columns.changeRevenue') as string },
            { dataIndex: "changeMargin", title: this.$t('regular.columns.changeMargin') as string },
            { dataIndex: "salesDiffPc", title: this.$t('regular.columns.pctChangeSales') as string },
            { dataIndex: "revenueDiffPc", title: this.$t('regular.columns.pctChangeRevenue') as string },
            { dataIndex: "marginDiffPc", title: this.$t('regular.columns.pctChangeMargin') as string },
            { dataIndex: "marginDiffSecond", title: this.$t('regular.columns.marginChangePp') as string },
            { dataIndex: "individualPromoType", title: this.$t('regular.columns.promoType') as string },
            { dataIndex: "individualPromoLift", title: this.$t('regular.columns.regularPriceAdjustment') as string },
            { dataIndex: "individualPriceOptStrategy", title: this.$t('regular.columns.priceOptStrategy') as string },
            { dataIndex: "individualPriceIncreaseLimit", title: this.$t('regular.columns.increaseLimit') as string },
            { dataIndex: "individualPeriodPriceIncreaseLimit", title: this.$t('regular.columns.periodIncreaseLimitPercent') as string },
            { dataIndex: "individualPeriod", title: this.$t('regular.columns.period') as string },
            { dataIndex: "individualMarginalProfit", title: this.$t('regular.columns.minSkuProfitFull') as string },
            { dataIndex: "individualKviStrategy", title: this.$t('regular.columns.kviStrategy') as string },
            { dataIndex: "individualPercentCorrection", title: this.$t('regular.columns.adjustment') as string },
            { dataIndex: "individualNewProductPriceStrategy", title: this.$t('regular.columns.newProductPricingStrategy') as string },
            { dataIndex: "individualPriceGapPercent", title: this.$t('regular.columns.priceGapPercent') as string },
            { dataIndex: "comment", title: this.$t('regular.columns.comment') as string },
        ];

        sortedColumns: any[] = [];
        tableColumnsOrder: string[] = [];

        selectTaskIdForDetailTable: number[] = [];
        taskIdOptionsForDetailTable: Array<SelectBox<number>> = [];

        filterValues = {
            groups: ["all"],
            categories: ["all"],
            subcategories: ["all"],
            storeFormat: ["all"],
            storeRegion: ["all"],
            storeCluster: ["all"],
        };

        filterOptions: IFilterOptions = {
            groups: [],
            categories: [],
            subcategories: [],
            storeFormat: [],
            storeRegion: [],
            storeCluster: [],
        };

        historyItemsClasses: any = {
            'price-gray': [
                this.$t('regular.tooltips.mrcEqualsMinRetailNoRound') as string,
                this.$t('regular.tooltips.mrcEqualsMaxRetailNoRound') as string,
                this.$t('regular.tooltips.mrcUnfixedAfterProfMinNoRound') as string,
                this.$t('regular.tooltips.mrcUnfixedAfterProfMaxNoRound') as string,
                this.$t('regular.tooltips.mrcAfterProfCheckMinNoRound') as string,
                this.$t('regular.tooltips.mrcAfterProfCheckMaxNoRound') as string,
                this.$t('regular.tooltips.mrcEqualsMinRetail') as string,
                this.$t('regular.tooltips.mrcEqualsMaxRetail') as string,
                this.$t('regular.tooltips.mrcUnfixedAfterProfMin') as string,
                this.$t('regular.tooltips.mrcUnfixedAfterProfMax') as string,
            ],
            'price-orange': [
                this.$t('regular.tooltips.cpoPriceAfterLimit') as string,
                this.$t('regular.tooltips.priceInLineCheckAfterLimit') as string,
                this.$t('regular.tooltips.priceInXyzAfterLimit') as string,
                this.$t('regular.tooltips.priceAfterIncreaseLimit') as string,
            ],
            'price-violet': [
                this.$t('regular.tooltips.priceAfterPeriodLimitAndMinProfit') as string,
                this.$t('regular.tooltips.priceExceedsPeriodLimit') as string,
            ],
            'price-light-green': [
                this.$t('regular.tooltips.correlatedPriceRounded') as string,
            ],
        }

        selectGroupNameForDetailTable: string[] = [];
        groupNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectCategoryNameForDetailTable: string[] = [];
        categoryNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectSubcategoryNamesForDetailTable: string[] = [];
        subcategoryNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectFormatNameForDetailTable: string[] = [];
        formatNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectRegionNameForDetailTable: string[] = [];
        regionNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectClusterNameForDetailTable: string[] = [];
        clusterNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectSegmentNameForDetailTable: string[] = [];
        segmentNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectInternalCodeForDetailTable: string[] = [];
        internalCodesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectSkuNameForDetailTable: string[] = [];
        skuNamesOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectEventTriggerForDetailTable: SelectBox<number> = this.defaultFilterValue;
        selectKVIForDetailTable: SelectBox<number> = this.defaultFilterValue;
        kviOptions: Array<SelectBox<number>> = [
            {value: -1, label: this.$t('regular.common.all') as string},
            {value: 1, label: 'KVI'},
            {value: 0, label: this.$t('regular.columns.notKvi') as string},
        ];
        selectCTMForDetailTable: SelectBox<number> = this.defaultFilterValue;
        ctmOptionsForDetailTable: Array<SelectBox<number>> = [
            {value: -1, label: this.$t('regular.common.all') as string},
            {value: 1, label: 'CTM'},
            {value: 0, label: this.$t('regular.columns.notCtm') as string},
        ];
        selectCtmBrandForDetailTable: string[] = [];
        ctmBrandsOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectCtmPriceGapForDetailTable: number[] = [];
        ctmPriceGapOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinRetailPriceForDetailTable: number[] = [];
        minRetailPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMaxRetailPriceForDetailTable: number[] = [];
        maxRetailPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectKeyProduct1ForDetailTable: string[] = [];
        keyProduct1OptionsForDetailTable: Array<SelectBox<string>> = [];

        selectKeyProduct2ForDetailTable: string[] = [];
        keyProduct2OptionsForDetailTable: Array<SelectBox<string>> = [];

        selectRecipeAttributeForDetailTable: string[] = [];
        recipeAttributeOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectTreatmentAttributeForDetailTable: number[] = [];
        treatmentAttributeOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectVitalMedicineForDetailTable: SelectBox<number> = this.defaultFilterValue;
        vitalMedicinesOptionsForDetailTable: Array<SelectBox<number>> = [
            {value: -1, label: this.$t('regular.common.all') as string},
            {value: 1, label: this.$t('regular.common.yes') as string},
            {value: 0, label: this.$t('regular.common.no') as string},
        ];

        selectProducerPriceForDetailTable: number[] = [];
        producerPricesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectExtraChargePcForDetailTable: number[] = [];
        extraChargePcsOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRegistrationPriceForDetailTable: number[] = [];
        registrationPricesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSegmentPriceForDetailTable: ReportDetailSegments[] = [];
        segmentPriceOptionsForDetailTable: Array<SelectBox<ReportDetailSegments>> = [];

        selectSkuLineForDetailTable: string[] = [];
        skuLineOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectPurchasePriceForDetailTable: number[] = [];
        purchasePriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectPromoPurchasePriceForDetailTable: number[] = [];
        promoPurchasePriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectAvgRegularPriceForDetailTable: number[] = [];
        avgRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectAvgCashPriceForDetailTable: number[] = [];
        avgCashPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectAvgCheckPriceForDetailTable: number[] = [];
        avgCheckPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRegularPriceForDetailTable: number[] = [];
        regularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginLastPriceForDetailTable: number[] = [];
        marginLastPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinCompetitorPriceForDetailTable: number[] = [];
        minCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinCompetitorNameForDetailTable: string[] = [];
        minCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMaxCompetitorPriceForDetailTable: number[] = [];
        maxCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMaxCompetitorNameForDetailTable: string[] = [];
        maxCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectAvgCompetitorPriceForDetailTable: number[] = [];
        avgCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectLastCompetitorPriceForDetailTable: number[] = [];
        lastCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinPromoCompetitorPriceForDetailTable: number[] = [];
        minPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMinPromoCompetitorNameForDetailTable: string[] = [];
        minPromoCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMaxPromoCompetitorPriceForDetailTable: number[] = [];
        maxPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMaxPromoCompetitorNameForDetailTable: string[] = [];
        maxPromoCompetitorNameOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectMedianPromoCompetitorPriceForDetailTable: number[] = [];
        medianPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectLastPromoCompetitorPriceForDetailTable: number[] = [];
        lastPromoCompetitorPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectPiForDetailTable: number[] = [];
        piOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectActualSalesForDetailTable: number[] = [];
        actualSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectActualRevenueForDetailTable: number[] = [];
        actualRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectActualMarginForDetailTable: number[] = [];
        actualMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectActualMarginPercentForDetailTable: number[] = [];
        actualMarginPercentOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectComparableSalesForDetailTable: number[] = [];
        comparableSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectComparableRevenueForDetailTable: number[] = [];
        comparableRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectComparableMarginForDetailTable: number[] = [];
        comparableMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectComparableMarginPcForDetailTable: number[] = [];
        comparableMarginPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectNewPriceForDetailTable: number[] = [];
        newPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectNewPromoPriceForDetailTable: number[] = [];
        newPromoPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectCorrectedRegularPriceForDetailTable: number[] = [];
        correctedRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectCorrectedPromoPriceForDetailTable: number[] = [];
        correctedPromoPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectNewMarginPcForDetailTable: number[] = [];
        newMarginPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectNewPIForDetailTable: number[] = [];
        newPIOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectDeltaDiffPriceForDetailTable: Array<number | string> = [];
        deltaDiffPriceOptionsForDetailTable: Array<SelectBox<number | string>> = [];

        selectPriceDiffPcForDetailTable: number[] = [];
        priceDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffForDetailTable: number[] = [];
        marginDiffOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangedPIForDetailTable: number[] = [];
        changedPIPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectDiscountDepthForDetailTable: number[] = [];
        discountDepthOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectDiscountDurationForDetailTable: number[] = [];
        discountDurationOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectExitSegmentForDetailTable: string[] = [];
        exitSegmentOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectCoeffElasticityForDetailTable: number[] = [];
        coeffElasticityPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectPromoCoeffElasticityForDetailTable: number[] = [];
        promoCoeffElasticityPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSalesForecastForDetailTable: number[] = [];
        salesForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRevenueForecastForDetailTable: number[] = [];
        revenueForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginForecastForDetailTable: number[] = [];
        marginForecastOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginForecastPcForDetailTable: number[] = [];
        marginForecastPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeSalesForDetailTable: number[] = [];
        changeSalesOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeRevenueForDetailTable: number[] = [];
        changeRevenueOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeMarginForDetailTable: number[] = [];
        changeMarginOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSalesDiffPcForDetailTable: number[] = [];
        salesDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRevenueDiffPcForDetailTable: number[] = [];
        revenueDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffPcForDetailTable: number[] = [];
        marginDiffPcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffSecondForDetailTable: number[] = [];
        marginDiffSecondOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualPromoTypeForDetailTable: string[] = [];
        individualPromoTypeOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualPromoLiftForDetailTable: number[] = [];
        individualPromoLiftOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSalesForecastByRegularPriceForDetailTable: number[] = [];
        salesForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRevenueForecastByRegularPriceForDetailTable: number[] = [];
        revenueForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginForecastByRegularPriceForDetailTable: number[] = [];
        marginForecastByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginForecastByRegularPricePcForDetailTable: number[] = [];
        marginForecastByRegularPricePcOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeSalesByRegularPriceForDetailTable: number[] = [];
        changeSalesByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeRevenueByRegularPriceForDetailTable: number[] = [];
        changeRevenueByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectChangeMarginByRegularPriceForDetailTable: number[] = [];
        changeMarginByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectSalesDiffPcByRegularPriceForDetailTable: number[] = [];
        salesDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectRevenueDiffPcByRegularPriceForDetailTable: number[] = [];
        revenueDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffPcByRegularPriceForDetailTable: number[] = [];
        marginDiffPcByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectMarginDiffSecondByRegularPriceForDetailTable: number[] = [];
        marginDiffSecondByRegularPriceOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualPriceOptStrategyForDetailTable: string[] = [];
        individualPriceOptStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualPriceIncreaseLimitForDetailTable: number[] = [];
        individualPriceIncreaseLimitOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualPeriodPriceIncreaseLimitForDetailTable: number[] = [];
        individualPeriodPriceIncreaseLimitOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualPeriodForDetailTable: string[] = [];
        individualPeriodOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualMarginalProfitForDetailTable: number[] = [];
        individualMarginalProfitOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectIndividualKviStrategyForDetailTable: string[] = [];
        individualKviStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualPercentCorrectionForDetailTable: string[] = [];
        individualPercentCorrectionOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualNewProductPriceStrategyForDetailTable: string[] = [];
        individualNewProductPriceStrategyOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIndividualPriceGapPercentForDetailTable: number[] = [];
        individualPriceGapPercentOptionsForDetailTable: Array<SelectBox<number>> = [];

        selectBatchNumberForDetailTable: string[] = [];
        batchNumberOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectApprovedByFioForDetailTable: string[] = [];
        approvedByFioOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectIsApprovedForDetailTable: string[] = [];
        isApprovedOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectProductVerticalLineForDetailTable: string[] = [];
        productVerticalLineOptionsForDetailTable: Array<SelectBox<string>> = [];

        selectSalePointCodesForDetailTable: string[] = [];
        salePointCodeOptionsForDetailTable: Array<SelectBox<string>> = [];

        grossIncomeByLastPriceTableHeader: TableHeaders[] = [
            {key: 'sumMarginForecastByRegularPrice', label: this.$t('regular.columns.forecastMarginCurrentPrices') as string},
            {key: 'forecastMargin', label: this.$t('regular.columns.forecastMarginNewPrices') as string},
            {key: 'changeForecastMarginByRegularPrice', label: this.$t('regular.columns.difference') as string},
            {key: 'changeForecastMarginPcByRegularPrice', label: this.$t('regular.columns.differencePercent') as string},
            {key: 'sumMarginForecastPcByRegularPrice', label: this.$t('regular.columns.forecastMarginCurrentPricesPercent') as string},
            {key: 'forecastMarginPc', label: this.$t('regular.columns.forecastMarginNewPricesPercent') as string},
            {key: 'changeMarginByRegularPricePp', label: this.$t('regular.columns.differencePp') as string},
        ];

        salesByLastPriceTableHeader: TableHeaders[] = [
            {key: 'sumSalesForecastByRegularPrice', label: this.$t('regular.columns.forecastSalesCurrentPrices') as string},
            {key: 'forecastAmount', label: this.$t('regular.columns.forecastSalesNewPrices') as string},
            {key: 'changeForecastSalesByRegularPrice', label: this.$t('regular.columns.differenceUnits') as string},
            {key: 'changeForecastSalesPcByRegularPrice', label: this.$t('regular.columns.differencePercent') as string},
        ];

        revenueByLastPriceTableHeader: TableHeaders[] = [
            {key: 'sumRevenueForecastByRegularPrice', label: this.$t('regular.columns.forecastRevenueCurrentPrices') as string},
            {key: 'forecastRevenue', label: this.$t('regular.columns.forecastRevenueNewPrices') as string},
            {key: 'changeForecastRevenueByRegularPrice', label: this.$t('regular.columns.difference') as string},
            {key: 'changeForecastRevenuePcByRegularPrice', label: this.$t('regular.columns.differencePercent') as string},
        ];
        generalPromoResultTableHeader2: TableHeaders[] = [
            {key: 'realSalesAmount', label: this.$t('regular.columns.actualSalesUnits') as string},
            {key: 'forecastAmount', label: this.$t('regular.columns.forecastSalesUnitsLc') as string},
            {key: 'amountChange', label: this.$t('regular.columns.changeUnits') as string},
            {key: 'amountChangePc', label: this.$t('regular.columns.changePercent') as string},
        ];
        generalPromoResultTableHeader3: TableHeaders[] = [
            {key: 'revenueReal', label: this.$t('regular.columns.actualRevenue') as string},
            {key: 'forecastRevenue', label: this.$t('regular.columns.forecastRevenueLc') as string},
            {key: 'revenueChange', label: this.$t('regular.columns.change') as string},
            {key: 'revenueChangePc', label: this.$t('regular.columns.changePercent') as string},
        ];
        generalPromoResultTableHeader4: TableHeaders[] = [
            {key: 'marginReal', label: this.$t('regular.columns.actualMargin') as string},
            {key: 'forecastMargin', label: this.$t('regular.columns.forecastMarginLc') as string},
            {key: 'marginChange', label: this.$t('regular.columns.change') as string},
            {key: 'marginChangePc', label: this.$t('regular.columns.changePercent') as string},
            {key: 'marginRealPc', label: this.$t('regular.columns.actualMarginPercent') as string},
            {key: 'forecastMarginPc', label: this.$t('regular.columns.forecastMarginPercentLc') as string},
            {key: 'marginChangePp', label: this.$t('regular.columns.changePp') as string},
        ];
        generalResultChanges1: TableHeaders[] = [
            {key: 'skuCountInGroup', label: this.$t('regular.columns.skuCount') as string},
            {key: 'priceChangedCount', label: this.$t('regular.columns.priceChangesCount') as string},
            {key: 'avgPcPriceChange', label: this.$t('regular.columns.pctPriceChanges') as string},
        ];
        generalResultChanges2: TableHeaders[] = [
            {key: 'priceIncreaseCount', label: this.$t('regular.columns.priceIncreasesCount') as string},
            {key: 'avgPcIncreasePrice', label: this.$t('regular.columns.pctPriceIncreases') as string},
            {key: 'priceDecreaseCount', label: this.$t('regular.columns.priceDecreasesCount') as string},
        ];
        generalResultChanges3: TableHeaders[] = [
            {key: 'avgPcPriceDecrease', label: this.$t('regular.columns.pctPriceDecreases') as string},
            {key: 'settlementDate', label: this.$t('regular.columns.calcDate') as string},
            {key: 'forecastDate', label: this.$t('regular.columns.forecastDate') as string},
        ];
        generalPromoResultChanges1: TableHeaders[] = [
            {key: 'skuCountInGroup', label: this.$t('regular.columns.skuCount') as string},
            {key: 'priceChangedCount', label: this.$t('regular.columns.priceChangesCount') as string},
            {key: 'avgPcPriceChange', label: this.$t('regular.columns.pctPriceChanges') as string},
        ];
        generalPromoResultChanges2: TableHeaders[] = [
            {key: 'priceIncreaseCount', label: this.$t('regular.columns.priceIncreasesCount') as string},
            {key: 'avgPcIncreasePrice', label: this.$t('regular.columns.pctPriceIncreases') as string},
            {key: 'priceDecreaseCount', label: this.$t('regular.columns.priceDecreasesCount') as string},
        ];
        generalPromoResultChanges3: TableHeaders[] = [
            {key: 'avgPcPriceDecrease', label: this.$t('regular.columns.pctPriceDecreases') as string},
            {key: 'settlementDate', label: this.$t('regular.columns.calcDate') as string},
            {key: 'forecastDate', label: this.$t('regular.columns.forecastDate') as string},
        ];
        generalResultTableHeader2: TableHeaders[] = [
            {key: 'comparableSalesAmount', label: this.$t('regular.columns.compSalesUnits') as string},
            {key: 'forecastAmount', label: this.$t('regular.columns.forecastSalesNewPrices') as string},
            {key: 'amountChange', label: this.$t('regular.columns.changeUnits') as string},
            {key: 'amountChangePc', label: this.$t('regular.columns.changePercent') as string},
        ];

        generalResultTableHeader3: TableHeaders[] = [
            {key: 'revenueComparable', label: this.$t('regular.columns.compRevenue') as string},
            {key: 'forecastRevenue', label: this.$t('regular.columns.forecastRevenueNewPrices') as string},
            {key: 'revenueChange', label: this.$t('regular.columns.change') as string},
            {key: 'revenueChangePc', label: this.$t('regular.columns.changePercent') as string},
        ];

        generalResultTableHeader4: TableHeaders[] = [
            {key: 'marginComparable', label: this.$t('regular.columns.compMargin') as string},
            {key: 'forecastMargin', label: this.$t('regular.columns.forecastMarginNewPrices') as string},
            {key: 'marginChange', label: this.$t('regular.columns.change') as string},
            {key: 'marginChangePc', label: this.$t('regular.columns.changePercent') as string},
            {key: 'marginComparablePc', label: this.$t('regular.columns.compMarginPercent') as string},
            {key: 'forecastMarginPc', label: this.$t('regular.columns.forecastMarginNewPricesPercent') as string},
            {key: 'marginChangePp', label: this.$t('regular.columns.changePp') as string},
        ];

        regularDetailReport: any[] = []; // all columns will be added dynamically

        promoDetailReport: any[] = [];

        promoDetailReportStaticFields: any[] = [
            {
                key: 'checkboxes',
                dataIndex: 'checkboxes',
                scopedSlots: {
                    title: 'commonCheckbox',
                    customRender: 'rowCheckbox',
                },
                fixed: 'left',
                width: 50,
                align: 'center',
            },
            {
                dataIndex: 'internalCode',
                slots: { title: 'internalCodeColumnTitle' }, // dataIndex + 'ColumnTitle'
                slotColumnTitleData: {
                    text: this.$t('regular.columns.internalCode') as string,
                },
                fixed: 'left',
                sorter: true,
                filterOptionsKey: 'internalCode',
                filterModel: 'internalCode',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('internalCode') },
                scopedSlots: {
                    customRender: 'internalCode',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 170,
                ellipsis: true,
            },
            {
                dataIndex: 'skuName',
                slots: { title: 'skuNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.skuName') as string,
                },
                stickyColumn: true,
                sorter: true,
                fixed: 'left',
                filterOptionsKey: 'skuName',
                filterModel: 'skuName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('skuName') },
                scopedSlots: {
                    customRender: 'skuName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 340,
            },
            {
                dataIndex: 'taskId',
                slots: { title: 'taskIdColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.reportNo') as string,
                },
                sorter: true,
                filterOptionsKey: 'taskId',
                filterModel: 'taskId',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('taskId') },
                scopedSlots: {
                    customRender: 'taskId',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 156,
                ellipsis: true,
            },
            {
                dataIndex: 'isApproved',
                title: this.$t('regular.columns.approval') as string,
                filterOptionsKey: 'isApproved',
                filterModel: 'isApproved',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('isApproved') },
                scopedSlots: {
                  customRender: 'isApproved',
                  filterDropdown: "filterCheckboxes",
                  filterIcon: "filterIcon",
                },
                width: 150,
            },
            {
                dataIndex: 'approvedByFio',
                title: this.$t('regular.columns.approvedBy') as string,
                filterOptionsKey: 'approvedByFio',
                filterModel: 'approvedByFio',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('approvedByFio') },
                scopedSlots: {
                    customRender: 'approvedByFio',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 150,
                ellipsis: true,
            },
            {
                dataIndex: 'groupName',
                slots: { title: 'groupNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.productGroup') as string,
                },
                sorter: true,
                filterOptionsKey: 'groupName',
                filterModel: 'groupName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('groupName') },
                scopedSlots: {
                    customRender: 'groupName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'categoryName',
                slots: { title: 'categoryNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.productCategory') as string,
                },
                sorter: true,
                filterOptionsKey: 'categoryName',
                filterModel: 'categoryName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('categoryName') },
                scopedSlots: {
                    customRender: 'categoryName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'subCategoryName',
                slots: { title: 'subCategoryNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.productSubcategory') as string,
                },
                sorter: true,
                filterOptionsKey: 'subCategoryName',
                filterModel: 'subCategoryName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('subCategoryName') },
                scopedSlots: {
                    customRender: 'subCategoryName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                onFilter: () => true,
                ellipsis: true,
            },
            {
                dataIndex: 'formatName',
                slots: { title: 'formatNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.formatChannel') as string,
                },
                sorter: true,
                filterOptionsKey: 'formatName',
                filterModel: 'formatName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('formatName') },
                scopedSlots: {
                    customRender: 'formatName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'regionName',
                slots: { title: 'regionNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.storeRegion') as string,
                },
                sorter: true,
                filterOptionsKey: 'regionName',
                filterModel: 'regionName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('regionName') },
                scopedSlots: {
                    customRender: 'regionName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'clusterName',
                slots: { title: 'clusterNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.storeCluster') as string,
                },
                sorter: true,
                filterOptionsKey: 'clusterName',
                filterModel: 'clusterName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('clusterName') },
                scopedSlots: {
                    customRender: 'clusterName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
            {
                dataIndex: 'productSegmentName',
                slots: { title: 'productSegmentNameColumnTitle' },
                slotColumnTitleData: {
                    text: this.$t('regular.columns.productSegment') as string,
                },
                sorter: true,
                filterOptionsKey: 'productSegmentName',
                filterModel: 'productSegmentName',
                showRange: false,
                onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('productSegmentName') },
                scopedSlots: {
                    customRender: 'productSegmentName',
                    filterDropdown: "filterCheckboxes",
                    filterIcon: "filterIcon",
                },
                width: 200,
                ellipsis: true,
            },
        ];

        salesDetailReport: any = [];

        salesDetailReportStaticFields: any[] = [
        {
            key: 'checkboxes',
            scopedSlots: {
                title: 'commonCheckbox',
                customRender: 'rowCheckbox',
            },
            fixed: 'left',
            width: 50,
            align: 'center',
        },
        {
            dataIndex: 'internalCode',
            slots: { title: 'internalCodeColumnTitle' }, // dataIndex + 'ColumnTitle'
            slotColumnTitleData: {
                text: this.$t('regular.columns.internalCode') as string,
            },
            fixed: 'left',
            sorter: true,
            filterOptionsKey: 'internalCode',
            filterModel: 'internalCode',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('internalCode') },
            scopedSlots: {
                customRender: 'internalCode',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 170,
            ellipsis: true,
        },
        {
            dataIndex: 'skuName',
            slots: { title: 'skuNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.skuName') as string,
            },
            stickyColumn: true,
            sorter: true,
            fixed: 'left',
            filterOptionsKey: 'skuName',
            filterModel: 'skuName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('skuName') },
            scopedSlots: {
                customRender: 'skuName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 340,
        },
        {
            dataIndex: 'taskId',
            slots: { title: 'taskIdColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.reportNo') as string,
            },
            sorter: true,
            filterOptionsKey: 'taskId',
            filterModel: 'taskId',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('taskId') },
            scopedSlots: {
                customRender: 'taskId',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 156,
            ellipsis: true,
        },
        {
            dataIndex: 'isApproved',
            title: this.$t('regular.columns.approval') as string,
            filterOptionsKey: 'isApproved',
            filterModel: 'isApproved',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('isApproved') },
            scopedSlots: {
                customRender: 'isApproved',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 150,
        },
        {
            dataIndex: 'approvedByFio',
            title: this.$t('regular.columns.approvedBy') as string,
            filterOptionsKey: 'approvedByFio',
            filterModel: 'approvedByFio',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('approvedByFio') },
            scopedSlots: {
                customRender: 'approvedByFio',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 150,
            ellipsis: true,
        },
        {
            dataIndex: 'groupName',
            slots: { title: 'groupNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.productGroup') as string,
            },
            sorter: true,
            filterOptionsKey: 'groupName',
            filterModel: 'groupName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('groupName') },
            scopedSlots: {
                customRender: 'groupName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'categoryName',
            slots: { title: 'categoryNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.productCategory') as string,
            },
            sorter: true,
            filterOptionsKey: 'categoryName',
            filterModel: 'categoryName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('categoryName') },
            scopedSlots: {
                customRender: 'categoryName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'subCategoryName',
            slots: { title: 'subCategoryNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.productSubcategory') as string,
            },
            sorter: true,
            filterOptionsKey: 'subCategoryName',
            filterModel: 'subCategoryName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('subCategoryName') },
            scopedSlots: {
                customRender: 'subCategoryName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            onFilter: () => true,
            ellipsis: true,
        },
        {
            dataIndex: 'formatName',
            slots: { title: 'formatNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.formatChannel') as string,
            },
            sorter: true,
            filterOptionsKey: 'formatName',
            filterModel: 'formatName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('formatName') },
            scopedSlots: {
                customRender: 'formatName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'regionName',
            slots: { title: 'regionNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.storeRegion') as string,
            },
            sorter: true,
            filterOptionsKey: 'regionName',
            filterModel: 'regionName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('regionName') },
            scopedSlots: {
                customRender: 'regionName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'clusterName',
            slots: { title: 'clusterNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.storeCluster') as string,
            },
            sorter: true,
            filterOptionsKey: 'clusterName',
            filterModel: 'clusterName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('clusterName') },
            scopedSlots: {
                customRender: 'clusterName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'productSegmentName',
            slots: { title: 'productSegmentNameColumnTitle' },
            slotColumnTitleData: {
                text: this.$t('regular.columns.productSegment') as string,
            },
            sorter: true,
            filterOptionsKey: 'productSegmentName',
            filterModel: 'productSegmentName',
            showRange: false,
            onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('productSegmentName') },
            scopedSlots: {
                customRender: 'productSegmentName',
                filterDropdown: "filterCheckboxes",
                filterIcon: "filterIcon",
            },
            width: 200,
            ellipsis: true,
        },
    ];

        filterDropdownsState: any = {};
        filterDropdownsRange: any = {
            from: {},
            to: {},
        };
        tableFilterOptions: any = {};
        filterAllCheckboxCheckedState: any = {};

        pagination: any = {
            current: 1,
            pageSize: 20,
            total: 0,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
        }

        packageRegularFullHeaderReport: any[] = [
            {dataIndex: 'taskId', title: '№', fixed: 'left', stickyColumn: true, width: 100},
            {dataIndex: 'fileResult', title: this.$t('regular.columns.actions') as string, scopedSlots: { customRender: 'fileResult' }, fixed: 'left', stickyColumn: true, ellipsis: true, width: 200},
            {dataIndex: 'groupName', title: this.$t('regular.columns.productGroup') as string, scopedSlots: { customRender: 'groupName' }, width: 200, ellipsis: true},
            {dataIndex: 'categoryName', title: this.$t('regular.columns.productCategory') as string, scopedSlots: { customRender: 'categoryName' }, width: 200, ellipsis: true},
            {dataIndex: 'subCategoryName', title: this.$t('regular.columns.productSubcategory') as string, scopedSlots: { customRender: 'subCategoryName' }, width: 200, ellipsis: true},
            {dataIndex: 'formatName', title: this.$t('regular.columns.formatChannel') as string, scopedSlots: { customRender: 'formatName' }, width: 200, ellipsis: true},
            {dataIndex: 'regionName', title: this.$t('regular.columns.storeRegion') as string, scopedSlots: { customRender: 'regionName' }, width: 200, ellipsis: true},
            {dataIndex: 'clusterName', title: this.$t('regular.columns.storeCluster') as string, scopedSlots: { customRender: 'clusterName' }, width: 200, ellipsis: true},
            {dataIndex: 'scenarioName', title: this.$t('regular.columns.scenarioName') as string, scopedSlots: { customRender: 'scenarioName' }, width: 200, ellipsis: true},
            {dataIndex: 'sumSalesForecastByRegularPrice', title: this.$t('regular.columns.forecastSalesCurrentPrices') as string, scopedSlots: { customRender: 'sumSalesForecastByRegularPrice' }, width: 100},
            {dataIndex: 'forecastAmount', title: this.$t('regular.columns.forecastSalesNewPrices') as string, scopedSlots: { customRender: 'forecastAmount' }, width: 100},
            {dataIndex: 'changeForecastSalesByRegularPrice', title: this.$t('regular.columns.differenceUnits') as string, scopedSlots: { customRender: 'changeForecastSalesByRegularPrice' }, width: 100},
            {dataIndex: 'changeForecastSalesPcByRegularPrice', title: this.$t('regular.columns.differencePercent') as string, scopedSlots: { customRender: 'changeForecastSalesPcByRegularPrice' }, width: 100},
            {dataIndex: 'sumRevenueForecastByRegularPrice', title: this.$t('regular.columns.forecastRevenueCurrentPrices') as string, scopedSlots: { customRender: 'sumRevenueForecastByRegularPrice' }, width: 100},
            {dataIndex: 'forecastRevenue', title: this.$t('regular.columns.forecastRevenueNewPrices') as string, scopedSlots: { customRender: 'forecastRevenue' }, width: 100},
            {dataIndex: 'changeForecastRevenueByRegularPrice', title: this.$t('regular.columns.difference') as string, scopedSlots: { customRender: 'changeForecastRevenueByRegularPrice' }, width: 100},
            {dataIndex: 'changeForecastRevenuePcByRegularPrice', title: this.$t('regular.columns.differencePercent') as string, scopedSlots: { customRender: 'changeForecastRevenuePcByRegularPrice' }, width: 100},
            {dataIndex: 'sumMarginForecastByRegularPrice', title: this.$t('regular.columns.forecastMarginCurrentPrices') as string, scopedSlots: { customRender: 'sumMarginForecastByRegularPrice' }, width: 100},
            {dataIndex: 'forecastMargin', title: this.$t('regular.columns.forecastMarginNewPrices') as string, scopedSlots: { customRender: 'forecastMargin' }, width: 100},
            {dataIndex: 'changeForecastMarginByRegularPrice', title: this.$t('regular.columns.difference') as string, scopedSlots: { customRender: 'changeForecastMarginByRegularPrice' }, width: 100},
            {dataIndex: 'changeForecastMarginPcByRegularPrice', title: this.$t('regular.columns.differencePercent') as string, scopedSlots: { customRender: 'changeForecastMarginPcByRegularPrice' }, width: 100},
            {dataIndex: 'sumMarginForecastPcByRegularPrice', title: this.$t('regular.columns.forecastMarginCurrentPricesPercent') as string, scopedSlots: { customRender: 'sumMarginForecastPcByRegularPrice' }, width: 100},
            {dataIndex: 'forecastMarginPc', title: this.$t('regular.columns.forecastMarginNewPricesPercent') as string, scopedSlots: { customRender: 'forecastMarginPc' }, width: 100},
            {dataIndex: 'changeMarginByRegularPricePp', title: this.$t('regular.columns.differencePp') as string, scopedSlots: { customRender: 'changeMarginByRegularPricePp' }, width: 100},
            {dataIndex: 'ftpSendingStatus', title: '', scopedSlots: { customRender: 'ftpSendingStatus' }, width: 50},
        ];

    allDetailReportFields: TableHeaders[] = [
        {key: 'recipeAttribute', label: this.$t('regular.columns.prc') as string},
        {key: 'treatmentAttribute', label: this.$t('regular.columns.pkl') as string},
        {key: 'vitalMedicine', label: this.$t('regular.columns.essentialDrugs') as string},
        {key: 'producerPrice', label: this.$t('regular.columns.producerPriceVat') as string},
        {key: 'extraChargePc', label: this.$t('regular.columns.markupPercent') as string},
        {key: 'registrationPrice', label: this.$t('regular.columns.registrationPriceVat') as string},
        {key: 'eventTrigger', label: this.$t('regular.columns.eventTrigger') as string},
        {key: 'purchasePriceDeviationPercent', label: this.$t('regular.columns.purchasePriceDeviationPercent') as string, formatter: (v: number | null) => formatPurchasePriceDeviationPercent(v)},
        {key: 'kvi', label: 'KVI', formatter: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value},
        {key: 'ctm', label: this.$t('regular.columns.ctm') as string, formatter: (value: string) => value === 'ДА' ? this.$t('shared.boolFilter.yes') as string : value === 'НЕТ' ? this.$t('shared.boolFilter.no') as string : value},
        {key: 'ctmBrand', label: this.$t('regular.columns.ctmBrandTarget') as string},
        {key: 'ctmPriceGap', label: this.$t('regular.columns.ctmPriceGap') as string},
        {key: 'minRetailPrice', label: this.$t('regular.columns.minRetailPrice') as string},
        {key: 'maxRetailPrice', label: this.$t('regular.columns.maxRetailPrice') as string},
        {key: 'omnichannelStrategy', label: this.$t('regular.columns.omnichannelStrategy') as string},
        {key: 'omnichannelFixedGapType', label: this.$t('regular.columns.omnichannelFixedGapType') as string},
        {key: 'omnichannelGap', label: this.$t('regular.columns.omnichannelGap') as string},
        {key: 'omnichannelApplyCompetitorPrices', label: this.$t('regular.columns.omnichannelApplyCompetitorPrices') as string},
        {key: 'omnichannelMinProfitabilityLimit', label: this.$t('regular.columns.omnichannelMinProfitabilityLimit') as string},
        {key: 'omnichannelBaseChannelPrice', label: this.$t('regular.columns.omnichannelBaseChannelPrice') as string},
        {key: 'keyProduct1', label: this.$t('regular.columns.kht1') as string},
        {key: 'keyProduct2', label: this.$t('regular.columns.kht2') as string},
        {key: 'keyProduct3', label: this.$t('regular.columns.kht3') as string},
        {key: 'keyProduct4', label: this.$t('regular.columns.kht4') as string},
        {key: 'keyProduct5', label: this.$t('regular.columns.kht5') as string},
        {key: 'segment', label: this.$t('regular.columns.segment') as string},
        {key: 'skuLine', label: this.$t('regular.columns.skuPriceLine') as string},
        {key: 'productVerticalLine', label: this.$t('regular.columns.vlName') as string},
        {key: 'productVolume', label: this.$t('regular.columns.vgh') as string},
        {key: 'measurementUnit', label: this.$t('regular.columns.unit') as string},
        {key: 'isVerticalLineBase', label: this.$t('regular.columns.base') as string, formatter: (v, key, item) => "HHFHF" },
        {key: 'vlStrategyStr', label: this.$t('regular.columns.vlStrategy') as string},
        {key: 'vlGapPc', label: this.$t('regular.columns.verticalLineGap') as string,
          formatter: (_value: any, _key: any, item: any) => Formatter.vlGap(item && item.vlGapPc, item && item.vlGapType)},
        {key: 'purchasePrice', label: this.$t('regular.columns.purchasePrice') as string},
        {key: 'avgRegularPrice', label: this.$t('regular.columns.avgRegularPrice') as string},
        {key: 'avgCashPrice', label: this.$t('regular.columns.avgCashierPrice') as string},
        {key: 'avgCheckPrice', label: this.$t('regular.columns.avgReceiptPrice') as string},
        {key: 'regularPrice', label: this.$t('regular.columns.currentRegularPrice') as string},
        {key: 'marginLastPrice', label: this.$t('regular.columns.lastPriceMargin') as string},
        {key: 'minCompetitorPrice', label: this.$t('regular.columns.minCompetitorPrice') as string},
        {key: 'minCompetitorName', label: this.$t('regular.columns.competitor') as string},
        {key: 'minCompetitorCode', label: this.$t('regular.columns.competitorCode') as string},
        {key: 'maxCompetitorPrice', label: this.$t('regular.columns.maxCompetitorPrice') as string},
        {key: 'maxCompetitorName', label: this.$t('regular.columns.competitor') as string},
        {key: 'maxCompetitorCode', label: this.$t('regular.columns.competitorCode') as string},
        {key: 'avgCompetitorPrice', label: this.$t('regular.columns.avgCompetitorPrice') as string},
        {key: 'lastCompetitorPrice', label: this.$t('regular.columns.lastCompetitorPrice') as string},
        {key: 'pi', label: 'PI'},
        {key: 'promoPi', label: this.$t('regular.columns.promoPi') as string},
        {key: 'actualSales', label: this.$t('regular.columns.actualSalesUnitsFull') as string},
        {key: 'actualRevenue', label: this.$t('regular.columns.actualRevenueFull') as string},
        {key: 'actualMargin', label: this.$t('regular.columns.actualMarginFull') as string},
        {key: 'actualMarginPercent', label: this.$t('regular.columns.actualMarginPercentFull') as string},
        {key: 'comparableSales', label: this.$t('regular.columns.compSalesUnitsFull') as string},
        {key: 'comparableRevenue', label: this.$t('regular.columns.compRevenueFull') as string},
        {key: 'comparableMargin', label: this.$t('regular.columns.compMarginFull') as string},
        {key: 'comparableMarginPc', label: this.$t('regular.columns.compMarginPercentFull') as string},
        {key: 'newPrice', label: this.$t('regular.columns.newPrice') as string},
        {key: 'correctedRegularPrice', label: this.$t('regular.columns.correctedPrice') as string},
        {key: 'newMarginPc', label: this.$t('regular.columns.newMargin') as string},
        {key: 'newPI', label: this.$t('regular.columns.newPi') as string},
        {key: 'deltaDiffPrice', label: this.$t('regular.columns.deltaPrice') as string},
        {key: 'priceDiffPc', label: this.$t('regular.columns.pctPriceChange') as string},
        {key: 'marginDiff', label: this.$t('regular.columns.marginChangePp') as string},
        {key: 'changedPI', label: this.$t('regular.columns.piChangePp') as string},
        {key: 'exitSegment', label: this.$t('regular.columns.segmentExit') as string},
        {key: 'coeffElasticity', label: this.$t('regular.columns.elasticityCoeff') as string},
        {key: 'remains', label: this.$t('regular.columns.stock') as string},
        {key: 'initialRemains', label: this.$t('regular.columns.initialRemains') as string},
        {key: 'realizationPercent', label: this.$t('regular.columns.realizationPercent') as string},
        {key: 'salesForecast', label: this.$t('regular.columns.forecastSalesUnits') as string},
        {key: 'revenueForecast', label: this.$t('regular.columns.forecastRevenue') as string},
        {key: 'marginForecast', label: this.$t('regular.columns.forecastMargin') as string},
        {key: 'marginForecastPc', label: this.$t('regular.columns.forecastMarginPercent') as string},
        {key: 'changeSales', label: this.$t('regular.columns.changeSalesUnits') as string},
        {key: 'changeRevenue', label: this.$t('regular.columns.changeRevenue') as string},
        {key: 'changeMargin', label: this.$t('regular.columns.changeMargin') as string},
        {key: 'salesDiffPc', label: this.$t('regular.columns.pctChangeSales') as string},
        {key: 'revenueDiffPc', label: this.$t('regular.columns.pctChangeRevenue') as string},
        {key: 'marginDiffPc', label: this.$t('regular.columns.pctChangeMargin') as string},
        {key: 'marginDiffSecond', label: this.$t('regular.columns.marginChangePp') as string},
        {key: 'salesForecastByRegularPrice', label: this.$t('regular.columns.forecastSalesCurrent') as string},
        {key: 'revenueForecastByRegularPrice', label: this.$t('regular.columns.forecastRevenueCurrent') as string},
        {key: 'marginForecastByRegularPrice', label: this.$t('regular.columns.forecastMarginCurrent') as string},
        {key: 'marginForecastByRegularPricePc', label: this.$t('regular.columns.forecastMarginCurrentPercent') as string},
        {key: 'changeSalesByRegularPrice', label: this.$t('regular.columns.changeSalesCurrentUnits') as string},
        {key: 'changeRevenueByRegularPrice', label: this.$t('regular.columns.changeRevenueCurrent') as string},
        {key: 'changeMarginByRegularPrice', label: this.$t('regular.columns.changeMarginCurrent') as string},
        {key: 'salesDiffPcByRegularPrice', label: this.$t('regular.columns.pctChangeSalesCurrent') as string},
        {key: 'revenueDiffPcByRegularPrice', label: this.$t('regular.columns.pctChangeRevenueCurrent') as string},
        {key: 'marginDiffPcByRegularPrice', label: this.$t('regular.columns.pctChangeMarginCurrent') as string},
        {key: 'marginDiffSecondByRegularPrice', label: this.$t('regular.columns.marginChangeCurrentPp') as string},
        {key: 'individualPriceOptStrategy', label: this.$t('regular.columns.priceOptStrategy') as string},
        {key: 'individualPriceIncreaseLimit', label: this.$t('regular.columns.increaseLimit') as string},
        {key: 'individualPeriodPriceIncreaseLimit', label: this.$t('regular.columns.periodIncreaseLimitPercent') as string},
        {key: 'individualPeriod', label: this.$t('regular.columns.period') as string},
        {key: 'individualMarginalProfit', label: this.$t('regular.columns.minSkuProfitFull') as string},
        {key: 'individualKviStrategy', label: this.$t('regular.columns.kviStrategy') as string},
        {key: 'individualPercentCorrection', label: this.$t('regular.columns.adjustment') as string},
        {key: 'individualNewProductPriceStrategy', label: this.$t('regular.columns.newProductPricingStrategy') as string},
        {key: 'individualPriceGapPercent', label: this.$t('regular.columns.priceGapPercent') as string},
        {key: 'newPriceHistory', label: this.$t('regular.columns.newPriceHistory') as string},
        {key: 'promoPurchasePrice', label: this.$t('regular.columns.purchasePriceForPromo') as string},
        {key: 'minPromoCompetitorPrice', label: this.$t('regular.columns.minPromoCompetitorPrice') as string},
        {key: 'minPromoCompetitorName', label: this.$t('regular.columns.competitor') as string},
        {key: 'minPromoCompetitorCode', label: this.$t('regular.columns.competitorCode') as string},
        {key: 'maxPromoCompetitorPrice', label: this.$t('regular.columns.maxPromoCompetitorPrice') as string},
        {key: 'maxPromoCompetitorName', label: this.$t('regular.columns.competitor') as string},
        {key: 'maxPromoCompetitorCode', label: this.$t('regular.columns.competitorCode') as string},
        {key: 'medianPromoCompetitorPrice', label: this.$t('regular.columns.medianPromoCompPrice') as string},
        {key: 'lastPromoCompetitorPrice', label: this.$t('regular.columns.lastPromoCompetitorPrice') as string},
        {key: 'newPromoPrice', label: this.$t('regular.columns.promoPriceWithComp') as string},
        {key: 'optimalNewPromoPrice', label: this.$t('regular.columns.optimalPromoPrice') as string},
        {key: 'correctedPromoPrice', label: this.$t('regular.columns.correctedPromoPrice') as string},
        {key: 'discountDepth', label: this.$t('regular.columns.discountDepthWithComp') as string},
        {key: 'optimalDiscountDepth', label: this.$t('regular.columns.optimalDiscountDepth') as string},
        {key: 'discountDuration', label: this.$t('regular.columns.discountLength') as string},
        {key: 'promoCoeffElasticity', label: this.$t('regular.columns.promoElasticity') as string},
        {key: 'individualPromoType', label: this.$t('regular.columns.promoType') as string},
        {key: 'individualPromoLift', label: this.$t('regular.columns.regularPriceAdjustment') as string},
        {key: 'basePrice', label: this.$t('regular.columns.producerPriceNoVat') as string},
        {key: 'vatPercentage', label: this.$t('regular.columns.vatPercent') as string},
        {key: 'markupPercentage', label: this.$t('regular.columns.maxMarkup') as string},
        {key: 'marketingPaymentsPercentage', label: this.$t('regular.columns.marketingPayments') as string},
        {key: 'logisticCostsAmount', label: this.$t('regular.columns.logisticsCostNoVat') as string},
        {key: 'logisticCostsPercentage', label: this.$t('regular.columns.logisticsCostPercent') as string},
        {key: 'minPriceForSale', label: this.$t('regular.columns.minSalePrice') as string},
        {key: 'maxPriceForSale', label: this.$t('regular.columns.maxSalePrice') as string},
        {key: 'minDiscountForSale', label: this.$t('regular.columns.minSaleDiscount') as string},
        {key: 'maxDiscountForSale', label: this.$t('regular.columns.minSaleDiscount') as string},
        {key: 'minMarginForSale', label: this.$t('regular.columns.minSaleMargin') as string},
        {key: 'firstDiscountForSale', label: this.$t('regular.columns.discount1stPeriod') as string},
        {key: 'secondDiscountForSale', label: this.$t('regular.columns.discount2ndPeriod') as string},
        {key: 'thirdDiscountForSale', label: this.$t('regular.columns.discount3rdPeriod') as string},
        {key: 'fourthDiscountForSale', label: this.$t('regular.columns.discount4thPeriod') as string},
        {key: 'salePointCode', label: this.$t('regular.columns.storeCode') as string},
        {key: 'marginLoss', label: this.$t('regular.columns.grossIncomeLosses') as string},
        {key: 'marginLossPc', label: this.$t('regular.columns.grossIncomeLossesPercent') as string},
        {key: 'status', label: this.$t('regular.columns.status') as string},
        {key: 'detailedStatus', label: this.$t('regular.columns.detailedStatus') as string},
        {key: 'uploadFile', label: this.$t('regular.columns.uploadFile') as string},
        {key: 'comment', label: this.$t('regular.columns.comment') as string},
        {key: 'minPriceForPromotion', label: this.$t('regular.columns.minPrice') as string},
        {key: 'maxPriceForPromotion', label: this.$t('regular.columns.maxPrice') as string},
        {key: 'minDiscountForPromotion', label: this.$t('regular.columns.minPromoDiscount') as string},
        {key: 'maxDiscountForPromotion', label: this.$t('regular.columns.maxPromoDiscount') as string},
        {key: 'minMarginForPromotion', label: this.$t('regular.columns.minPromoMargin') as string},
        {key: 'firstDiscountForPromotion', label: this.$t('regular.columns.periodDiscount') as string},
    ]

    private hasUnsavedRegularPrices: boolean = false;
    private hasUnsavedPromoPrices: boolean = false;
    numberFormatter = (v: any): string => FormatNumber.format(v);


    onTableChange(pagination: any, filters: any, sorter: any) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;

        // custom management sorting state of table
        this.resultDetailColumns.forEach(column => {
            if (column.sorter && column.sortOrder) {
                column.sortOrder = false;
            }
        })

        if (sorter.field && sorter.order) {
            this.resultDetailColumns.find(column => column.dataIndex === sorter.field).sortOrder = sorter.order;
        }

        if (sorter.field && sorter.order) {
        }

        this.fetchResultTableDetailReports();
    }

    getFilters(dataIndex: string) {
        let key = dataIndex;

        if (key === 'subCategoryName') key = 'subcategoryName'
        if (key === 'productSegmentName') key = 'segmentName'
        if (key === 'segment') key = 'segmentPrice'
        if (key === 'changedPI') key = 'changedPIPc'
        if (key === 'coeffElasticity') key = 'coeffElasticityPc'
        if (key === 'promoCoeffElasticity') key = 'promoCoeffElasticityPc'
        // @ts-ignore
        const filters = this[`${key}sOptionsForDetailTable`] || this[`${key}OptionsForDetailTable`] || this[`${key}Options`]
        if (dataIndex == 'approvedByFio') {
          console.log('filtersCustom', filters)
        }

        return (filters || []);
    }

        clearCalcAllData() {
            this.clearDetailTableFilter();
            this.segmentPriceOptionsForDetailTable = [];
            this.resultTableDetailReports = [];
            this.changesPrices = [];
            this.hasUnsavedRegularPrices = false;
        }

        clearPromoAllData() {
            this.clearDetailTableFilter();
            this.segmentPriceOptionsForDetailTable = [];
            this.resultTableDetailReports = [];
            this.changesPrices = [];
            this.hasUnsavedPromoPrices = false;
        }


        saveCorrectedPrices() {
            // Для типа расчета 'sales' используем новую логику переформирования
            if (this.reportType === 'sales') {
                this.recalculateSalesReportFromDetail();
                return;
            }

            const changesPricesToProcess = Object.assign([], this.changesPrices) as ChangesPrices[];

            const includedSkusPropertiesArray = this.getIncludedSkusPropertiesArray();
            const excludedSkusPropertiesArray = this.getExcludedSkusPropertiesArray();

            const taskIds = [
                ...new Set([
                    ...changesPricesToProcess.map(el => el.taskId),
                    ...includedSkusPropertiesArray.map(el => el.taskId),
                    ...excludedSkusPropertiesArray.map(el => el.taskId),
                ])
            ];

            taskIds.forEach(taskId => {
                const record = changesPricesToProcess.find(el => el.taskId === taskId);

                if (record) {
                    record.includedSkus = includedSkusPropertiesArray.filter(item => item.taskId === taskId).map(item => item.internalCode);
                    record.excludedSkus = excludedSkusPropertiesArray.filter(item => item.taskId === taskId).map(item => item.internalCode);
                } else {
                    const chPrice = new ChangesPrices();

                    chPrice.taskId = taskId;
                    chPrice.includedSkus = includedSkusPropertiesArray.filter(item => item.taskId === taskId).map(item => item.internalCode);
                    chPrice.excludedSkus = excludedSkusPropertiesArray.filter(item => item.taskId === taskId).map(item => item.internalCode);

                    changesPricesToProcess.push(chPrice);
                }
            });

            changesPricesToProcess.forEach((ch) => {
              ch.codeWithPrices = (ch.codeWithPrices || []).filter((p) => p.correctedPrice != null);
            });

            if (this.reportType === 'promo') {
                if (this.taskData != null) {
                    this.showActiveStatusMessage();

                    this.paramsForDetail.changesPrices = changesPricesToProcess;
                    this.paramsForDetail.isAllSkusSelected = this.isAllSkusSelected;
                    this.paramsForDetail.selectActiveProductsOnly = this.selectActiveProductsOnly;
                    this.paramsForDetail.filterParams = this.getReportDetailParams();

                    // tslint:disable-next-line: no-non-null-assertion
                    this.httpSaveCorrectedPromoPrices(this.taskData!!.id, this.taskData.type, this.paramsForDetail)
                        .then((resp) => {
                            if (resp.status === 409) {
                                this.showError(this.$t('regular.notifications.calcAlreadyRunning') as string);
                            }
                          if (resp.status === 204) {
                            this.showInfo(this.$t('regular.notifications.metricsRecalcWithPromo') as string)
                          }
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                            this.updateTableCheckboxesPrevConfiguration();
                        })
                        .catch((e) => {
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                        })
                }
            } else {
                if (this.taskData != null) {
                    this.showActiveStatusMessage();

                    this.paramsForDetail.changesPrices = changesPricesToProcess;
                    this.paramsForDetail.isAllSkusSelected = this.isAllSkusSelected;
                    this.paramsForDetail.selectActiveProductsOnly = this.selectActiveProductsOnly;
                    this.paramsForDetail.filterParams = this.getReportDetailParams();

                    // tslint:disable-next-line: no-non-null-assertion
                    this.httpSaveCorrectedRegularPrices(this.taskData!!.id, this.taskData.type, this.paramsForDetail)
                        .then((resp) => {
                            if (resp.status === 409) {
                                this.showError(this.$t('regular.notifications.calcAlreadyRunning') as string);
                            }
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                            this.updateTableCheckboxesPrevConfiguration();
                            (this.$refs.resultHeaderTableRef as any).refresh();
                        })
                        .catch((e) => {
                            this.refreshDetailTable();
                            this.hideActiveStatusMessage();
                        });
                }
            }
        }

        fullRecalculatePackageTask() {
            if (this.taskData != null) {
                this.showActiveStatusMessage();

                const packageDetailParamFilters = this.getPackageParamsDetailFilter()
                this.httpRestartPackageTaskFromDetailParams(this.taskData.id, packageDetailParamFilters)
                    .then((resp) => {
                        this.loadHeaders();
                        this.loadDetails();
                        this.getReportDetailFieldsByUserId();
                        this.hideActiveStatusMessage();
                    })
                    .catch((e) => {
                        this.hideActiveStatusMessage()
                    })
            }
        }

        recalculateSalesReportFromDetail() {
            if (!this.taskData) return;

            this.showActiveStatusMessage();

            const generalTaskId = this.taskData.id;

            // Collect selection similar to saveCorrected prices flow
            const selectedSkuSalePoints: Array<{ internalCode: string, codeSalesPoint: string }> = [];

            // When not all SKUs are selected: include only explicitly selected
            if (!this.isAllSkusSelected) {
                this.includedSkusProperties.forEach(({ internalCode, taskId }) => {
                    // Find any row matching this pair to grab salePointCode
                    const row = this.resultTableDetailReports.find((r: any) => r.internalCode === internalCode && r.taskId === taskId);
                    if (row && row.salePointCode) {
                        selectedSkuSalePoints.push({ internalCode, codeSalesPoint: row.salePointCode });
                    }
                });
            } else {
                // All selected: exclude items explicitly unchecked
                // Build a fast lookup for excluded pairs
                const excludedSet = new Set(this.excludedSkusProperties.map(el => `${el.taskId}::${el.internalCode}`));
                this.allTaskIdWithInternalCodesByFilters.forEach(({ taskId, internalCode }: any) => {
                    if (!excludedSet.has(`${taskId}::${internalCode}`)) {
                        const row = this.resultTableDetailReports.find((r: any) => r.internalCode === internalCode && r.taskId === taskId);
                        if (row && row.salePointCode) {
                            selectedSkuSalePoints.push({ internalCode, codeSalesPoint: row.salePointCode });
                        }
                    }
                });
            }

            const requestBody: any = {
                generalTaskId,
                isAllSkusSelected: this.isAllSkusSelected,
                selectedSkuSalePoints,
                // Filters object mirrors current detail filters
                filters: this.getReportDetailParams(),
            };

            this.httpRecalculateSales(requestBody)
                .then(() => {
                    this.loadHeaders();
                    this.loadDetails();
                    this.getReportDetailFieldsByUserId();
                })
                .catch(() => {})
                .finally(() => this.hideActiveStatusMessage());
        }

        updateTableCheckboxesPrevConfiguration(): void {
            this.tableCheckboxesPrevConfiguration = {
                selectActiveProductsOnly: this.selectActiveProductsOnly,
                isAllSkusSelected: this.isAllSkusSelected,
                includedSkusProperties: [...this.includedSkusProperties],
                excludedSkusProperties: [...this.excludedSkusProperties],
            };
        }

        isArrayContentIdentical(arr1: any[], arr2: any[]): boolean {
            if (Array.isArray(arr1) && Array.isArray(arr2)) {
                if (arr1.length !== arr2.length) {
                    return false;
                }

                return JSON.stringify(arr1.sort()) === JSON.stringify(arr2.sort());
            }

            return false;
        }

        private getIncludedSkusPropertiesArray(): UniqSkuData[] {
          return Array.from(this.includedSkusProperties as any).map((key: any) => this.parseUniqSkuKey(key));
        }

        private getExcludedSkusPropertiesArray(): UniqSkuData[] {
          return Array.from(this.excludedSkusProperties as any).map((key: any) => this.parseUniqSkuKey(key));
        }

        private parseUniqSkuKey(key: string | UniqSkuData): UniqSkuData {
          if (typeof key !== 'string') return key;

          const [id, taskId, internalCode] = key.split('::');
          return { id: Number(id), taskId: Number(taskId), internalCode };
        }

        get isRecalculateButtonActive(): boolean {
          return this.tableCheckboxesPrevConfiguration.selectActiveProductsOnly !== this.selectActiveProductsOnly
              || this.tableCheckboxesPrevConfiguration.isAllSkusSelected !== this.isAllSkusSelected
              || !this.isArrayContentIdentical(this.tableCheckboxesPrevConfiguration.includedSkusProperties, this.includedSkusProperties)
              || !this.isArrayContentIdentical(this.tableCheckboxesPrevConfiguration.excludedSkusProperties, this.excludedSkusProperties);
        }

        get isAllVisibleSkusSelected(): boolean {
            if (this.isFilterActive && this.filteredSkusSnapshot.length > 0) {
                // Если фильтр активен, проверяем только отфильтрованные элементы
                return this.filteredSkusSnapshot.every(item =>
                    this.excludedSkusProperties.findIndex(
                        excluded => excluded.internalCode === item.internalCode && excluded.taskId === item.taskId
                    ) === -1
                );
            } else {
                // Если фильтр не активен, проверяем все доступные элементы
                if (this.allTaskIdWithInternalCodesByFilters.length === 0) {
                    return false;
                }

                // Проверяем, все ли доступные элементы выделены (не исключены)
                return this.allTaskIdWithInternalCodesByFilters.every(item => {
                    return this.excludedSkusProperties.findIndex(
                        excluded => excluded.internalCode === item.internalCode && excluded.taskId === item.taskId
                    ) === -1;
                });
            }
        }

        set isAllVisibleSkusSelected(value: boolean) {
            if (this.isFilterActive && this.filteredSkusSnapshot.length > 0) {
                // Если фильтр активен, обрабатываем только отфильтрованные элементы
                this.handleCommonCheckboxValueChanged(value);
            } else {
                // Если фильтр не активен, работаем со всеми доступными элементами
                if (value) {
                    // При выборе всех элементов очищаем excludedSkusProperties
                    this.excludedSkusProperties = [];
                } else {
                    // При снятии выбора добавляем все доступные элементы в excludedSkusProperties
                    this.excludedSkusProperties = this.allTaskIdWithInternalCodesByFilters.map(item => ({
                        internalCode: item.internalCode,
                        taskId: item.taskId
                    }));
                }
            }
        }

        get disabledRecalculateButton(): boolean {
            if (this.reportType === 'promo' || this.reportType === 'sales') {
                return (!this.hasUnsavedPromoPrices && !this.isRecalculateButtonActive) || this.disableEdit;
            } else {
              return (
                  ((!this.hasUnsavedRegularPrices && !this.isRecalculateButtonActive) || this.disableEdit)
                  && !this.hasCorrectedPrices
              );
            }
        }

        mounted() {
            this.calcTaskData(this.taskData, null);
            EventBus.$on('calc', this.onTaskEventReceived);
            EventBus.$on('ftpDownloadProgress', this.onFtpDownloadProgressReceived);

            this.fetchResultTableDetailReports();

            this.fetchHasCorrectedPricesFlag()

            this.fetchCommonFilterOptions();

            this.getDetailTableColumnsOrder();

            // temporary - to remove after deploy to all clients and after opening this page on each client
            if (this.reportType === 'sales') {
                const isSkipResetSalesColumnsOrder = localStorage.getItem('isSkipResetSalesColumnsOrderAllSKUs');

                if (!isSkipResetSalesColumnsOrder || isSkipResetSalesColumnsOrder !== 'version_01_09_2025') {
                    localStorage.removeItem('skuDetailSalesColumnsOrderAllSKUs');
                    localStorage.setItem('isSkipResetSalesColumnsOrderAllSKUs', 'version_01_09_2025');

                    this.$router.go(this.$router.currentRoute as any);
                }
            } else if (this.reportType === 'promo') {
                const isSkipResetPromoColumnsOrder = localStorage.getItem('isSkipResetPromoColumnsOrderAllSKUs');

                if (!isSkipResetPromoColumnsOrder || isSkipResetPromoColumnsOrder !== 'version_22_10_2025_3') {
                    localStorage.removeItem('skuDetailPromoColumnsOrderAllSKUs');
                    localStorage.setItem('isSkipResetPromoColumnsOrderAllSKUs', 'version_22_10_2025_3');

                    this.$router.go(this.$router.currentRoute as any);
                }
            } else {
                const isSkipResetRegularColumnsOrder = localStorage.getItem('isSkipResetRegularColumnsOrderAllSKUs');

                if (!isSkipResetRegularColumnsOrder || isSkipResetRegularColumnsOrder !== 'version_01_09_2025') {
                    localStorage.removeItem('skuDetailRegularColumnsOrderAllSKUs');
                    localStorage.setItem('isSkipResetRegularColumnsOrderAllSKUs', 'version_01_09_2025');

                    this.$router.go(this.$router.currentRoute as any);
                }
            }
            // /temporary
        }

        @Watch('$route.params.id')
        onRouteIdChanged(newId: string) {
          this.handleRouteChange(newId)
        }

        handleRouteChange(id: string) {
          this.fetchHasCorrectedPricesFlag()
        }

        onFtpDownloadProgressReceived(ftpSendProgress: FtpDownloadProgress) {
            this.updateSendToFtpProgress(ftpSendProgress);
        }

        updateSendToFtpProgress(ftpSendProgress: FtpDownloadProgress) {
            const index = this.resultGeneralSubtasksTableHeaders.findIndex((item) => {
                return item.taskId === ftpSendProgress.taskId;
            });
            if (index !== -1) {
                this.resultGeneralSubtasksTableHeaders[index].ftpSendingStatus = ftpSendProgress.ftpSendStatus;
            }
        }

        getColumnWidth(dataIndex: string): number {
            const commonWidthOfColumns: {[key: string]: number} = {
                omnichannelStrategy: 220,
                omnichannelFixedGapType: 160,
                omnichannelGap: 100,
                omnichannelApplyCompetitorPrices: 200,
                omnichannelMinProfitabilityLimit: 260,
                omnichannelBaseChannelPrice: 160,
                newPrice: 140,
                newPriceHistory: 300,
                correctedRegularPrice: 230,
                newMarginPc: 160,
                newPI: 140,
                deltaDiffPrice: 150,
                priceDiffPc: 150,
                marginDiff: 160,
                changedPI: 140,
                exitSegment: 160,
                coeffElasticity: 140,
                remains: 120,
                salesForecast: 156,
                revenueForecast: 160,
                marginForecast: 160,
                marginForecastPc: 160,
                changeSales: 176,
                changeRevenue: 180,
                changeMargin: 176,
                salesDiffPc: 160,
                revenueDiffPc: 160,
                marginDiffPc: 160,
                marginDiffSecond: 160,
                salesForecastByRegularPrice: 210,
                revenueForecastByRegularPrice: 210,
                marginForecastByRegularPrice: 200,
                marginForecastByRegularPricePc: 210,
                changeSalesByRegularPrice: 220,
                changeRevenueByRegularPrice: 226,
                changeMarginByRegularPrice: 216,
                salesDiffPcByRegularPrice: 200,
                revenueDiffPcByRegularPrice: 206,
                marginDiffPcByRegularPrice: 190,
                marginDiffSecondByRegularPrice: 180,
                recipeAttribute: 80,
                treatmentAttribute: 80,
                vitalMedicine: 110,
                producerPrice: 160,
                extraChargePc: 140,
                registrationPrice: 150,
                eventTrigger: 166,
                purchasePriceDeviationPercent: 140,
                kvi: 92,
                ctm: 92,
                ctmBrand: 150,
                ctmPriceGap: 156,
                minRetailPrice: 140,
                maxRetailPrice: 146,
                keyProduct1: 200,
                keyProduct2: 160,
                keyProduct3: 170,
                keyProduct4: 170,
                keyProduct5: 170,
                segment: 130,
                skuLine: 200,
                purchasePrice: 180,
                avgRegularPrice: 194,
                avgCashPrice: 180,
                avgCheckPrice: 162,
                regularPrice: 130,
                marginLastPrice: 200,
                minCompetitorPrice: 176,
                minCompetitorName: 200,
                maxCompetitorPrice: 180,
                maxCompetitorName: 200,
                avgCompetitorPrice: 180,
                lastCompetitorPrice: 234,
                pi: 80,
                actualSales: 176,
                actualRevenue: 170,
                actualMargin: 160,
                actualMarginPercent: 172,
                comparableSales: 190,
                comparableRevenue: 190,
                comparableMargin: 176,
                comparableMarginPc: 190,
                logisticCostsPercentage: 196,
                logisticCostsAmount: 196,
                marketingPaymentsPercentage: 210,
                limitRetailPrice: 196,
                markupPercentage: 170,
                vatPercentage: 90,
                basePrice: 166,
                individualPriceOptStrategy: 190,
                individualPriceIncreaseLimit: 160,
                individualPeriodPriceIncreaseLimit: 162,
                individualPeriod: 120,
                individualMarginalProfit: 206,
                individualKviStrategy: 160,
                individualPercentCorrection: 160,
                individualNewProductPriceStrategy: 186,
                individualPriceGapPercent: 160,
                productVerticalLine: 140,
                uploadFile: 180,
                productVolume: 80,
                measurementUnit: 70,
                isVerticalLineBase: 110,
                vlStrategyStr: 140,
                vlGapPc: 176,
                comment: 240,
                // next - only promo fields
                minPriceForPromotion: 180,
                maxPriceForPromotion: 180,
                minDiscountForPromotion: 200,
                maxDiscountForPromotion: 200,
                minMarginForPromotion: 190,
                firstDiscountForPromotion: 170,
                promoPurchasePrice: 200,
                minPromoCompetitorPrice: 220,
                minPromoCompetitorName: 200,
                maxPromoCompetitorPrice: 230,
                maxPromoCompetitorName: 200,
                medianPromoCompetitorPrice: 246,
                lastPromoCompetitorPrice: 266,
                newPromoPrice: 186,
                correctedPromoPrice: 236,
                discountDepth: 210,
                discountDuration: 150,
                promoCoeffElasticity: 150,
                individualPromoType: 120,
                individualPromoLift: 200,
                promoPi: 116,
                status: 170,
                // next - only sales fields
                minPriceForSale: 194,
                maxPriceForSale: 200,
                minDiscountForSale: 206,
                maxDiscountForSale: 206,
                minMarginForSale: 200,
                firstDiscountForSale: 190,
                secondDiscountForSale: 190,
                thirdDiscountForSale: 190,
                fourthDiscountForSale: 190,
            }

            const widthOfColumns: Record<'regular' | 'promo' | 'sales', Record<string, number>> = {
                sales: {
                    newPrice: 190,
                },
                regular: {},
                promo: {},
            };

            return (widthOfColumns[this.reportType] && widthOfColumns[this.reportType][dataIndex] ? widthOfColumns[this.reportType][dataIndex] : commonWidthOfColumns[dataIndex]) || 200;
        }

        getReportDetailFieldsByUserId() {
            if (!this.taskData || !this.taskData.id) {
                this.showError(this.$t('regular.errors.reportDataNotReceived') as string);
                return;
            }

            this.httpGetReportDetailFieldsByUserId(this.reportType, { taskId: this.taskData!.id })
                .then((r) => {
                        this.detailUserFields = r.data;

                        if (this.detailUserFields.length) {
                            const singleFilters = ['kvi', 'ctm'];
                            const columnsWithFiltersArray = [ // not included fields, that have added props in manually created column arrays
                                'newPrice', 'newMarginPc', 'deltaDiffPrice', 'newPI', 'priceDiffPc', 'marginDiff', 'changedPI', 'salesDiffPc', 'revenueDiffPc',
                                'marginDiffPc', 'marginDiffSecond', 'marginForecastByRegularPricePc', 'salesDiffPcByRegularPrice',
                                'revenueDiffPcByRegularPrice', 'marginDiffPcByRegularPrice', 'marginDiffSecondByRegularPrice', 'kvi', 'ctm', 'purchasePrice',
                                'regularPrice', 'marginLastPrice', 'lastCompetitorPrice', 'pi', 'actualMarginPercent', 'comparableMarginPc', 'keyProduct1',
                                'keyProduct2', 'skuLine', 'minCompetitorName', 'maxCompetitorName', 'productVerticalLine', 'detailedStatus', 'uploadFile', 'salePointCode',
                            ];
                            const columnsWithRangeInFilter = [ // not included fields, that have added props in manually created column arrays
                                'newPrice', 'newMarginPc', 'deltaDiffPrice', 'newPI', 'priceDiffPc', 'changedPI', 'salesDiffPc', 'revenueDiffPc',
                                'marginDiffPc', 'marginDiffSecond', 'marginForecastByRegularPricePc', 'salesDiffPcByRegularPrice',
                                'revenueDiffPcByRegularPrice', 'marginDiffPcByRegularPrice', 'marginDiffSecondByRegularPrice', 'marginLastPrice'
                            ];

                            if (this.reportType === 'promo') {
                                const promoDetailReportColumns = [...this.promoDetailReportStaticFields];

                                this.detailUserFields.forEach((detailField) => {
                                    if (detailField.permanentlyHidden) {
                                        return;
                                    }

                                    const reportField = this.allDetailReportFields.find((v) => v.key === detailField.key)
                                    if (reportField == null) {
                                        this.$log.debug('notFound', detailField.key);
                                    } else {
                                        const promoColumn: any = {
                                            dataIndex: detailField.key,
                                            slots: { title: `${detailField.key}ColumnTitle` }, // dataIndex + 'ColumnTitle'
                                            slotColumnTitleData: {
                                                text: reportField.label,
                                            },
                                            sorter: true,
                                            scopedSlots: {
                                                customRender: detailField.key
                                            },
                                            width: this.getColumnWidth(detailField.key),
                                            ellipsis: true,
                                        }

                                        if (columnsWithFiltersArray.includes(detailField.key)) {
                                            promoColumn.filterOptionsKey = detailField.key;
                                            promoColumn.filterModel = detailField.key;
                                            promoColumn.showRange = columnsWithRangeInFilter.includes(detailField.key);
                                            promoColumn.onFilterDropdownVisibleChange = () => { this.filterDropdownVisibleChange(detailField.key) };
                                            promoColumn.scopedSlots = {
                                                customRender: detailField.key,
                                                filterDropdown: singleFilters.includes(detailField.key) ? "filterRadioButtons" : "filterCheckboxes",
                                                filterIcon: "filterIcon",
                                            };
                                        }

                                        promoDetailReportColumns.push(promoColumn);
                                    }
                                });

                                const orderOfFieldsPromo = [
                                    "checkboxes", "internalCode", "skuName", "salePointCode", "taskId", "status", "detailedStatus", "isApproved", "approvedByFio",
                                    "newPrice", "newPriceHistory",  "optimalNewPromoPrice",
                                    "optimalDiscountDepth", "firstDiscountForPromotion", "minPriceForPromotion", "maxPriceForPromotion", "minDiscountForPromotion", "maxDiscountForPromotion",
                                    "minMarginForPromotion","marginLoss", "marginLossPc", "remains", "groupName", "categoryName", "subCategoryName",
                                    "formatName", "regionName", "clusterName", "productSegmentName", "recipeAttribute", "treatmentAttribute", "vitalMedicine",
                                    "producerPrice", "extraChargePc", "registrationPrice", "eventTrigger", "purchasePriceDeviationPercent", "kvi", "ctm", "ctmBrand", "ctmPriceGap", "minRetailPrice",
                                    "maxRetailPrice",
                                    "omnichannelStrategy", "omnichannelFixedGapType", "omnichannelGap",
                                    "omnichannelApplyCompetitorPrices", "omnichannelMinProfitabilityLimit", "omnichannelBaseChannelPrice",
                                    "keyProduct1", "keyProduct2", "keyProduct3", "keyProduct4", "keyProduct5", "segment", "skuLine", "purchasePrice", "promoPurchasePrice",
                                    "avgRegularPrice", "avgCashPrice", "avgCheckPrice", "regularPrice", "marginLastPrice", "minCompetitorPrice",
                                    "minCompetitorName", "minCompetitorCode", "maxCompetitorPrice", "maxCompetitorName", "maxCompetitorCode", "avgCompetitorPrice", "lastCompetitorPrice",
                                    "minPromoCompetitorPrice", "minPromoCompetitorName", "minPromoCompetitorCode", "maxPromoCompetitorPrice", "maxPromoCompetitorName", "maxPromoCompetitorCode",
                                    "medianPromoCompetitorPrice", "lastPromoCompetitorPrice", "pi", "promoPi", "actualSales", "actualRevenue", "actualMargin",
                                    "actualMarginPercent", "comparableSales", "comparableRevenue", "comparableMargin", "comparableMarginPc",
                                    "newPromoPrice", "correctedPromoPrice", "newMarginPc", "newPI", "deltaDiffPrice", "priceDiffPc", "marginDiff", "changedPI",
                                    "discountDepth", "discountDuration", "exitSegment", "coeffElasticity", "promoCoeffElasticity", "salesForecast",
                                    "revenueForecast", "marginForecast", "marginForecastPc", "changeSales", "changeRevenue", "changeMargin", "salesDiffPc",
                                    "revenueDiffPc", "marginDiffPc", "marginDiffSecond", "individualPromoType", "individualPromoLift", "individualPriceOptStrategy",
                                    "individualPriceIncreaseLimit", "individualPeriodPriceIncreaseLimit", "individualPeriod", "individualMarginalProfit",
                                    "individualKviStrategy", "individualPercentCorrection", "individualNewProductPriceStrategy", "individualPriceGapPercent",
                                    "comment", "logisticCostsPercentage", "logisticCostsAmount", "marketingPaymentsPercentage", "basePrice", "vatPercentage", "markupPercentage",
                                ];

                                const orderedPromoDetailReportColumns: any[] = [];
                                const notOrderedPromoDetailReportColumns = [...promoDetailReportColumns];

                                orderOfFieldsPromo.forEach(dataIndex => {
                                    const index = notOrderedPromoDetailReportColumns.findIndex(column => column.dataIndex === dataIndex);

                                    if (index !== -1) {
                                        orderedPromoDetailReportColumns.push(notOrderedPromoDetailReportColumns.splice(index, 1)[0]);
                                    }
                                });

                                this.promoDetailReport = [...orderedPromoDetailReportColumns, ...notOrderedPromoDetailReportColumns];
                            } else if (this.reportType === 'sales') {
                                const salesOnlyDetailReportFields: TableHeaders[] = [
                                    {key: 'newPrice', label: this.$t('regular.columns.regularPrice') as string},
                                ];

                                const salesDetailReportColumns = [...this.salesDetailReportStaticFields];

                                this.detailUserFields.forEach((detailField) => {
                                    if (detailField.permanentlyHidden) {
                                        return;
                                    }

                                    if (!this.isSalesRealizationReport && ['initialRemains', 'realizationPercent'].includes(detailField.key)) {
                                        return;
                                    }

                                    const reportField = ['newPrice'].includes(detailField.key)
                                        ? salesOnlyDetailReportFields.find((v) => v.key === detailField.key)
                                        : this.allDetailReportFields.find((v) => v.key === detailField.key);

                                    if (reportField) {
                                        const salesColumn: any = {
                                            dataIndex: detailField.key,
                                            slots: { title: `${detailField.key}ColumnTitle` },
                                            slotColumnTitleData: {
                                                text: this.getSalesDetailFieldLabel(detailField.key, reportField.label),
                                            },
                                            sorter: true,
                                            scopedSlots: {
                                                customRender: detailField.key
                                            },
                                            width: this.getColumnWidth(detailField.key),
                                            ellipsis: true,
                                        }

                                        if (columnsWithFiltersArray.includes(detailField.key)) {
                                            salesColumn.filterOptionsKey = detailField.key;
                                            salesColumn.filterModel = detailField.key;
                                            salesColumn.showRange = columnsWithRangeInFilter.includes(detailField.key);
                                            salesColumn.onFilterDropdownVisibleChange = () => { this.filterDropdownVisibleChange(detailField.key) };
                                            salesColumn.scopedSlots = {
                                                customRender: detailField.key,
                                                filterDropdown: singleFilters.includes(detailField.key) ? "filterRadioButtons" : "filterCheckboxes",
                                                filterIcon: "filterIcon",
                                            };
                                        }

                                        salesDetailReportColumns.push(salesColumn);
                                    }
                                });

                                // ordering columns
                                const orderOfFields = [
                                    "checkboxes", "internalCode", "skuName", "salePointCode", "taskId", "status", "detailedStatus", "isApproved", "approvedByFio",
                                    "newPrice", "newPriceHistory",  "optimalNewPromoPrice",
                                    "optimalDiscountDepth", "firstDiscountForSale", "secondDiscountForSale", "thirdDiscountForSale", "fourthDiscountForSale", "minPriceForSale", "maxPriceForSale",
                                    "minDiscountForSale", "maxDiscountForSale", "minMarginForSale", "marginLoss", "marginLossPc", "remains", "initialRemains", "realizationPercent", "groupName", "categoryName", "subCategoryName",
                                    "formatName", "regionName", "clusterName", "productSegmentName", "recipeAttribute", "treatmentAttribute", "vitalMedicine",
                                    "producerPrice", "extraChargePc", "registrationPrice", "eventTrigger", "purchasePriceDeviationPercent", "kvi", "ctm", "ctmBrand", "ctmPriceGap", "minRetailPrice",
                                    "maxRetailPrice",
                                    "omnichannelStrategy", "omnichannelFixedGapType", "omnichannelGap",
                                    "omnichannelApplyCompetitorPrices", "omnichannelMinProfitabilityLimit", "omnichannelBaseChannelPrice",
                                    "keyProduct1", "keyProduct2", "keyProduct3", "keyProduct4", "keyProduct5", "segment", "skuLine", "purchasePrice", "promoPurchasePrice",
                                    "avgRegularPrice", "avgCashPrice", "avgCheckPrice", "regularPrice", "marginLastPrice", "minCompetitorPrice",
                                    "minCompetitorName", "minCompetitorCode", "maxCompetitorPrice", "maxCompetitorName", "maxCompetitorCode", "avgCompetitorPrice", "lastCompetitorPrice",
                                    "minPromoCompetitorPrice", "minPromoCompetitorName", "minPromoCompetitorCode", "maxPromoCompetitorPrice", "maxPromoCompetitorName", "maxPromoCompetitorCode",
                                    "medianPromoCompetitorPrice", "lastPromoCompetitorPrice", "pi", "promoPi", "actualSales", "actualRevenue", "actualMargin",
                                    "actualMarginPercent", "comparableSales", "comparableRevenue", "comparableMargin", "comparableMarginPc",
                                    "newPromoPrice", "correctedPromoPrice", "newMarginPc", "newPI", "deltaDiffPrice", "priceDiffPc", "marginDiff", "changedPI",
                                    "discountDepth", "discountDuration", "exitSegment", "coeffElasticity", "promoCoeffElasticity", "salesForecast",
                                    "revenueForecast", "marginForecast", "marginForecastPc", "changeSales", "changeRevenue", "changeMargin", "salesDiffPc",
                                    "revenueDiffPc", "marginDiffPc", "marginDiffSecond", "individualPromoType", "individualPromoLift", "individualPriceOptStrategy",
                                    "individualPriceIncreaseLimit", "individualPeriodPriceIncreaseLimit", "individualPeriod", "individualMarginalProfit",
                                    "individualKviStrategy", "individualPercentCorrection", "individualNewProductPriceStrategy", "individualPriceGapPercent",
                                    "comment",
                                ];

                                const orderedSalesDetailReportColumns: any[] = [salesDetailReportColumns.splice(0, 1)[0]]; // add "checkboxes" column

                                const notOrderedSalesDetailReportColumns = [...salesDetailReportColumns];

                                orderOfFields.forEach(dataIndex => {
                                    const index = notOrderedSalesDetailReportColumns.findIndex(column => column.dataIndex === dataIndex);

                                    if (index !== -1) {
                                        orderedSalesDetailReportColumns.push(notOrderedSalesDetailReportColumns.splice(index, 1)[0]);
                                    }
                                })

                                this.salesDetailReport = [...orderedSalesDetailReportColumns, ...notOrderedSalesDetailReportColumns];
                            } else {
                                const orderOfFields = [ // by dataIndexes, not include dataIndexes from correctOrderedStaticRegularDetailReportColumns
                                    'status', 'detailedStatus', 'uploadFile',
                                    'newPrice', 'newPriceHistory', 'correctedRegularPrice', 'newMarginPc', 'newPI', 'deltaDiffPrice', 'priceDiffPc', 'marginDiff',
                                    'changedPI', 'exitSegment', 'coeffElasticity', 'remains', 'salesForecast', 'revenueForecast', 'marginForecast', 'marginForecastPc', 'changeSales',
                                    'changeRevenue', 'changeMargin', 'salesDiffPc', 'revenueDiffPc', 'marginDiffPc', 'marginDiffSecond', 'salesForecastByRegularPrice',
                                    'revenueForecastByRegularPrice', 'marginForecastByRegularPrice',
                                    'marginForecastByRegularPricePc', 'changeSalesByRegularPrice', 'changeRevenueByRegularPrice', 'changeMarginByRegularPrice',
                                    'salesDiffPcByRegularPrice', 'revenueDiffPcByRegularPrice', 'marginDiffPcByRegularPrice', 'marginDiffSecondByRegularPrice', 'taskId',
                                    'groupName', 'categoryName', 'subCategoryName', 'formatName', 'regionName', 'clusterName', 'productSegmentName', 'batchNumber', 'recipeAttribute',
                                    'treatmentAttribute', 'vitalMedicine', 'producerPrice', 'extraChargePc', 'registrationPrice', 'eventTrigger', 'purchasePriceDeviationPercent', 'kvi', 'ctm',
                                    'ctmBrand', 'ctmPriceGap', 'minRetailPrice', 'maxRetailPrice',
                                    "omnichannelStrategy", "omnichannelFixedGapType", "omnichannelGap",
                                    "omnichannelApplyCompetitorPrices", "omnichannelMinProfitabilityLimit", "omnichannelBaseChannelPrice",
                                    'keyProduct1', 'keyProduct2', 'keyProduct3', 'keyProduct4', 'keyProduct5', 'segment', 'skuLine', 'purchasePrice',
                                    'avgRegularPrice', 'avgCashPrice', 'avgCheckPrice', 'regularPrice', 'marginLastPrice',
                                    'minCompetitorPrice', 'minCompetitorName', 'minCompetitorCode', 'maxCompetitorPrice', 'maxCompetitorName', 'maxCompetitorCode', 'avgCompetitorPrice', 'lastCompetitorPrice',
                                    'pi', 'actualSales', 'actualRevenue', 'actualMargin', 'actualMarginPercent', 'comparableSales', 'comparableRevenue',
                                    'comparableMargin', 'comparableMarginPc', 'logisticCostsPercentage', 'logisticCostsAmount', 'marketingPaymentsPercentage',
                                    'limitRetailPrice', 'markupPercentage', 'vatPercentage', 'basePrice', 'individualPriceOptStrategy', 'individualPriceIncreaseLimit',
                                    'individualPeriodPriceIncreaseLimit', 'individualPeriod', 'individualMarginalProfit', 'individualKviStrategy', 'individualPercentCorrection',
                                    'individualNewProductPriceStrategy', 'individualPriceGapPercent', 'productVerticalLine', 'productVolume', 'measurementUnit',
                                    'isVerticalLineBase', 'vlStrategyStr', 'vlGapPc', 'comment',
                                ];

                                const correctOrderedStaticRegularDetailReportColumns = [
                                    {
                                        key: 'checkboxes',
                                        scopedSlots: {
                                            title: 'commonCheckbox',
                                            customRender: 'rowCheckbox',
                                        },
                                        fixed: 'left',
                                        width: 50,
                                        align: 'center',
                                    },
                                    {
                                        dataIndex: 'internalCode',
                                        slots: { title: 'internalCodeColumnTitle' }, // dataIndex + 'ColumnTitle'
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.internalCode') as string,
                                        },
                                        sorter: true,
                                        fixed: 'left',
                                        filterOptionsKey: 'internalCode',
                                        filterModel: 'internalCode',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('internalCode') },
                                        scopedSlots: {
                                            customRender: 'internalCode',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 170,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'skuName',
                                        slots: { title: 'skuNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.skuName') as string,
                                        },
                                        stickyColumn: true,
                                        sorter: true,
                                        fixed: 'left',
                                        filterOptionsKey: 'skuName',
                                        filterModel: 'skuName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('skuName') },
                                        scopedSlots: {
                                            customRender: 'skuName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 340,
                                        // ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'isApproved',
                                        title: this.$t('regular.columns.approval') as string,
                                        filterOptionsKey: 'isApproved',
                                        filterModel: 'isApproved',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('isApproved') },
                                        scopedSlots: {
                                            customRender: 'isApproved',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 150,
                                    },
                                    {
                                        dataIndex: 'approvedByFio',
                                        title: this.$t('regular.columns.approvedBy') as string,
                                        filterOptionsKey: 'approvedByFio',
                                        filterModel: 'approvedByFio',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('approvedByFio') },
                                        scopedSlots: {
                                            customRender: 'approvedByFio',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 150,
                                        ellipsis: true,
                                    },
                                ];

                                const incorrectOrderedStaticRegularDetailReportColumns = [
                                    {
                                        dataIndex: 'taskId',
                                        slots: { title: 'taskIdColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.reportNo') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'taskId',
                                        filterModel: 'taskId',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('taskId') },
                                        scopedSlots: {
                                            customRender: 'taskId',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 156,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'groupName',
                                        slots: { title: 'groupNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.productGroup') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'groupName',
                                        filterModel: 'groupName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('groupName') },
                                        scopedSlots: {
                                            customRender: 'groupName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'categoryName',
                                        slots: { title: 'categoryNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.productCategory') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'categoryName',
                                        filterModel: 'categoryName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('categoryName') },
                                        scopedSlots: {
                                            customRender: 'categoryName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'subCategoryName',
                                        slots: { title: 'subCategoryNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.productSubcategory') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'subCategoryName',
                                        filterModel: 'subCategoryName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('subCategoryName') },
                                        scopedSlots: {
                                            customRender: 'subCategoryName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        onFilter: () => true,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'formatName',
                                        slots: { title: 'formatNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.formatChannel') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'formatName',
                                        filterModel: 'formatName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('formatName') },
                                        scopedSlots: {
                                            customRender: 'formatName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'regionName',
                                        slots: { title: 'regionNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.storeRegion') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'regionName',
                                        filterModel: 'regionName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('regionName') },
                                        scopedSlots: {
                                            customRender: 'regionName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'clusterName',
                                        slots: { title: 'clusterNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.storeCluster') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'clusterName',
                                        filterModel: 'clusterName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('clusterName') },
                                        scopedSlots: {
                                            customRender: 'clusterName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'productSegmentName',
                                        slots: { title: 'productSegmentNameColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.productSegment') as string,
                                        },
                                        sorter: true,
                                        filterOptionsKey: 'productSegmentName',
                                        filterModel: 'productSegmentName',
                                        showRange: false,
                                        onFilterDropdownVisibleChange: () => { this.filterDropdownVisibleChange('productSegmentName') },
                                        scopedSlots: {
                                            customRender: 'productSegmentName',
                                            filterDropdown: "filterCheckboxes",
                                            filterIcon: "filterIcon",
                                        },
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        dataIndex: 'batchNumber',
                                        slots: { title: 'batchNumberColumnTitle' },
                                        slotColumnTitleData: {
                                            text: this.$t('regular.columns.batchNumber') as string,
                                        },
                                        sorter: true,
                                        scopedSlots: {
                                            customRender: 'batchNumber',
                                        },
                                        width: 160,
                                        ellipsis: true,
                                    },
                                    // {
                                    //     dataIndex: 'recipeAttribute', // must fetch from Backend as for Promo
                                    //     title: this.$t('allSkusTab.columns.prc') as string,
                                    //     sorter: true,
                                    //     scopedSlots: {
                                    //         customRender: 'recipeAttribute'
                                    //     },
                                    //     width: 80,
                                    //     filterMultiple: true,
                                    //     ellipsis: true
                                    // }
                                ];

                                const dynamicRegularDetailReportColumns: any[] = [];

                                this.detailUserFields.forEach((detailField) => {
                                    if (detailField.permanentlyHidden) {
                                        return;
                                    }

                                    const reportField = this.allDetailReportFields.find((v) => v.key === detailField.key)
                                    if (reportField == null) {
                                      this.$log.debug('notFound', detailField.key);
                                    } else {
                                        this.tableFilterOptions[detailField.key] = this.getFilters(detailField.key);

                                        const dynamicRegularDetailReportColumn: any = {
                                            dataIndex: detailField.key,
                                            slots: { title: `${detailField.key}ColumnTitle` }, // dataIndex + 'ColumnTitle'
                                            slotColumnTitleData: {
                                                text: reportField.label,
                                            },
                                            sorter: true,
                                            scopedSlots: {
                                                customRender: detailField.key,
                                            },
                                            ellipsis: true,
                                            width: this.getColumnWidth(detailField.key),
                                        }

                                        if (columnsWithFiltersArray.includes(detailField.key)) {
                                            dynamicRegularDetailReportColumn.filterOptionsKey = detailField.key;
                                            dynamicRegularDetailReportColumn.filterModel = detailField.key;
                                            dynamicRegularDetailReportColumn.showRange = columnsWithRangeInFilter.includes(detailField.key);
                                            dynamicRegularDetailReportColumn.onFilterDropdownVisibleChange = () => { this.filterDropdownVisibleChange(detailField.key) };
                                            dynamicRegularDetailReportColumn.scopedSlots = {
                                                customRender: detailField.key,
                                                filterDropdown: singleFilters.includes(detailField.key) ? "filterRadioButtons" : "filterCheckboxes",
                                                filterIcon: "filterIcon",
                                            };
                                        }

                                        dynamicRegularDetailReportColumns.push(dynamicRegularDetailReportColumn);
                                    }
                                });

                                // ordering columns
                                const orderedRegularDetailReportColumns = [...correctOrderedStaticRegularDetailReportColumns];

                                const notOrderedRegularDetailReportColumns = [...incorrectOrderedStaticRegularDetailReportColumns, ...dynamicRegularDetailReportColumns]

                                orderOfFields.forEach(dataIndex => {
                                    const index = notOrderedRegularDetailReportColumns.findIndex(column => column.dataIndex === dataIndex);

                                    if (index !== -1) {
                                        orderedRegularDetailReportColumns.push(notOrderedRegularDetailReportColumns.splice(index, 1)[0]);
                                    }
                                })

                                this.regularDetailReport = [...orderedRegularDetailReportColumns, ...notOrderedRegularDetailReportColumns];
                            }
                        }
                    },
                )
                .catch((e) => {
                    this.$log.error(e)
                    this.showError(this.$t('regular.errors.loadDetailReportFieldsFailed') as string);
                });
        }

        setSelectedDetailField(columnName: string, columnValue: string, change: boolean) {
            if (change) {
                this.detailColumnsListForAddFields.push({key: columnName, label: columnValue})

                const index = this.detailColumnsListForDeleteFields.findIndex((field) => {
                    return field.key === columnName
                });
                if (index !== -1) {
                    this.detailColumnsListForDeleteFields.splice(index, 1)
                }
            } else {
                this.detailColumnsListForDeleteFields.push({key: columnName, label: ''})

                const index = this.detailColumnsListForAddFields.findIndex((field) => {
                    return field.key === columnName
                });
                if (index !== -1) {
                    this.detailColumnsListForAddFields.splice(index, 1)
                }
            }
        }

        isSelectedDetailField(fieldName: string): boolean {
            const index = this.detailUserFields.findIndex((field) => {
                return field.key === fieldName
            });
            return index !== -1;
        }

        saveDetailColumnsStatus() {
            const params: ReportDetailColumnsForAddOrDelete = {
                detailColumnsForAdd: this.detailColumnsListForAddFields,
                detailColumnsForDelete: this.detailColumnsListForDeleteFields,
            }

            this.httpChangeReportDetailColumnsStatus(this.reportType, params)
                .then((r) => {
                        this.detailColumnsListForAddFields = [];
                        this.detailColumnsListForDeleteFields = [];
                        this.getReportDetailFieldsByUserId();
                        this.showInfo(this.$t('regular.notifications.columnOrderChanged') as string);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.saveDetailReportFieldsFailed') as string + e);
                });
        }

        beforeDestroy() {
            EventBus.$off('calc', this.onTaskEventReceived)
            EventBus.$off('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        }

        onTaskEventReceived(task: TaskData) {
            if (this.taskData != null && this.taskData.id === task.id) {
                this.taskData.status = task.status;
                if (this.taskData.status === 'WriteToFileComplete' || this.taskData.status === 'OnApproval' || this.taskData.status === 'Rejected' || this.taskData.status === 'Approved') {
                    this.changesPrices = [];
                    this.hasUnsavedRegularPrices = false;
                    this.hasUnsavedPromoPrices = false;
                    this.refreshHeaderTable();
                    this.refreshDetailTable();
                    this.hideActiveStatusMessage();
                }
            }
        }

        @Watch('taskData')
        onTaskDataChanged(taskData: TaskAndFile | null, oldValue: TaskAndFile | null) {
            this.calcTaskData(taskData, oldValue);

            this.fetchCommonFilterOptions();
        }

        @Watch('showSortingModal')
        onShowSortingModalChange(newVal: boolean) {
            if (newVal) {
                this.sortedColumns = [...this.columnsForManageModal];
            }
        }

        handleApplyClick() {
            const columnsOrder = [...this.sortedColumns.map(column => column.dataIndex)];

            if (this.tableColumnsOrder.toString() !== columnsOrder.toString()) {
                this.tableColumnsOrder = columnsOrder;

                const columnsOrderVariable = (() => {
                    switch (this.reportType) {
                        case 'promo':
                            return 'skuDetailPromoColumnsOrderAllSKUs';
                        case 'sales':
                            return 'skuDetailSalesColumnsOrderAllSKUs';
                        default:
                            return 'skuDetailRegularColumnsOrderAllSKUs';
                    }
                })();

                localStorage.setItem(columnsOrderVariable, this.tableColumnsOrder.toString());
            }

            if (this.detailColumnsListForAddFields.length !== 0 || this.detailColumnsListForDeleteFields.length !== 0) {
                this.saveDetailColumnsStatus();
            } else {
                this.showInfo(this.$t('regular.notifications.columnOrderChangedShort') as string);
            }

            this.showSortingModal = false;
        }

        handleCancel() {
            this.showSortingModal = false;
        }

        isHidePossibility(dataIndex: string) {
            return !['internalCode', 'skuName', 'isApproved', 'approvedByFio', 'taskId',
                'groupName', 'categoryName', 'subCategoryName', 'formatName', 'regionName',
                'clusterName', 'productSegmentName', 'batchNumber'].includes(dataIndex);
        }

        isAllowDrag(dataIndex: string) {
            return !['internalCode', 'skuName'].includes(dataIndex);
        }

        calcTaskData(taskData: TaskAndFile | null, oldValue: TaskAndFile | null) {
            this.fetchAllGeneralSubTasksTableHeaders(true, (items) => {})
            this.fetchAllGeneralSubTasksTableHeadersSize(true, (items) => {})

            if (taskData == null) {
                this.clearCalcAllData();
                this.clearPromoAllData();
            } else {
                if (taskData.status !== 'WriteToFileComplete' && taskData.status !== 'OnApproval' && taskData.status !== 'Rejected' && taskData.status !== 'Approved') {
                    this.showActiveStatusMessage();
                    return;
                }
                if (oldValue == null || taskData.id !== oldValue.id) {
                    if ([TaskType.PROMO, TaskType.PACKAGE_PROMO, TaskType.PACKAGE_GENERAL_PROMO, TaskType.PACKAGE_PROMOTION, TaskType.PACKAGE_GENERAL_PROMOTION].includes(taskData.type)) {
                        this.reportType = 'promo';
                    } else if (taskData.type === TaskType.SALES || taskData.type === TaskType.PACKAGE_SALES || taskData.type === TaskType.PACKAGE_GENERAL_SALES || taskData.type === TaskType.PACKAGE_GENERAL_AGGREGATE_SALES) {
                        this.reportType = 'sales';
                    } else {
                        this.reportType = 'regular';
                    }

                    this.isPackageOrScheduleReport = taskData.type === TaskType.PACKAGE_REGULAR || taskData.type === TaskType.PACKAGE_SCHEDULE || taskData.type === TaskType.PACKAGE_SCENARIO || taskData.type === TaskType.PACKAGE_EVENTS || taskData.type === TaskType.SCHEDULED_PRICE_EXP;
                    this.isPackagePromoReport = taskData.type === TaskType.PACKAGE_PROMOTION;

                    if (this.reportType === 'promo') {
                        this.detailTableIdName = 'resultDetailPromoReport';
                    } else if (this.reportType === 'sales') {
                        this.detailTableIdName = 'resultDetailSalesReport';
                    }

                    this.reportType === 'promo' || this.reportType === 'sales' ? this.clearPromoAllData() : this.clearCalcAllData();

                    if (taskData.type === TaskType.PACKAGE_GENERAL || taskData.type === TaskType.PACKAGE_GENERAL_SCENARIO || taskData.type === TaskType.PACKAGE_EVENTS_GENERAL || taskData.type === TaskType.PACKAGE_GENERAL_KVI_CARTS) {
                        this.isGeneralRegularPackage = true
                        this.showGeneralComparableBlock = false
                    }

                    this.loadHeaders();
                    this.loadDetails();
                    this.getReportDetailFieldsByUserId();
                    this.tryFindParams(taskData.id);
                }
            }
        }

        tryFindParams(taskId: number) {
            if (this.isPackageOrScheduleReport || this.isPackagePromoReport) {
                this.loadPackageCommonParams(taskId);
                if (this.isPackagePromoReport) {
                    this.loadPackagePromoParams(taskId);
                }
            }
        }

        loadPackageCommonParams(taskId: number) {
            this.httpFindPackageBaseParams(taskId)
                .then((r) => {
                    this.applyPackageParamsInDetailReportCalcFilters(this.$packageParamsInDetailReport, r.data);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadPackageReportParamsFailed') as string);
                    this.$log.error('Error occurred [load package base filters]', e);
                });
        }

        loadPackagePromoParams(taskId: number) {
            this.httpFindPackagePromoParams(taskId)
                .then((r) => {
                        this.applyPackageParamsInDetailReportPromoFilters(this.$packageParamsInDetailReport, r.data);
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadPackagePromoParamsFailed') as string);
                    this.$log.error('Error occurred [load package promo filters]', e);
                });
        }

        showRecalculateButton(): boolean {
          return !this.isTaskStatusApproved()
        }

        showActiveStatusMessage() {
            (this.$refs['statusModal'] as BModal).show();
        }

        hideActiveStatusMessage() {
            (this.$refs['statusModal'] as BModal).hide();
        }

        setCorrectedRegularPrice(row: ResultTableDetailReports, priceStr: string | null) {
            let price: number | null
            if (priceStr == null) {
                price = null
            } else {
                const value = priceStr.replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.');
                price = parseFloat(value)
            }
            const index = this.changesPrices.findIndex((item) => {
                return item.taskId === row.taskId
            });
            if (row.correctedRegularPrice == null) {
                if (price == null || isNaN(price)) {
                    if (index !== -1) {
                        this.changesPrices.splice(index, 1);
                    }
                } else {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = price
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                }
            } else {
                if (price == null || isNaN(price)) {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = null
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = null
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = null
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                } else {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = price
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                }
            }
            this.hasUnsavedRegularPrices = this.changesPrices.length !== 0;
        }

        setCorrectedPromoPrice(row: ResultTableDetailReports, priceStr: string | number | null) {
            let price: number | null;

            if (priceStr == null || priceStr === '') {
              price = null;
            } else {
              const raw = String(priceStr);
              const value = raw.replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.');
              price = parseFloat(value);

              if (row.newPrice != null && (isNaN(price) || price >= row.newPrice)) {
                price = null;
                row.correctedPromoPrice = null;
              }
            }
            const index = this.changesPrices.findIndex((item) => {
                return item.taskId === row.taskId
            });
            if (row.correctedPromoPrice == null) {
                // tslint:disable-next-line: no-non-null-assertion
                if (isNaN(price!!)) {
                    if (index !== -1) {
                        this.changesPrices.splice(index, 1);
                    }
                } else {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = price
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                }
            } else {
                if (price == null || isNaN(price)) {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = null
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = null
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = null
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                } else {
                    if (index === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                        internalCodesWithCorrPrices.internalCode = row.internalCode
                        internalCodesWithCorrPrices.correctedPrice = price
                        chPrice.codeWithPrices.push(internalCodesWithCorrPrices)
                        this.changesPrices.push(chPrice)
                    } else {
                        const innerIndex = this.changesPrices[index].codeWithPrices.findIndex((item) => {
                            return item.internalCode === row.internalCode
                        });
                        if (innerIndex !== -1) {
                            this.changesPrices[index].codeWithPrices[innerIndex].correctedPrice = price
                        } else {
                            const internalCodesWithCorrPrices = new InternalCodesWithCorrPrices();
                            internalCodesWithCorrPrices.internalCode = row.internalCode
                            internalCodesWithCorrPrices.correctedPrice = price
                            this.changesPrices[index].codeWithPrices.push(internalCodesWithCorrPrices)
                        }
                    }
                }
            }
            // tslint:disable-next-line: no-non-null-assertion
            this.hasUnsavedPromoPrices = this.changesPrices.length !== 0;
        }

        getCorrectedRegularPrice(row: ResultTableDetailReports): number | null {
            const changePriceRow = this.changesPrices.find((value, index) => value.taskId === row.taskId);
            if (changePriceRow !== undefined) {
                const innerIndex = changePriceRow.codeWithPrices.findIndex((item) => {
                    return item.internalCode === row.internalCode
                });
                if (innerIndex !== -1) {
                    return changePriceRow.codeWithPrices[innerIndex].correctedPrice;
                }
            }
            if (row.correctedRegularPrice == null) {
                return null
            } else {
                return parseFloat(String(row.correctedRegularPrice).replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.'));
            }
        }

        getCorrectedPromoPrice(row: ResultTableDetailReports): number | null {
            const changePriceRow = this.changesPrices.find((value, index) => value.taskId === row.taskId);
            if (changePriceRow !== undefined) {
                const innerIndex = changePriceRow.codeWithPrices.findIndex((item) => {
                    return item.internalCode === row.internalCode
                });
                if (innerIndex !== -1) {
                    return changePriceRow.codeWithPrices[innerIndex].correctedPrice;
                }
            }
            if (row.correctedPromoPrice == null) {
                return null
            } else {
                return parseFloat(String(row.correctedPromoPrice).replace(/^(-)|[^0-9.,]+/g, '$1').replace(',', '.'));
            }
        }

        sendFileToFtpServer() {
            if (this.taskData != null) {
                this.httpSendReportToFtpServer([this.taskData.id])
                    .then((r) => {
                        this.showInfo(this.$t('regular.notifications.reportSentForApproval') as string);
                    })
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.sendReportForApprovalFailed') as string + e.response.data);
                    });
            }
        }

        sendSubTaskToFtpServer(taskId: number) {
            this.httpSendReportToFtpServer([taskId])
                .then((r) => {
                    this.showInfo(this.$t('regular.notifications.reportSentForApproval') as string);
                })
                .catch((exception) => {
                    this.showError(this.$t('regular.errors.sendReportForApprovalFailed') as string + exception.response.data.message);
                });
        }

        fetchAllGeneralSubTasksTableHeaders(ctx: any, callback: (items: any[]) => void) {
            if (this.taskData == null) {
                callback([]);
                return;
            }
            this.httpGetAllSubTasksGeneralPackageHeaders(this.taskData.id, this.subtasksListPerPage, this.subtasksListPerPage * (this.subtasksListCurrentPage - 1))
                .then((r) => {
                        this.resultGeneralSubtasksTableHeaders = r.data;
                        callback(r.data);
                    },
                )
                .catch((e) => {
                    callback([]);
                });
        }

        fetchAllGeneralSubTasksTableHeadersSize(ctx: any, callback: (items: number) => void) {
            if (this.taskData == null) {
                callback(0);
                return;
            }
            this.httpGetAllSubTasksGeneralPackageHeadersSize(this.taskData.id)
                .then((r) => {
                        this.subtasksTotalRows = r.data;
                        callback(r.data);
                    },
                )
                .catch((e) => {
                    callback(0);
                });
        }

        getReportDetailParams(): ReportDetailParams {
            return {
                selectTaskIdFilter: this.selectTaskIdForDetailTable,
                selectGroupFilter: this.selectGroupNameForDetailTable,
                selectCategoryFilter: this.selectCategoryNameForDetailTable,
                selectSubcategoryFilter: this.selectSubcategoryNamesForDetailTable,
                selectFormatFilter: this.selectFormatNameForDetailTable,
                selectRegionFilter: this.selectRegionNameForDetailTable,
                selectClusterFilter: this.selectClusterNameForDetailTable,
                selectSegmentNameFilter: this.selectSegmentNameForDetailTable,
                selectInternalCodeFilter: this.selectInternalCodeForDetailTable,
                selectSkuNameFilter: this.selectSkuNameForDetailTable,
                eventTriggerCondition: this.selectEventTriggerForDetailTable.value,
                kviCondition: this.selectKVIForDetailTable.value,
                ctmCondition: this.selectCTMForDetailTable.value,
                selectCtmBrandFilter: this.selectCtmBrandForDetailTable,
                selectCtmPriceGapFilter: this.selectCtmPriceGapForDetailTable,
                selectMinRetailPriceFilter: this.selectMinRetailPriceForDetailTable,
                selectMaxRetailPriceFilter: this.selectMaxRetailPriceForDetailTable,
                selectKeyProduct1Filter: this.selectKeyProduct1ForDetailTable,
                selectKeyProduct2Filter: this.selectKeyProduct2ForDetailTable,
                selectRecipeAttributeFilter: this.selectRecipeAttributeForDetailTable,
                selectTreatmentAttributeFilter: this.selectTreatmentAttributeForDetailTable,
                selectVitalMedicineFilter: this.selectVitalMedicineForDetailTable.value,
                selectProducerPriceFilter: this.selectProducerPriceForDetailTable,
                selectExtraChargePcFilter: this.selectExtraChargePcForDetailTable,
                selectRegistrationPriceFilter: this.selectRegistrationPriceForDetailTable,
                priceSegmentsForDetailReport: this.selectSegmentPriceForDetailTable,
                selectSkuLineFilter: this.selectSkuLineForDetailTable,
                selectPurchasePriceFilter: this.selectPurchasePriceForDetailTable,
                selectPromoPurchasePriceFilter: this.selectPromoPurchasePriceForDetailTable,
                selectAvgRegularPriceFilter: this.selectAvgRegularPriceForDetailTable,
                selectAvgCashPriceFilter: this.selectAvgCashPriceForDetailTable,
                selectAvgCheckPriceFilter: this.selectAvgCheckPriceForDetailTable,
                selectRegularPriceFilter: this.selectRegularPriceForDetailTable,
                selectMarginLastPriceFilter: this.selectMarginLastPriceForDetailTable,
                selectMinCompetitorPriceFilter: this.selectMinCompetitorPriceForDetailTable,
                selectMinCompetitorNameFilter: this.selectMinCompetitorNameForDetailTable,
                selectMinCompetitorCodeFilter: [],
                selectMaxCompetitorPriceFilter: this.selectMaxCompetitorPriceForDetailTable,
                selectMaxCompetitorNameFilter: this.selectMaxCompetitorNameForDetailTable,
                selectMaxCompetitorCodeFilter: [],
                selectAvgCompetitorPriceFilter: this.selectAvgCompetitorPriceForDetailTable,
                selectLastCompetitorPriceFilter: this.selectLastCompetitorPriceForDetailTable,
                selectMinPromoCompetitorPriceFilter: this.selectMinPromoCompetitorPriceForDetailTable,
                selectMinPromoCompetitorNameFilter: this.selectMinPromoCompetitorNameForDetailTable,
                selectMinPromoCompetitorCodeFilter: [],
                selectMaxPromoCompetitorPriceFilter: this.selectMaxPromoCompetitorPriceForDetailTable,
                selectMaxPromoCompetitorNameFilter: this.selectMaxPromoCompetitorNameForDetailTable,
                selectMaxPromoCompetitorCodeFilter: [],
                selectMedianPromoCompetitorPriceFilter: this.selectMedianPromoCompetitorPriceForDetailTable,
                selectLastPromoCompetitorPriceFilter: this.selectLastPromoCompetitorPriceForDetailTable,
                selectPiFilter: this.selectPiForDetailTable,
                selectActualSalesFilter: this.selectActualSalesForDetailTable,
                selectActualRevenueFilter: this.selectActualRevenueForDetailTable,
                selectActualMarginFilter: this.selectActualMarginForDetailTable,
                selectActualMarginPercentFilter: this.selectActualMarginPercentForDetailTable,
                selectComparableSalesFilter: this.selectComparableSalesForDetailTable,
                selectComparableRevenueFilter: this.selectComparableRevenueForDetailTable,
                selectComparableMarginFilter: this.selectComparableMarginForDetailTable,
                selectComparableMarginPcFilter: this.selectComparableMarginPcForDetailTable,
                selectNewPriceFilter: this.selectNewPriceForDetailTable,
                selectNewPromoPriceFilter: this.selectNewPromoPriceForDetailTable,
                selectCorrectedRegularPriceFilter: this.selectCorrectedRegularPriceForDetailTable,
                selectCorrectedPromoPriceFilter: this.selectCorrectedPromoPriceForDetailTable,
                selectNewMarginPcFilter: this.selectNewMarginPcForDetailTable,
                selectNewPIFilter: this.selectNewPIForDetailTable,
                selectDeltaDiffPriceFilter: this.selectDeltaDiffPriceForDetailTable,
                selectPriceDiffPcFilter: this.selectPriceDiffPcForDetailTable,
                selectMarginDiffFilter: this.selectMarginDiffForDetailTable,
                selectChangedPIFilter: this.selectChangedPIForDetailTable,
                selectDiscountDepthFilter: this.selectDiscountDepthForDetailTable,
                selectDiscountDurationFilter: this.selectDiscountDurationForDetailTable,
                selectExitSegmentFilter: this.selectExitSegmentForDetailTable,
                selectCoeffElasticityFilter: this.selectCoeffElasticityForDetailTable,
                selectPromoCoeffElasticityFilter: this.selectPromoCoeffElasticityForDetailTable,
                selectSalesForecastFilter: this.selectSalesForecastForDetailTable,
                selectRevenueForecastFilter: this.selectRevenueForecastForDetailTable,
                selectMarginForecastFilter: this.selectMarginForecastForDetailTable,
                selectMarginForecastPcFilter: this.selectMarginForecastPcForDetailTable,
                selectChangeSalesFilter: this.selectChangeSalesForDetailTable,
                selectChangeRevenueFilter: this.selectChangeRevenueForDetailTable,
                selectChangeMarginFilter: this.selectChangeMarginForDetailTable,
                selectSalesDiffPcFilter: this.selectSalesDiffPcForDetailTable,
                selectRevenueDiffPcFilter: this.selectRevenueDiffPcForDetailTable,
                selectMarginDiffPcFilter: this.selectMarginDiffPcForDetailTable,
                selectMarginDiffSecondFilter: this.selectMarginDiffSecondForDetailTable,
                selectIndividualPromoTypeFilter: this.selectIndividualPromoTypeForDetailTable,
                selectIndividualPromoLiftFilter: this.selectIndividualPromoLiftForDetailTable,
                selectSalesForecastByRegularPriceFilter: this.selectSalesForecastByRegularPriceForDetailTable,
                selectRevenueForecastByRegularPriceFilter: this.selectRevenueForecastByRegularPriceForDetailTable,
                selectMarginForecastByRegularPriceFilter: this.selectMarginForecastByRegularPriceForDetailTable,
                selectMarginForecastByRegularPricePcFilter: this.selectMarginForecastByRegularPricePcForDetailTable,
                selectChangeSalesByRegularPriceFilter: this.selectChangeSalesByRegularPriceForDetailTable,
                selectChangeRevenueByRegularPriceFilter: this.selectChangeRevenueByRegularPriceForDetailTable,
                selectChangeMarginByRegularPriceFilter: this.selectChangeMarginByRegularPriceForDetailTable,
                selectSalesDiffPcByRegularPriceFilter: this.selectSalesDiffPcByRegularPriceForDetailTable,
                selectRevenueDiffPcByRegularPriceFilter: this.selectRevenueDiffPcByRegularPriceForDetailTable,
                selectMarginDiffPcByRegularPriceFilter: this.selectMarginDiffPcByRegularPriceForDetailTable,
                selectMarginDiffSecondByRegularPriceFilter: this.selectMarginDiffSecondByRegularPriceForDetailTable,
                selectIndividualPriceOptStrategyFilter: this.selectIndividualPriceOptStrategyForDetailTable,
                selectIndividualPriceIncreaseLimitFilter: this.selectIndividualPriceIncreaseLimitForDetailTable,
                selectIndividualPeriodPriceIncreaseLimitFilter: this.selectIndividualPeriodPriceIncreaseLimitForDetailTable,
                selectIndividualPeriodFilter: this.selectIndividualPeriodForDetailTable,
                selectIndividualMarginalProfitFilter: this.selectIndividualMarginalProfitForDetailTable,
                selectIndividualKviStrategyFilter: this.selectIndividualKviStrategyForDetailTable,
                selectIndividualPercentCorrectionFilter: this.selectIndividualPercentCorrectionForDetailTable,
                selectIndividualNewProductPriceStrategyFilter: this.selectIndividualNewProductPriceStrategyForDetailTable,
                selectIndividualPriceGapPercentFilter: this.selectIndividualPriceGapPercentForDetailTable,
                selectBatchNumberFilter: this.selectBatchNumberForDetailTable,
                selectApprovedByFioFilter: this.selectApprovedByFioForDetailTable,
                selectIsApprovedFilter: this.getTransformedApprovalFilter(),
                selectPriceExperimentFilter: [],
                selectProductVerticalLineFilter: this.selectProductVerticalLineForDetailTable,
                selectDetailedStatusFilter: [],
                selectSalePointsFilter: this.selectSalePointCodesForDetailTable,

                sortingField: this.sortingField,
                detailTableSkuFilter: this.detailTableSkuFilter.trim(),
                // tslint:disable-next-line: no-non-null-assertion
                taskType: this.taskData!!.type,
                selectActiveProductsOnly: this.selectActiveProductsOnly,
            }
        }

        getTransformedApprovalFilter(): string[] {
            const result: string[] = [];
            for (const value of this.selectIsApprovedForDetailTable) {
                if (value === 'APPROVED') {
                    result.push(ApprovalStatus.APPROVED_AUTOMATICALLY);
                    result.push(ApprovalStatus.APPROVED_MANUALLY);
                } else {
                    result.push(value);
                }
            }
            return result;
        }

        fetchResultTableDetailReports() {
            if (this.taskData == null) {
                return;
            }
            const offset = (this.pagination.current - 1) * this.pagination.pageSize;
            const params = this.getReportDetailParams();

            this.tableIsLoading = true;

            this.httpGetResultTableDetailReports(this.taskData.id, this.pagination.pageSize, offset, params, false)
                .then((r) => {
                        this.pagination.total = r.data.totalElements;
                        this.resultTableDetailReports = r.data.content.map(el => ({...el, newPriceHistory: el.newPriceHistory ? el.newPriceHistory: '-'}));
                        this.detailReportTotalRows = r.data.totalElements;
                        this.disableSelectedReports = true;
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadReportNumbersFailed') as string);
                }).finally(() => {
                    this.tableIsLoading = false;
                });

            if (!this.isDownloadAllFiltersName) {
                this.getResultTableDetailAllFiltersNames();
                this.isDownloadAllFiltersName = true
            }
            if (this.segmentPriceOptionsForDetailTable.length === 0) {
                this.getSegmentPriceForDetailReport();
            }

            this.httpGetAllReportDetailIdsByFilters(this.taskData.id, params)
                .then((response) => {
                    this.allTaskIdWithInternalCodesByFilters = response.data;
                    // Создаем снимок отфильтрованных данных и определяем активность фильтра
                    this.updateFilterSnapshot(params);
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadReportNumbersFailed') as string);
                });
        }


        getResultTableDetailAllFiltersNames() {
            // tslint:disable-next-line: no-non-null-assertion
            this.httpGetResultTableDetailsFilterNames(this.taskData!!.id, this.taskData!!.type)
                .then((r) => {
                    const result = r.data
                    this.taskIdOptionsForDetailTable = result.taskIds.map((taskId) => {
                        return {value: taskId, label: taskId.toString()};
                    });
                    this.groupNamesOptionsForDetailTable = result.groupNames.map((group) => {
                        return {value: group, label: group};
                    });
                    this.categoryNamesOptionsForDetailTable = result.categoryNames.map((category) => {
                        return {value: category, label: category};
                    });
                    this.subcategoryNamesOptionsForDetailTable = result.subCategoryNames.map((subCat) => {
                        return {value: subCat, label: subCat};
                    });
                    this.formatNamesOptionsForDetailTable = result.formatNames.map((format) => {
                        return {value: format, label: format};
                    });
                    this.regionNamesOptionsForDetailTable = result.regionNames.map((region) => {
                        return {value: region, label: region};
                    });
                    this.clusterNamesOptionsForDetailTable = result.clusterNames.map((cluster) => {
                        return {value: cluster, label: cluster};
                    });
                    this.segmentNamesOptionsForDetailTable = result.segmentNames.map((segmentName) => {
                        return {value: segmentName, label: segmentName};
                    });
                    this.internalCodesOptionsForDetailTable = result.internalCodes.map((internalCode) => {
                        return {value: internalCode, label: internalCode};
                    });
                    this.skuNamesOptionsForDetailTable = result.skuNames.map((skuName) => {
                        return {value: skuName, label: skuName};
                    });
                    this.kviOptions = [
                        {value: -1, label: this.$t('regular.common.all') as string},
                        {value: 1, label: 'KVI'},
                        {value: 0, label: this.$t('regular.columns.notKvi') as string},
                    ];
                    this.ctmOptionsForDetailTable = [
                        {value: -1, label: this.$t('regular.common.all') as string},
                        {value: 1, label: 'CTM'},
                        {value: 0, label: this.$t('regular.columns.notCtm') as string},
                    ];
                    this.ctmBrandsOptionsForDetailTable = result.ctmBrands.map((ctmBrand) => {
                        return {value: ctmBrand, label: ctmBrand};
                    });
                    this.ctmPriceGapOptionsForDetailTable = result.ctmPriceGaps.map((ctmPriceGap) => {
                        return {value: ctmPriceGap, label: ctmPriceGap.toString()};
                    });
                    this.minRetailPriceOptionsForDetailTable = result.minRetailPrices.map((minRetailPrice) => {
                        return {value: minRetailPrice, label: minRetailPrice.toString()};
                    });
                    this.maxRetailPriceOptionsForDetailTable = result.maxRetailPrices.map((maxRetailPrice) => {
                        return {value: maxRetailPrice, label: maxRetailPrice.toString()};
                    });
                    this.keyProduct1OptionsForDetailTable = result.keyProducts1.map((keyProduct1) => {
                        return {value: keyProduct1, label: keyProduct1};
                    });
                    this.keyProduct2OptionsForDetailTable = result.keyProducts2.map((keyProduct2) => {
                        return {value: keyProduct2, label: keyProduct2};
                    });
                    this.recipeAttributeOptionsForDetailTable = result.recipeAttributes.map((recipeAttribute) => {
                        return {value: recipeAttribute, label: recipeAttribute};
                    });
                    this.treatmentAttributeOptionsForDetailTable = result.treatmentAttributes.map((treatmentAttribute) => {
                        return {value: treatmentAttribute, label: treatmentAttribute.toString()};
                    });
                    this.producerPricesOptionsForDetailTable = result.producerPrices.map((producerPrice) => {
                        return {value: producerPrice, label: producerPrice.toString()};
                    });
                    this.extraChargePcsOptionsForDetailTable = result.extraChargePcs.map((extraChargePc) => {
                        return {value: extraChargePc, label: extraChargePc.toString()};
                    });
                    this.registrationPricesOptionsForDetailTable = result.registrationPrices.map((registrationPrice) => {
                        return {value: registrationPrice, label: registrationPrice.toString()};
                    });
                    this.skuLineOptionsForDetailTable = result.skuLines.map((skuLine) => {
                        return {value: skuLine, label: skuLine};
                    });
                    this.purchasePriceOptionsForDetailTable = result.purchasePrices.map((purchasePrice) => {
                        return {value: purchasePrice, label: purchasePrice.toString()};
                    });
                    this.promoPurchasePriceOptionsForDetailTable = result.promoPurchasePrices.map((promoPurchasePrice) => {
                        return {value: promoPurchasePrice, label: promoPurchasePrice.toString()};
                    });
                    this.avgRegularPriceOptionsForDetailTable = result.avgRegularPrices.map((avgRegularPrice) => {
                        return {value: avgRegularPrice, label: avgRegularPrice.toString()};
                    });
                    this.avgCashPriceOptionsForDetailTable = result.avgCashPrices.map((avgCashPrice) => {
                        return {value: avgCashPrice, label: avgCashPrice.toString()};
                    });
                    this.avgCheckPriceOptionsForDetailTable = result.avgCheckPrices.map((avgCheckPrice) => {
                        return {value: avgCheckPrice, label: avgCheckPrice.toString()};
                    });
                    this.regularPriceOptionsForDetailTable = result.regularPrices.map((regularPrice) => {
                        return {value: regularPrice, label: regularPrice.toString()};
                    });
                    this.marginLastPriceOptionsForDetailTable = result.marginLastPrices.map((marginLastPrice) => {
                        return {value: marginLastPrice, label: marginLastPrice.toString()};
                    });
                    this.minCompetitorPriceOptionsForDetailTable = result.minCompetitorPrices.map((minCompetitorPrice) => {
                        return {value: minCompetitorPrice, label: minCompetitorPrice.toString()};
                    });
                    this.minCompetitorNameOptionsForDetailTable = result.minCompetitorNames.map((minCompetitorName) => {
                        return {value: minCompetitorName, label: minCompetitorName};
                    });
                    this.maxCompetitorPriceOptionsForDetailTable = result.maxCompetitorPrices.map((maxCompetitorPrice) => {
                        return {value: maxCompetitorPrice, label: maxCompetitorPrice.toString()};
                    });
                    this.maxCompetitorNameOptionsForDetailTable = result.maxCompetitorNames.map((maxCompetitorName) => {
                        return {value: maxCompetitorName, label: maxCompetitorName};
                    });
                    this.avgCompetitorPriceOptionsForDetailTable = result.avgCompetitorPrices.map((avgCompetitorPrice) => {
                        return {value: avgCompetitorPrice, label: avgCompetitorPrice.toString()};
                    });
                    this.lastCompetitorPriceOptionsForDetailTable = result.lastCompetitorPrices.map((lastCompetitorPrice) => {
                        return {value: lastCompetitorPrice, label: lastCompetitorPrice.toString()};
                    });
                    this.minPromoCompetitorPriceOptionsForDetailTable = result.minPromoCompetitorPrices.map((minPromoCompetitorPrice) => {
                        return {value: minPromoCompetitorPrice, label: minPromoCompetitorPrice.toString()};
                    });
                    this.minPromoCompetitorNameOptionsForDetailTable = result.minPromoCompetitorNames.map((minPromoCompetitorName) => {
                        return {value: minPromoCompetitorName, label: minPromoCompetitorName};
                    });
                    this.maxPromoCompetitorPriceOptionsForDetailTable = result.maxPromoCompetitorPrices.map((maxPromoCompetitorPrice) => {
                        return {value: maxPromoCompetitorPrice, label: maxPromoCompetitorPrice.toString()};
                    });
                    this.maxPromoCompetitorNameOptionsForDetailTable = result.maxPromoCompetitorNames.map((maxPromoCompetitorName) => {
                        return {value: maxPromoCompetitorName, label: maxPromoCompetitorName};
                    });
                    this.medianPromoCompetitorPriceOptionsForDetailTable = result.medianPromoCompetitorPrices.map((medianPromoCompetitorPrice) => {
                        return {value: medianPromoCompetitorPrice, label: medianPromoCompetitorPrice.toString()};
                    });
                    this.lastPromoCompetitorPriceOptionsForDetailTable = result.lastPromoCompetitorPrices.map((lastPromoCompetitorPrice) => {
                        return {value: lastPromoCompetitorPrice, label: lastPromoCompetitorPrice.toString()};
                    });
                    this.piOptionsForDetailTable = result.piValues.map((piValue) => {
                        return {value: piValue, label: piValue.toString()};
                    });
                    this.actualSalesOptionsForDetailTable = result.actualSales.map((actualSales) => {
                        return {value: actualSales, label: actualSales.toString()};
                    });
                    this.actualRevenueOptionsForDetailTable = result.actualRevenues.map((actualRevenue) => {
                        return {value: actualRevenue, label: actualRevenue.toString()};
                    });
                    this.actualMarginOptionsForDetailTable = result.actualMargins.map((actualMargin) => {
                        return {value: actualMargin, label: actualMargin.toString()};
                    });
                    this.actualMarginPercentOptionsForDetailTable = result.actualMarginPercents.map((actualMarginPercent) => {
                        return {value: actualMarginPercent, label: actualMarginPercent.toString()};
                    });
                    this.comparableSalesOptionsForDetailTable = result.comparableSales.map((comparableSale) => {
                        return {value: comparableSale, label: comparableSale.toString()};
                    });
                    this.comparableRevenueOptionsForDetailTable = result.comparableRevenues.map((comparableRevenue) => {
                        return {value: comparableRevenue, label: comparableRevenue.toString()};
                    });
                    this.comparableMarginOptionsForDetailTable = result.comparableMargins.map((comparableMargin) => {
                        return {value: comparableMargin, label: comparableMargin.toString()};
                    });
                    this.comparableMarginPcOptionsForDetailTable = result.comparableMarginPcs.map((comparableMarginPc) => {
                        return {value: comparableMarginPc, label: comparableMarginPc.toString()};
                    });
                    this.newPriceOptionsForDetailTable = result.newPrices.map((newPrice) => {
                        return {value: newPrice, label: newPrice.toString()};
                    });
                    this.newPromoPriceOptionsForDetailTable = result.newPromoPrices.map((newPromoPrice) => {
                        return {value: newPromoPrice, label: newPromoPrice.toString()};
                    });
                    this.correctedRegularPriceOptionsForDetailTable = result.correctedRegularPrices.map((correctedRegularPrice) => {
                        return {value: correctedRegularPrice, label: correctedRegularPrice.toString()};
                    });
                    this.correctedPromoPriceOptionsForDetailTable = result.correctedPromoPrices.map((correctedPromoPrice) => {
                        return {value: correctedPromoPrice, label: correctedPromoPrice.toString()};
                    });
                    this.newMarginPcOptionsForDetailTable = result.newMarginPcs.map((newMarginPc) => {
                        return {value: newMarginPc, label: newMarginPc.toString()};
                    });
                    this.newPIOptionsForDetailTable = result.newPIs.map((newPI) => {
                        return {value: newPI, label: newPI.toString()};
                    });
                    this.deltaDiffPriceOptionsForDetailTable = result.deltaDiffPrices.map((deltaDiffPrice) => {
                        return {value: deltaDiffPrice, label: deltaDiffPrice.toString()};
                    });
                    this.priceDiffPcOptionsForDetailTable = result.priceDiffPcs.map((priceDiffPc) => {
                        return {value: priceDiffPc, label: priceDiffPc.toString()};
                    });
                    this.marginDiffOptionsForDetailTable = result.marginDiffs.map((marginDiff) => {
                        return {value: marginDiff, label: marginDiff.toString()};
                    });
                    this.changedPIPcOptionsForDetailTable = result.changedPIs.map((changedPI) => {
                        return {value: changedPI, label: changedPI.toString()};
                    });
                    this.discountDepthOptionsForDetailTable = result.discountDepths.map((discountDepth) => {
                        return {value: discountDepth, label: discountDepth.toString()};
                    });
                    this.discountDurationOptionsForDetailTable = result.discountDurations.map((discountDuration) => {
                        return {value: discountDuration, label: discountDuration.toString()};
                    });
                    this.exitSegmentOptionsForDetailTable = result.exitSegments.map((exitSegment) => {
                        return {value: exitSegment, label: exitSegment};
                    });
                    this.coeffElasticityPcOptionsForDetailTable = result.coeffElasticitys.map((coeffElasticity) => {
                        return {value: coeffElasticity, label: coeffElasticity.toString()};
                    });
                    this.promoCoeffElasticityPcOptionsForDetailTable = result.promoCoeffElasticitys.map((promoCoeffElasticity) => {
                        return {value: promoCoeffElasticity, label: promoCoeffElasticity.toString()};
                    });
                    this.salesForecastOptionsForDetailTable = result.salesForecasts.map((salesForecast) => {
                        return {value: salesForecast, label: salesForecast.toString()};
                    });
                    this.revenueForecastOptionsForDetailTable = result.revenueForecasts.map((revenueForecast) => {
                        return {value: revenueForecast, label: revenueForecast.toString()};
                    });
                    this.marginForecastOptionsForDetailTable = result.marginForecasts.map((marginForecast) => {
                        return {value: marginForecast, label: marginForecast.toString()};
                    });
                    this.marginForecastPcOptionsForDetailTable = result.marginForecastPcs.map((marginForecastPc) => {
                        return {value: marginForecastPc, label: marginForecastPc.toString()};
                    });
                    this.changeSalesOptionsForDetailTable = result.changeSales.map((changeSale) => {
                        return {value: changeSale, label: changeSale.toString()};
                    });
                    this.changeRevenueOptionsForDetailTable = result.changeRevenues.map((changeRevenue) => {
                        return {value: changeRevenue, label: changeRevenue.toString()};
                    });
                    this.changeMarginOptionsForDetailTable = result.changeMargins.map((changeMargin) => {
                        return {value: changeMargin, label: changeMargin.toString()};
                    });
                    this.salesDiffPcOptionsForDetailTable = result.salesDiffPcs.map((salesDiffPc) => {
                        return {value: salesDiffPc, label: salesDiffPc.toString()};
                    });
                    this.revenueDiffPcOptionsForDetailTable = result.revenueDiffPcs.map((revenueDiffPc) => {
                        return {value: revenueDiffPc, label: revenueDiffPc.toString()};
                    });
                    this.marginDiffPcOptionsForDetailTable = result.marginDiffPcs.map((marginDiffPc) => {
                        return {value: marginDiffPc, label: marginDiffPc.toString()};
                    });
                    this.marginDiffSecondOptionsForDetailTable = result.marginDiffSeconds.map((marginDiffSecond) => {
                        return {value: marginDiffSecond, label: marginDiffSecond.toString()};
                    });
                    this.individualPromoTypeOptionsForDetailTable = result.individualPromoTypes.map((individualPromoType) => {
                        return {value: individualPromoType, label: individualPromoType};
                    });
                    this.individualPromoLiftOptionsForDetailTable = result.individualPromoLifts.map((individualPromoLift) => {
                        return {value: individualPromoLift, label: individualPromoLift.toString()};
                    });
                    this.salesForecastByRegularPriceOptionsForDetailTable = result.salesForecastByRegularPrices.map((salesForecastByRegularPrice) => {
                        return {value: salesForecastByRegularPrice, label: salesForecastByRegularPrice.toString()};
                    });
                    this.revenueForecastByRegularPriceOptionsForDetailTable = result.revenueForecastByRegularPrices.map((revenueForecastByRegularPrice) => {
                        return {value: revenueForecastByRegularPrice, label: revenueForecastByRegularPrice.toString()};
                    });
                    this.marginForecastByRegularPriceOptionsForDetailTable = result.marginForecastByRegularPrices.map((marginForecastByRegularPrice) => {
                        return {value: marginForecastByRegularPrice, label: marginForecastByRegularPrice.toString()};
                    });
                    this.marginForecastByRegularPricePcOptionsForDetailTable = result.marginForecastByRegularPricePcs.map((marginForecastByRegularPricePc) => {
                        return {value: marginForecastByRegularPricePc, label: marginForecastByRegularPricePc.toString()};
                    });
                    this.changeSalesByRegularPriceOptionsForDetailTable = result.changeSalesByRegularPrices.map((changeSalesByRegularPrice) => {
                        return {value: changeSalesByRegularPrice, label: changeSalesByRegularPrice.toString()};
                    });
                    this.changeRevenueByRegularPriceOptionsForDetailTable = result.changeRevenueByRegularPrices.map((changeRevenueByRegularPrice) => {
                        return {value: changeRevenueByRegularPrice, label: changeRevenueByRegularPrice.toString()};
                    });
                    this.changeMarginByRegularPriceOptionsForDetailTable = result.changeMarginByRegularPrices.map((changeMarginByRegularPrice) => {
                        return {value: changeMarginByRegularPrice, label: changeMarginByRegularPrice.toString()};
                    });
                    this.salesDiffPcByRegularPriceOptionsForDetailTable = result.salesDiffPcByRegularPrices.map((salesDiffPcByRegularPrice) => {
                        return {value: salesDiffPcByRegularPrice, label: salesDiffPcByRegularPrice.toString()};
                    });
                    this.revenueDiffPcByRegularPriceOptionsForDetailTable = result.revenueDiffPcByRegularPrices.map((revenueDiffPcByRegularPrice) => {
                        return {value: revenueDiffPcByRegularPrice, label: revenueDiffPcByRegularPrice.toString()};
                    });
                    this.marginDiffPcByRegularPriceOptionsForDetailTable = result.marginDiffPcByRegularPrices.map((marginDiffPcByRegularPrice) => {
                        return {value: marginDiffPcByRegularPrice, label: marginDiffPcByRegularPrice.toString()};
                    });
                    this.marginDiffSecondByRegularPriceOptionsForDetailTable = result.marginDiffSecondByRegularPrices.map((marginDiffSecondByRegularPrice) => {
                        return {value: marginDiffSecondByRegularPrice, label: marginDiffSecondByRegularPrice.toString()};
                    });
                    this.individualPriceOptStrategyOptionsForDetailTable = result.individualPriceOptStrategy.map((individualPriceOptStrategy) => {
                        return {value: individualPriceOptStrategy, label: individualPriceOptStrategy};
                    });
                    this.individualPriceIncreaseLimitOptionsForDetailTable = result.individualPriceIncreaseLimits.map((individualPriceIncreaseLimit) => {
                        return {value: individualPriceIncreaseLimit, label: individualPriceIncreaseLimit.toString()};
                    });
                    this.individualPeriodPriceIncreaseLimitOptionsForDetailTable = result.individualPeriodPriceIncreaseLimits.map((individualPeriodPriceIncreaseLimit) => {
                        return {value: individualPeriodPriceIncreaseLimit, label: individualPeriodPriceIncreaseLimit.toString()};
                    });
                    this.individualPeriodOptionsForDetailTable = result.individualPeriods.map((individualPeriod) => {
                        return {value: individualPeriod, label: individualPeriod};
                    });
                    this.individualMarginalProfitOptionsForDetailTable = result.individualMarginalProfits.map((individualMarginalProfit) => {
                        return {value: individualMarginalProfit, label: individualMarginalProfit.toString()};
                    });
                    this.individualKviStrategyOptionsForDetailTable = result.individualKviStrategys.map((individualKviStrategy) => {
                        return {value: individualKviStrategy, label: individualKviStrategy};
                    });
                    this.individualPercentCorrectionOptionsForDetailTable = result.individualPercentCorrections.map((individualPercentCorrection) => {
                        return {value: individualPercentCorrection, label: individualPercentCorrection};
                    });
                    this.individualNewProductPriceStrategyOptionsForDetailTable = result.individualNewProductPriceStrategys.map((individualNewProductPriceStrategy) => {
                        return {value: individualNewProductPriceStrategy, label: individualNewProductPriceStrategy};
                    });
                    this.individualPriceGapPercentOptionsForDetailTable = result.individualPriceGapPercents.map((individualPriceGapPercents) => {
                        return {value: individualPriceGapPercents, label: individualPriceGapPercents.toString()};
                    });
                    this.batchNumberOptionsForDetailTable = result.batchNumbers.map((batchNumbers) => {
                        return {value: batchNumbers, label: batchNumbers};
                    });
                    this.approvedByFioOptionsForDetailTable = result.approvedByFioList.map((approvedByFio) => {
                        return {value: approvedByFio, label: approvedByFio}
                    });
                    
                    // Добавляем опции для фильтрации статусов согласования
                    this.isApprovedOptionsForDetailTable = [
                        {value: 'APPROVED', label: this.$t('regular.statuses.agreedStatus') as string},
                        {value: ApprovalStatus.NOT_APPROVED, label: this.$t('regular.statuses.notApproved') as string}
                    ];
                    this.productVerticalLineOptionsForDetailTable = result.productVerticalLines.map((productVerticalLine) => {
                        return {value: productVerticalLine, label: productVerticalLine}
                    });
                    this.salePointCodeOptionsForDetailTable = result.salePointCodes.map((salePointCode) => {
                        return {value: salePointCode, label: salePointCode.toString()};
                    });

                    const columnsWithEmptyOption = ['keyProduct1', 'keyProduct2', 'skuLine', 'minCompetitorName', 'maxCompetitorName', 'productVerticalLine', 'deltaDiffPrice'];

                    columnsWithEmptyOption.forEach(columnName => {
                        if ((this as any)[`${columnName}OptionsForDetailTable`]) {
                            (this as any)[`${columnName}OptionsForDetailTable`] = [{value: 'EMPTY_VALUE', label: this.$t('regular.columns.noValueEmpty') as string}, ...(this as any)[`${columnName}OptionsForDetailTable`]]
                        }
                    })

                    setTimeout(() => {
                        const fields = (() => {
                            switch (this.reportType) {
                                case 'promo':
                                    return [...this.promoDetailReport];
                                case 'sales':
                                    return [...this.salesDetailReport];
                                default:
                                    return [...this.regularDetailReport];
                            }
                        })();

                        fields.forEach((item) => {
                            this.tableFilterOptions[item.dataIndex] = this.getFilters(item.dataIndex);
                        });

                        if (this.reportType === 'promo') {
                            this.promoDetailReport = fields;
                        } else if (this.reportType === 'sales') {
                            this.salesDetailReport = fields;
                        } else {
                            this.regularDetailReport = fields;
                        }
                    }, 1000);
                }).catch((err) => {
                    console.log(err)
            });
        }

        resetTableSortingField() {
            this.sortingField = null;
        }

        resetAllFiltersFields() {
            this.selectTaskIdForDetailTable = []
            this.selectGroupNameForDetailTable = []
            this.selectCategoryNameForDetailTable = []
            this.selectSubcategoryNamesForDetailTable = []
            this.selectFormatNameForDetailTable = []
            this.selectRegionNameForDetailTable = []
            this.selectClusterNameForDetailTable = []
            this.selectSegmentNameForDetailTable = []
            this.selectInternalCodeForDetailTable = []
            this.selectSkuNameForDetailTable = []
            this.selectEventTriggerForDetailTable = this.defaultFilterValue;
            this.selectKVIForDetailTable = this.defaultFilterValue;
            this.selectCTMForDetailTable = this.defaultFilterValue;
            this.selectCtmBrandForDetailTable = []
            this.selectCtmPriceGapForDetailTable = []
            this.selectMinRetailPriceForDetailTable = []
            this.selectMaxRetailPriceForDetailTable = []
            this.selectKeyProduct1ForDetailTable = []
            this.selectKeyProduct2ForDetailTable = []
            this.selectRecipeAttributeForDetailTable = []
            this.selectTreatmentAttributeForDetailTable = []
            this.selectVitalMedicineForDetailTable = this.defaultFilterValue;
            this.selectProducerPriceForDetailTable = []
            this.selectExtraChargePcForDetailTable = []
            this.selectRegistrationPriceForDetailTable = []
            this.selectSegmentPriceForDetailTable = []
            this.selectSkuLineForDetailTable = []
            this.selectPurchasePriceForDetailTable = []
            this.selectPromoPurchasePriceForDetailTable = []
            this.selectAvgRegularPriceForDetailTable = []
            this.selectAvgCashPriceForDetailTable = []
            this.selectAvgCheckPriceForDetailTable = []
            this.selectRegularPriceForDetailTable = []
            this.selectMarginLastPriceForDetailTable = []
            this.selectMinCompetitorPriceForDetailTable = []
            this.selectMinCompetitorNameForDetailTable = []
            this.selectMaxCompetitorPriceForDetailTable = []
            this.selectMaxCompetitorNameForDetailTable = []
            this.selectAvgCompetitorPriceForDetailTable = []
            this.selectLastCompetitorPriceForDetailTable = []
            this.selectMinPromoCompetitorPriceForDetailTable = []
            this.selectMinPromoCompetitorNameForDetailTable = []
            this.selectMaxPromoCompetitorPriceForDetailTable = []
            this.selectMaxPromoCompetitorNameForDetailTable = []
            this.selectMedianPromoCompetitorPriceForDetailTable = []
            this.selectLastPromoCompetitorPriceForDetailTable = []
            this.selectPiForDetailTable = []
            this.selectActualSalesForDetailTable = []
            this.selectActualRevenueForDetailTable = []
            this.selectActualMarginForDetailTable = []
            this.selectActualMarginPercentForDetailTable = []
            this.selectComparableSalesForDetailTable = []
            this.selectComparableRevenueForDetailTable = []
            this.selectComparableMarginForDetailTable = []
            this.selectComparableMarginPcForDetailTable = []
            this.selectNewPriceForDetailTable = []
            this.selectNewPromoPriceForDetailTable = []
            this.selectCorrectedRegularPriceForDetailTable = []
            this.selectCorrectedPromoPriceForDetailTable = []
            this.selectNewMarginPcForDetailTable = []
            this.selectNewPIForDetailTable = []
            this.selectDeltaDiffPriceForDetailTable = []
            this.selectPriceDiffPcForDetailTable = []
            this.selectMarginDiffForDetailTable = []
            this.selectChangedPIForDetailTable = []
            this.selectDiscountDepthForDetailTable = []
            this.selectDiscountDurationForDetailTable = []
            this.selectExitSegmentForDetailTable = []
            this.selectCoeffElasticityForDetailTable = []
            this.selectPromoCoeffElasticityForDetailTable = []
            this.selectSalesForecastForDetailTable = []
            this.selectRevenueForecastForDetailTable = []
            this.selectMarginForecastForDetailTable = []
            this.selectMarginForecastPcForDetailTable = []
            this.selectChangeSalesForDetailTable = []
            this.selectChangeRevenueForDetailTable = []
            this.selectChangeMarginForDetailTable = []
            this.selectSalesDiffPcForDetailTable = []
            this.selectRevenueDiffPcForDetailTable = []
            this.selectMarginDiffPcForDetailTable = []
            this.selectMarginDiffSecondForDetailTable = []
            this.selectIndividualPromoTypeForDetailTable = []
            this.selectIndividualPromoLiftForDetailTable = []
            this.selectSalesForecastByRegularPriceForDetailTable = []
            this.selectRevenueForecastByRegularPriceForDetailTable = []
            this.selectMarginForecastByRegularPriceForDetailTable = []
            this.selectMarginForecastByRegularPricePcForDetailTable = []
            this.selectChangeSalesByRegularPriceForDetailTable = []
            this.selectChangeRevenueByRegularPriceForDetailTable = []
            this.selectChangeMarginByRegularPriceForDetailTable = []
            this.selectSalesDiffPcByRegularPriceForDetailTable = []
            this.selectRevenueDiffPcByRegularPriceForDetailTable = []
            this.selectMarginDiffPcByRegularPriceForDetailTable = []
            this.selectMarginDiffSecondByRegularPriceForDetailTable = []
            this.selectIndividualPriceOptStrategyForDetailTable = []
            this.selectIndividualPriceIncreaseLimitForDetailTable = []
            this.selectIndividualPeriodPriceIncreaseLimitForDetailTable = []
            this.selectIndividualPeriodForDetailTable = []
            this.selectIndividualMarginalProfitForDetailTable = []
            this.selectIndividualKviStrategyForDetailTable = []
            this.selectIndividualPercentCorrectionForDetailTable = []
            this.selectIndividualNewProductPriceStrategyForDetailTable = []
            this.selectIndividualPriceGapPercentForDetailTable = []
            this.selectApprovedByFioForDetailTable = []
            this.selectIsApprovedForDetailTable = []
            this.selectProductVerticalLineForDetailTable = []
            this.selectSalePointCodesForDetailTable = [];
        }

        clearDetailTableFilterDisabled() {
            return !this.detailTableSkuFilter;
        }

        updateFilterSnapshot(params: ReportDetailParams) {
            const previousFilterState = this.isFilterActive;

            // Определяем, активен ли фильтр используя готовый объект params
            this.isFilterActive = this.hasActiveFilters(params);

            // Создаем снимок текущих отфильтрованных данных
            if (this.allTaskIdWithInternalCodesByFilters) {
                this.filteredSkusSnapshot = this.allTaskIdWithInternalCodesByFilters.map(item => ({
                    internalCode: item.internalCode,
                    taskId: item.taskId
                }));
            }

            // Если фильтр был активен, а теперь стал неактивен (сброс фильтра)
            // нужно принудительно обновить состояние чекбокса
            if (previousFilterState && !this.isFilterActive) {
                // Принудительно обновляем UI, чтобы отразить правильное состояние чекбокса
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            }
        }

        hasActiveFilters(params: ReportDetailParams): boolean {
            // Проверяем текстовый поиск
            if (params.detailTableSkuFilter && params.detailTableSkuFilter.trim() !== '') {
                return true;
            }

            // Проверяем все фильтры в объекте params, используя рефлексию
            const filterKeys = Object.keys(params) as (keyof ReportDetailParams)[];

            for (const key of filterKeys) {
                // Пропускаем служебные поля
                if (['sortingField', 'detailTableSkuFilter', 'taskType', 'selectActiveProductsOnly'].includes(key as string)) {
                    continue;
                }

                const value = params[key];

                // Проверяем массивы
                if (Array.isArray(value) && value.length > 0) {
                    return true;
                }

                // Проверяем булевы значения фильтров (condition поля)
                if (typeof value === 'boolean' || typeof value === 'number') {
                    // Для condition полей: если значение отличается от дефолтного, значит фильтр активен
                    if (key.toString().includes('Condition')) {
                        // Дефолтные значения для condition полей обычно -1 или null
                        if (value !== -1 && value !== null && value !== undefined) {
                            return true;
                        }
                    }
                }
            }

            return false;
        }

        handleCommonCheckboxValueChanged(isChecked: boolean) {
            if (this.isFilterActive && this.filteredSkusSnapshot.length > 0) {
                // Если фильтр активен, работаем только с отфильтрованными элементами
                if (!isChecked) {
                    // Снимаем выбор - добавляем отфильтрованные элементы в исключения
                    // НО сохраняем isAllSkusSelected = true, чтобы невидимые элементы остались выбранными
                    this.filteredSkusSnapshot.forEach(item => {
                        // Проверяем, что у item есть все необходимые поля
                        if (item.internalCode && item.taskId) {
                            const exists = this.excludedSkusProperties.findIndex(
                                excluded => excluded.internalCode === item.internalCode && excluded.taskId === item.taskId
                            ) > -1;
                            if (!exists) {
                                this.excludedSkusProperties.push(item);
                            }
                        }
                    });
                    // Принудительно сохраняем isAllSkusSelected = true
                    this.isAllSkusSelected = true;
                    this.$forceUpdate();
                } else {
                    // Фильтруем только валидные элементы с обоими полями
                    const validFilteredSkus = this.filteredSkusSnapshot.filter(item =>
                        item.internalCode && item.taskId
                    );

                    // Создаем новый массив excludedSkusProperties без отфильтрованных элементов
                    const newExcludedProps = this.excludedSkusProperties.filter(excluded => {
                        return !validFilteredSkus.some(filtered =>
                            filtered.internalCode === excluded.internalCode && filtered.taskId === excluded.taskId
                        );
                    });

                    // Полностью заменяем массив для принудительной реактивности Vue
                    this.excludedSkusProperties = newExcludedProps;

                    // Убеждаемся, что isAllSkusSelected = true для работы с логикой исключений
                    this.isAllSkusSelected = true;

                    // Принудительное обновление UI
                    this.$forceUpdate();
                }
            } else {
                // Если фильтр не активен, работаем как раньше - очищаем все
                this.includedSkusProperties = [];
                this.excludedSkusProperties = [];
            }
        }

        isRowCheckboxChecked(internalCode: string, taskId: number) {
            if (this.isAllSkusSelected) {
                return !(this.excludedSkusProperties.findIndex(item => item.internalCode === internalCode && item.taskId === taskId) > -1);
            } else {
                return this.includedSkusProperties.findIndex(item => item.internalCode === internalCode && item.taskId === taskId) > -1;
            }
        }

        handleRowCheckboxClicked(item: any, value: boolean) {
            if (this.isAllSkusSelected) {
                if (value) {
                    const index = this.excludedSkusProperties.findIndex(el => el.internalCode === item.internalCode && el.taskId === item.taskId)

                    if (index > -1) this.excludedSkusProperties.splice(index, 1);
                } else {
                    this.excludedSkusProperties.push({
                        internalCode: item.internalCode,
                        taskId: item.taskId,
                    });

                    if (!item.activeProduct) {
                        this.arrayOfPushedInactiveSkus.push({
                            internalCode: item.internalCode,
                            taskId: item.taskId,
                        });
                    }
                }
            } else {
                if (value) {
                    this.includedSkusProperties.push({
                        internalCode: item.internalCode,
                        taskId: item.taskId,
                    });

                    if (!item.activeProduct) {
                        this.arrayOfPushedInactiveSkus.push({
                            internalCode: item.internalCode,
                            taskId: item.taskId,
                        });
                    }
                } else {
                    const index = this.includedSkusProperties.findIndex(el => el.internalCode === item.internalCode && el.taskId === item.taskId);

                    if (index > -1) this.includedSkusProperties.splice(index, 1);
                }
            }
        }

        addChangedProductsToArrays(row: ResultTableDetailReports, selected: boolean) {
            const taskIdIndex = this.changesPrices.findIndex((item) => {
                return item.taskId === row.taskId
            });
            if (selected) {
                if (!row.activeProduct) {
                    if (taskIdIndex === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        chPrice.productCodesForAdd.push(row.internalCode)
                        this.changesPrices.push(chPrice)
                    } else {
                        this.changesPrices[taskIdIndex].productCodesForAdd.push(row.internalCode)
                    }
                }
                if (taskIdIndex !== -1) {
                    const delIndex = this.changesPrices[taskIdIndex].productCodesForDelete.findIndex((item) => {
                        return item === row.internalCode
                    });
                    if (delIndex !== -1) {
                        this.changesPrices[taskIdIndex].productCodesForDelete.splice(delIndex, 1);
                    }
                }
            } else {
                if (row.activeProduct) {
                    if (taskIdIndex === -1) {
                        const chPrice = new ChangesPrices();
                        chPrice.taskId = row.taskId
                        if (row.priceDiffPc != 0) {
                            chPrice.productCodesForDelete.push(row.internalCode)
                        }
                        this.changesPrices.push(chPrice)
                    } else {
                        if (row.priceDiffPc != 0) {
                            this.changesPrices[taskIdIndex].productCodesForDelete.push(row.internalCode)
                        }
                    }
                }
                if (taskIdIndex !== -1) {
                    const addIndex = this.changesPrices[taskIdIndex].productCodesForAdd.findIndex((item) => {
                        return item === row.internalCode
                    });
                    if (addIndex !== -1) {
                        this.changesPrices[taskIdIndex].productCodesForAdd.splice(addIndex, 1);
                    }
                }
            }
        }

        disableCorrectedPrice(row: ResultTableDetailReports): boolean {
          if (this.isTaskStatusApproved() || row.isApproved) {
            return true
          }
            const taskIdIndex = this.changesPrices.findIndex((item) => {
                return item.taskId === row.taskId
            });

            if (taskIdIndex !== -1) {
                let isRowSelected: boolean;

                if (this.isAllSkusSelected) {
                    isRowSelected = this.excludedSkusProperties.findIndex(item => {
                        return item.internalCode === row.internalCode;
                    }) === -1;
                } else {
                    isRowSelected = this.includedSkusProperties.findIndex(item => {
                        return item.internalCode === row.internalCode;
                    }) > -1;
                }

                return this.disableEdit || !row.activeProduct || !isRowSelected;
            } else {
                return this.disableEdit || !row.activeProduct
            }
        }

        isTaskStatusApproved(): boolean {
          return this.taskData != null && this.taskData.status == TaskStatus.APPROVED
        }

        getPackageParamsDetailFilter(): PackageParamsInDetailReportFilters {
            return {
                coefficientK1: this.$packageParamsInDetailReport.selectCoefficent.value.k1,
                coefficientK2: this.$packageParamsInDetailReport.selectCoefficent.value.k2,
                allCheck: this.$packageParamsInDetailReport.allCheck,
                discountPrise: this.$packageParamsInDetailReport.discountPrice,
                pennies: this.$packageParamsInDetailReport.pennies,
                randomPennies: this.$packageParamsInDetailReport.randomPennies,
                countPriceBySkuWithoutBatches: this.$packageParamsInDetailReport.countPriceBySkuWithoutBatches,
                countByAvgPurchasePrice: this.$packageParamsInDetailReport.countByAvgPurchasePrice,
                calcPurchasePriceByClusters: this.$packageParamsInDetailReport.calcPurchasePriceByClusters,
                useEmptyRemains: this.$packageParamsInDetailReport.useEmptyRemains,
                useArrivalDate: this.$packageParamsInDetailReport.useArrivalDate,
                countAtLastPurchasePrice: this.$packageParamsInDetailReport.countAtLastPurchasePrice,
                countAtFuturePurchasePrice: this.$packageParamsInDetailReport.countAtFuturePurchasePrice,
                allNewPricesWithoutPennies: this.$packageParamsInDetailReport.allNewPricesWithoutPennies,
                allClaster: this.$packageParamsInDetailReport.allClaster,
                xyzChecked: this.$packageParamsInDetailReport.xyzChecked,
                uvwChecked: this.$packageParamsInDetailReport.uvwChecked,
                spreadUVWParams: this.$packageParamsInDetailReport.uvwParams,
                spreadXYZParams: this.$packageParamsInDetailReport.xyzParams,
                intervalOfUltimateElasticity: this.$packageParamsInDetailReport.intervalOfUltimateElasticity,
                calculationDepth: this.$packageParamsInDetailReport.calculationDepth,
                calculationDay: this.$packageParamsInDetailReport.calculationDay,
                competitorsPricesParams: this.$packageParamsInDetailReport.competitorsPrices,
                minProfitKVI: this.$packageParamsInDetailReport.minProfitKVI,
                maxProfitKVI: this.$packageParamsInDetailReport.maxProfitKVI != null ? this.$packageParamsInDetailReport.maxProfitKVI : 100,
                percentageOfCompetitorsPrice: this.$packageParamsInDetailReport.percentageOfCompetitorsPrice,
                marginalProfitability: this.$packageParamsInDetailReport.marginalProfitability,
                marginalProfit: this.$packageParamsInDetailReport.marginalProfit,
                maxMarginalProfit: this.$packageParamsInDetailReport.maxMarginalProfit != null ? this.$packageParamsInDetailReport.maxMarginalProfit : 100,
                marginalPriceDifference: this.$packageParamsInDetailReport.marginalPriceDifference,
                priceIncreaseLimit: this.$packageParamsInDetailReport.priceIncreaseLimit,
                priceDecreaseLimit: this.$packageParamsInDetailReport.priceDecreaseLimit,
                kviPriceDecreaseLimit: this.$packageParamsInDetailReport.kviPriceDecreaseLimit,
                compPriceDecreaseLimit: this.$packageParamsInDetailReport.compPriceDecreaseLimit,
                correlation: this.$packageParamsInDetailReport.correlation,
                highElasticity: this.$packageParamsInDetailReport.highElasticity,
                kviStrategy: this.$packageParamsInDetailReport.kviStrategy.value,
                period: this.$packageParamsInDetailReport.period.value,
                periodPriceIncreaseLimit: this.$packageParamsInDetailReport.periodPriceIncreaseLimit,
                priceCorridor: this.$packageParamsInDetailReport.priceCorridor,
                fixLowerBorder: this.$packageParamsInDetailReport.fixLowerBorder,
                depthToPurchasePrice: this.$packageParamsInDetailReport.depthToPurchasePrice,
                priceFamilies: this.$packageParamsInDetailReport.priceFamilies,
                hardPriceFamilies: this.$packageParamsInDetailReport.hardPriceFamilies,
                changePriceCorridor: this.$packageParamsInDetailReport.changePriceCorridor,
                useCompetitorsPrices: this.$packageParamsInDetailReport.useCompetitorsPrices,
                byPromoPrices: this.$packageParamsInDetailReport.byPromoPrices,
                roundPricesWithEqualCompStrategy: this.$packageParamsInDetailReport.roundPricesWithEqualCompStrategy,
                competitorsPricePeriod: this.$packageParamsInDetailReport.competitorsPricePeriod,
                competitorsPriceMethod: this.$packageParamsInDetailReport.competitorsPriceMethod.value,
                newProductPriceStrategy: this.$packageParamsInDetailReport.newProductPriceStrategy.value,
                priceGap: this.$packageParamsInDetailReport.priceGap,
                priceGapCtmPc: this.$packageParamsInDetailReport.priceGapCtmPc,
                manualPennies: this.$packageParamsInDetailReport.manualPennies,
                competitorsPriceAdjustment: this.$packageParamsInDetailReport.competitorsPriceAdjustment,
                competitorsInfluencesCoef: this.$packageParamsInDetailReport.competitorsInfluencesCoef,
                competitorsMinimumProfit: this.$packageParamsInDetailReport.competitorsMinimumProfit,
                competitorsMaximumProfit: this.$packageParamsInDetailReport.competitorsMaximumProfit != null ? this.$packageParamsInDetailReport.competitorsMaximumProfit : 100,
                competitorsControlParam: this.$packageParamsInDetailReport.competitorsControlParam,
                competitorsPriceStrategy: this.$packageParamsInDetailReport.competitorsPriceStrategy.value,
                roundKviCompetitorPrice: this.$packageParamsInDetailReport.roundKviCompetitorPrice,
                calculateByRegression: this.$packageParamsInDetailReport.calculateByElasticity,
                recalculateCtm: this.$packageParamsInDetailReport.recalculateCtm,
                priceChangeLimit: this.$packageParamsInDetailReport.priceChangeLimit,
                calculatePYR: this.$packageParamsInDetailReport.calculatePYR,
                calculateCompAllowedDeviation: this.$packageParamsInDetailReport.calculateCompAllowedDeviation,
                useCompElasticity: this.$packageParamsInDetailReport.useCompElasticity,
                forecastAccuracy: this.$packageParamsInDetailReport.forecastAccuracy,
                countAtMaxPurchasePrice: this.$packageParamsInDetailReport.countAtMaxPurchasePrice,
                useAllProductBatchNumbers: this.$packageParamsInDetailReport.useAllProductBatchNumbers,
                priceOpt: this.$packageParamsInDetailReport.selectCoefficent.value.enum,
                lift: this.$packageParamsInDetailReport.lift,
                crossCalculation: this.$packageParamsInDetailReport.crossCalculation,
                promoType: this.$packageParamsInDetailReport.promoType.value,
                availableStockDelta: this.$packageParamsInDetailReport.availableStockDelta,
                calculateCommon: this.$packageParamsInDetailReport.calculateCommon,
                intervalOfCorrelationElasticity: this.$packageParamsInDetailReport.intervalOfCorrelationElasticity,
                useDiscountDurationForForecastCalculation: this.$packageParamsInDetailReport.useDiscountDurationForForecastCalculation,
                excludeOutOfStock: this.$packageParamsInDetailReport.excludeOutOfStock,
                backBasketPart: this.$packageParamsInDetailReport.backBasketPart,
                percentileType: this.$packageParamsInDetailReport.percentileType.value,
                checkMarginDeclineProfit: this.$packageParamsInDetailReport.checkMarginDeclineProfit,
                declineProfitabilityPc: this.$packageParamsInDetailReport.declineProfitabilityPc,
                searchPreviousPricesDepth: this.$packageParamsInDetailReport.searchPreviousPricesDepth,
                compensateLowerTargets: this.$packageParamsInDetailReport.compensateLowerTargets,
                spreadByPriceSegments: this.$packageParamsInDetailReport.spreadByPriceSegments
            };
        }

        private clearDetailTableFilter() {
            this.detailTableSkuFilter = '';
            this.resetTableSortingField();
            this.resetAllFiltersFields()
            this.refreshDetailTable()
        }

        private loadHeaders() {
            this.downloadLastExcelHeaderByFilters = true;
            this.refreshHeaderTable();
        }

        private loadDetails() {
            this.downloadLastExcelDetailByFilters = true;
        }

        private refreshDetailTable() {
            const oldRefreshId = this.refreshDetailTableId;
            if (oldRefreshId !== -1) {
                clearTimeout(oldRefreshId);
            }
            const timeoutId = setTimeout(() => {
                if (this.refreshDetailTableId === timeoutId) {
                    const pagination = { ...this.pagination }
                    pagination.current = 1;
                    this.pagination = pagination
                    const detailTable = this.$refs.resultDetailReportRef as any;
                    if (typeof detailTable !== 'undefined') {
                        this.fetchResultTableDetailReports()
                        detailTable.$forceUpdate();
                    }
                    this.refreshDetailTableId = -1;
                }
            }, 300);
            this.refreshDetailTableId = timeoutId;
        }

        private refreshHeaderTable() {
            const oldRefreshId = this.refreshHeaderTableId;
            if (oldRefreshId !== -1) {
                clearTimeout(oldRefreshId);
            }
            const timeoutId = setTimeout(() => {
                if (this.refreshHeaderTableId === timeoutId) {
                    this.skuListCurrentPage = 1;
                    const headerTable = this.$refs.resultHeaderTableRef as any;
                    if (typeof headerTable !== 'undefined') {
                        headerTable.refresh();
                    }
                    this.refreshHeaderTableId = -1;
                }
            }, 300);
            this.refreshHeaderTableId = timeoutId;
        }

        private getSegmentPriceForDetailReport() {
            if (this.taskData == null) {
                return
            }
            this.httpGetPriceSegmentsForDetailReport(this.taskData.id, this.taskData.type)
                .then((data) => {
                    this.segmentPriceOptionsForDetailTable = data.data.map((i) => {
                        return {value: i, label: i.name}
                    });
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.searchPriceSegmentsFailed') as string)
                })
        }

        private setShowDeletedItems(showDeleted: boolean) {
            this.showDeletedItems = showDeleted
            this.selectActiveProductsOnly = !showDeleted

            if (!showDeleted) {
                this.includedSkusProperties = this.includedSkusProperties.filter(el => this.arrayOfPushedInactiveSkus.findIndex(sku => sku.internalCode === el.internalCode && sku.taskId === el.taskId) === -1);
                this.excludedSkusProperties = this.excludedSkusProperties.filter(el => this.arrayOfPushedInactiveSkus.findIndex(sku => sku.internalCode === el.internalCode && sku.taskId === el.taskId) === -1);

                this.arrayOfPushedInactiveSkus = [];
            }

            this.refreshDetailTable()
        }

        showApproveLineModal(data: ResultTableDetailReports) {
          this.singleLineToApprove = data
          this.showApproveSingleLineModal = true
        }

        approveLine() {
          if (!this.singleLineToApprove) {
            this.showError(this.$t('regular.notifications.noRowSelectedForApproval') as string)
            return
          }
          if (!this.taskData) {
            this.showError(this.$t('regular.errors.noCalcInfo') as string)
            return
          }
          const data = this.singleLineToApprove!!

          const checkboxesData: ApproveReportElementsSelectedCheckboxesData = {
              isCommonCheckboxSelected: false,
              includedIds: [parseInt(data.id)],
              excludedIds: [],
          };

          this.httpApproveReportDetailLines(
              this.taskData.id, checkboxesData
          ).then(() => {
            this.showInfo(this.$t('regular.notifications.reportRowApproved') as string)
            this.fetchResultTableDetailReports();
          })
        }

        showApproveAllDisplayedLines() {
          this.showApproveAllDisplayedLinesModal = true
        }

        importCorrectedPricesFileAndRecalculate() {
          if (!this.correctedPricesFile) {
            this.showInfo(this.$t('regular.common.selectFile') as string);
            return;
          }

          // Проверяем наличие автосогласованных товаров
          const autoApprovedItems = this.resultTableDetailReports.filter(row => 
            this.getApprovalStatus(row) === ApprovalStatus.APPROVED_AUTOMATICALLY
          );
          
          if (autoApprovedItems.length > 0) {
            this.showInfo((this.$t('results.messages.autoApprovedExcluded', { count: autoApprovedItems.length }) as string));
          }

          this.loadProgress = true;

          const uploadFile = new FormData();
          const size = this.correctedPricesFile.size;
          const taskId = this.taskData && this.taskData.id;
          const taskType = this.taskData && this.taskData.type;

          const uploadMode =
              taskType === 'PACKAGE_GENERAL_PROMOTION'
                  ? PriceImportMode.PROMO
                  : taskType === 'PACKAGE_GENERAL' ||
                  taskType === 'PACKAGE_GENERAL_KVI_CARTS' ||
                  taskType === 'PACKAGE_GENERAL_SCENARIO' ||
                  taskType === 'PACKAGE_EVENTS_GENERAL' ||
                  taskType === 'PACKAGE_GENERAL_FIXED_PRICE'
                      ? PriceImportMode.REGULAR
                      : null;

          uploadFile.append(
              'file',
              new Blob([this.correctedPricesFile]),
              this.correctedPricesFile.name
          );

          if (taskId !== null) {
            if (!uploadMode) {
              this.showError(this.$t('results.messages.importNotAvailableForType', { type: (this.taskData && this.taskData.type) || '' }) as string);
              this.loadProgress = false;
              this.progressCounter = 0;
              return;
            }
            this.httpUploadCorrectedPricesFile(taskId, uploadFile, uploadMode)
                .then((r) => {
                  const hasAnySaved = r.data;
                  this.correctedPricesFile = null;
                  this.showInfo(this.$t('regular.notifications.priceCorrectionsLoaded') as string);
                  if (hasAnySaved) {
                    this.changesPrices = [];
                    this.hasUnsavedRegularPrices = false;
                    this.hasUnsavedPromoPrices = false;
                    this.hasCorrectedPrices = true;
                    this.refreshDetailTable();
                  }
                })
                .catch((e) => {
                  const message = typeof e.response.data === 'string'
                      ? e.response.data
                      : e.message || this.$t('regular.errors.unknownError') as string;

                  this.showError(this.$t('results.messages.errorImportCorrectedPrices', { message }) as string);
                })
                .finally(() => {
                  this.loadProgress = false;
                  this.progressCounter = 0;
                });
          } else {
            this.loadProgress = false;
            this.progressCounter = 0;
          }
        }

        importCorrectedPromoPricesFileAndRecalculate() {
          if (!this.correctedPromoPricesFile) {
            this.showInfo(this.$t('regular.common.selectFile') as string);
            return;
          }

          const autoApprovedItems = this.resultTableDetailReports.filter(
              (row) => this.getApprovalStatus(row) === ApprovalStatus.APPROVED_AUTOMATICALLY
          );

          if (autoApprovedItems.length > 0) {
            this.showInfo(this.$t('results.messages.autoApprovedExcluded', { count: autoApprovedItems.length }) as string);
          }

          this.loadProgress = true;

          const taskId = this.taskData && this.taskData.id;
          const taskType = this.taskData && this.taskData.type;

          const uploadMode =
              taskType === 'PACKAGE_GENERAL_PROMOTION'
                  ? PriceImportMode.PROMO
                  : taskType === 'PACKAGE_GENERAL' ||
                  taskType === 'PACKAGE_GENERAL_KVI_CARTS' ||
                  taskType === 'PACKAGE_GENERAL_SCENARIO' ||
                  taskType === 'PACKAGE_EVENTS_GENERAL' ||
                  taskType === 'PACKAGE_GENERAL_FIXED_PRICE'
                      ? PriceImportMode.REGULAR
                      : null;

          const uploadFile = new FormData();
          uploadFile.append(
              'file',
              new Blob([this.correctedPromoPricesFile]),
              this.correctedPromoPricesFile.name
          );

          if (taskId == null) {
            this.loadProgress = false;
            this.progressCounter = 0;
            return;
          }

          if (!uploadMode) {
            this.showError(this.$t('results.messages.importNotAvailableForType', { type: taskType || '' }) as string);
            this.loadProgress = false;
            this.progressCounter = 0;
            return;
          }

          this.httpUploadCorrectedPricesFile(taskId, uploadFile, uploadMode)
              .then(() => {
                this.correctedPromoPricesFile = null;
                this.showInfo(this.$t('regular.notifications.promoPriceCorrectionsLoaded') as string);

                this.changesPrices = [];
                // После успешной загрузки считаем, что появились изменения для пересчёта
                this.hasCorrectedPrices = true;
                this.hasUnsavedPromoPrices = true;
                this.refreshDetailTable();
              })
              .catch((e) => {
                const message =
                    e && e.response && typeof e.response.data === 'string'
                        ? e.response.data
                        : (e && e.message) || this.$t('regular.errors.unknownError') as string;

                this.showError(this.$t('results.messages.errorImportCorrectedPromoPrices', { message }) as string);
              })
              .finally(() => {
                this.loadProgress = false;
                this.progressCounter = 0;
              });
        }

        approveAllDisplayedLines() {
          if (!this.taskData) {
            this.showError(this.$t('regular.errors.noReportInfo') as string)
            return
          }

          if (!this.resultTableDetailReports) {
            this.showError(this.$t('regular.notifications.noItemsForBulkApproval') as string)
            return
          }

          let ids = this.resultTableDetailReports.map(item => {
            return parseInt(item.id)
          })

          const checkboxesData: ApproveReportElementsSelectedCheckboxesData = {
              isCommonCheckboxSelected: false,
              includedIds: ids,
              excludedIds: [],
          };

          this.tableIsLoading = true
          this.httpApproveReportDetailLines(this.taskData.id, checkboxesData)
              .then(() => {
                this.showInfo(this.$t('regular.notifications.reportRowsApproved') as string)
                this.fetchResultTableDetailReports();
                this.fetchTaskData()
              })
              .finally(() => {
                this.tableIsLoading = false
              })
        }

        disableApproveButton(data: ResultTableDetailReports): boolean {
          // Блокируем кнопку для автосогласованных товаров
          if (this.getApprovalStatus(data) === ApprovalStatus.APPROVED_AUTOMATICALLY) {
            return true;
          }
          
          return (!!this.taskData && this.taskData.status != TaskStatus.ONAPPROVAL)
              || !this.isRowCheckboxChecked(data.internalCode, data.taskId);
        }

        getApprovalStatus(data: ResultTableDetailReports): ApprovalStatus {
            return data.approvalStatus || ApprovalStatus.NOT_APPROVED;
        }

        disableApproveAllDisplayedLinesButton(): boolean {
          return !this.taskData
              || this.taskData.status != TaskStatus.ONAPPROVAL
              || this.tableIsLoading
        }

        fetchTaskData() {
          if (!this.taskData) {
            return
          }
          this.httpLoadTaskById(this.taskData.id)
              .then((r) => {
                const task = r.data
                this.taskData = {
                  id: task.id,
                  status: task.status,
                  type: task.typeMachine,
                  fileResult: task.fileResult,
                  editable: task.editable,
                  filterNames: this.taskData!!.filterNames,
                  tradingId: task.tradingNetworks.id,
                  taskNote: task.taskNote,
                }
              })
              .catch((e) => {
                this.showError(this.$t('regular.errors.loadCalcInfoFailed') as string)
              })
        }

        get columnsForManageModal(): Array<IColumnLight> {
            const columnsLight = (() => {
                const ignoredColumnKeys = this.detailUserFields.filter(field => field.permanentlyHidden).map(field => field.key);

                switch (this.reportType) {
                    case 'promo':
                        return this.promoColumnsForManageModal.filter(column => !ignoredColumnKeys.includes(column.dataIndex));
                    case 'sales':
                        return this.salesColumnsForManageModal.filter(column => !ignoredColumnKeys.includes(column.dataIndex));
                    default:
                        return this.regularColumnsForManageModal.filter(column => !ignoredColumnKeys.includes(column.dataIndex));
                }
            })();

            const adjustedColumns = this.reportType === 'sales'
                ? columnsLight
                    .filter((column) => this.isSalesRealizationReport || !['initialRemains', 'realizationPercent'].includes(column.dataIndex))
                    .map((column) => column.dataIndex === 'remains'
                        ? ({...column, title: this.getSalesRemainsLabel()})
                        : column)
                : columnsLight;

            return this.tableColumnsOrder.length ? this.getOrderedByDataIndexes(adjustedColumns, this.tableColumnsOrder) : adjustedColumns;
        }

        get resultDetailColumns(): any[] {
            const columns = (() => {
                switch (this.reportType) {
                    case 'promo':
                        return this.promoDetailReport;
                    case 'sales':
                        return this.salesDetailReport;
                    default:
                        return this.regularDetailReport;
                }
            })();

            return this.tableColumnsOrder.length ? this.getOrderedByDataIndexes(columns, this.tableColumnsOrder) : columns;
        }

        get disableEdit(): boolean {
            return this.taskData == null || (this.taskData.status !== 'WriteToFileComplete' && this.taskData.status !== 'OnApproval' && this.taskData.status !== 'Rejected' && this.taskData.status !== 'Approved');
        }

        get taskId(): string {
            if (this.taskData == null) {
                return ''
            }
            return `${this.taskData.id}`;
        }

        get isNotApprovedGeneralReport(): boolean {
          const validTypes = [
            'PACKAGE_GENERAL',
            'PACKAGE_GENERAL_KVI_CARTS',
            'PACKAGE_GENERAL_SCENARIO',
            'PACKAGE_EVENTS_GENERAL',
            'PACKAGE_GENERAL_FIXED_PRICE',
          ];
          return !!(this.taskData && this.taskData.status !== TaskStatus.APPROVED && validTypes.includes(this.taskData.type));
        }

        get isNotApprovedGeneralPromoReport(): boolean {
          const validTypes = [
            'PACKAGE_GENERAL_PROMOTION'
          ];
          return !!(this.taskData && this.taskData.status !== TaskStatus.APPROVED && validTypes.includes(this.taskData.type));
        }

        get isSalesRealizationReport(): boolean {
            return !!this.taskData
                && [TaskType.PACKAGE_GENERAL_SALES, TaskType.PACKAGE_GENERAL_AGGREGATE_SALES].includes(this.taskData.type as TaskType);
        }

        getSalesRemainsLabel(): string {
            return this.$t(this.isSalesRealizationReport ? 'regular.columns.currentDateRemains' : 'regular.columns.stock') as string;
        }

        getSalesDetailFieldLabel(fieldKey: string, defaultLabel: any): any {
            if (fieldKey === 'remains') {
                return this.getSalesRemainsLabel();
            }

            return defaultLabel;
        }

        // for filters
        @Watch("filterValues", {deep: true})
        onFilterValuesChange() {
            Object.keys(this.filterValues).forEach((key) => {
                const filterArray = this.filterValues[key as keyof commonFilters];
                this.updateFilterArray(filterArray);
            });
        }

        updateFilterArray(filterArray: (string | number)[]) {
            if (filterArray.length === 0) {
                filterArray.push("all");
            } else if (filterArray.includes("all") && filterArray.length > 1) {
                filterArray.splice(filterArray.indexOf("all"), 1);
            }
        }

        fetchCommonFilterOptions() {
            this.handleResetFilters(true);

            this.requestFilterOptions("group", "groups");
            this.requestFilterOptions("format", "storeFormat");
        }

        async requestFilterOptions(filterBy: string, keyToChange: keyof commonFilters) {
            const obj: IInfoPayloadData = {
                groups: this.filterValues.groups.filter((item) => item !== "all"),
                categories: this.filterValues.categories.filter((item) => item !== "all"),
                subcategories: this.filterValues.subcategories.filter((item) => item !== "all"),
                storeFormat: this.filterValues.storeFormat.filter((item) => item !== "all"),
                storeRegion: this.filterValues.storeRegion.filter((item) => item !== "all"),
                storeCluster: this.filterValues.storeCluster.filter((item) => item !== "all"),
                tradingId: this.taskData!.tradingId!,
                type: filterBy,
            };

            let payload: any = {
                tradingId: this.taskData!.tradingId,
                type: filterBy,
            };

            Object.keys(obj).filter(key => !['tradingId', 'type'].includes(key)).forEach((optionsType: string) => {
                 payload[optionsType] = (obj[optionsType as keyof IInfoPayloadData] as string[]).map((name: string) => this.filterOptions[optionsType as keyof IFilterOptions]
                    .find((option: {id: string | number, name: string}) => option.name === name)!.id);
            })

            try {
                const response = await this.$http.post("/api/task/info", payload);
                this.filterOptions[keyToChange] = response.data[keyToChange];
            } catch (error) {
                console.error("Error sending POST request:", error);
            }
        }

        fetchHasCorrectedPricesFlag() {
          if (this.taskData == null) {
            this.hasCorrectedPrices = false;
            return;
          }

          const taskId = this.taskData.id;
          const taskType = this.taskData.type;

          this.httpCheckHasCorrectedRegularPrices(taskId, taskType)
              .then((resp) => {
                this.hasCorrectedPrices = resp.data;
              })
              .catch((e) => {
                this.hasCorrectedPrices = false;
                this.showError(this.$t('regular.errors.loadCorrectedPricesInfoFailed') as string);
              });
        }

        async handleFilterGroup(elemids: any) {
            this.filterValues.groups = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
            this.filterValues.categories = ["all"];
            this.filterValues.subcategories = ["all"];

            await this.requestFilterOptions("category", "categories");
        }

        async handleFilterCategory(elemids: any) {
            this.filterValues.categories = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
            this.filterValues.subcategories = ["all"];

            await this.requestFilterOptions("subcategory", "subcategories");
        }

        async handleFilterSubcategory(elemids: any) {
            this.filterValues.subcategories = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
        }

        async handleFilterFormat(elemids: any) {
            this.filterValues.storeFormat = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
            this.filterValues.storeRegion = ["all"];
            this.filterValues.storeCluster = ["all"];

            await this.requestFilterOptions("region", "storeRegion");
        }

        async handleFilterRegion(elemids: any) {
            this.filterValues.storeRegion = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
            this.filterValues.storeCluster = ["all"];

            await this.requestFilterOptions("cluster", "storeCluster");
        }

        async handleFilterCluster(elemids: any) {
            this.filterValues.storeCluster = elemids[elemids.length - 1] === "all" ? ["all"] : elemids;
        }

        handleApplyFilters(withoutFetch: boolean = false) {
            this.selectGroupNameForDetailTable = this.filterValues.groups.filter((item) => item !== "all");
            this.selectCategoryNameForDetailTable = this.filterValues.categories.filter((item) => item !== "all");
            this.selectSubcategoryNamesForDetailTable = this.filterValues.subcategories.filter((item) => item !== "all");
            this.selectFormatNameForDetailTable = this.filterValues.storeFormat.filter((item) => item !== "all");
            this.selectRegionNameForDetailTable = this.filterValues.storeRegion.filter((item) => item !== "all");
            this.selectClusterNameForDetailTable = this.filterValues.storeCluster.filter((item) => item !== "all");

            // Сбрасываем пагинацию на первую страницу при применении фильтров
            this.pagination.current = 1;

            if (!withoutFetch) {
                this.fetchResultTableDetailReports();
            }
        }

        filterDropdownVisibleChange(filterModel: string) {
            this.filterDropdownsState[filterModel] = !this.filterDropdownsState[filterModel];
        }

        getFilterIconActivity(filterModel: string): boolean {
            const filterValue = (this as any)[this.getForDetailTableVariableName(filterModel)];

            return Array.isArray(filterValue) ?
                !!filterValue.length :
                !!filterValue || filterValue === 0;
        }

        handleCheckboxGroupChanged(filterModel: string, value: string) {
            (this as any)[this.getForDetailTableVariableName(filterModel)] = value;

            // Сбрасываем пагинацию на первую страницу при изменении фильтра
            this.pagination.current = 1;
        }

        handleRadioGroupChanged(filterModel: string, value: number) {
            if (filterModel === 'kvi') {
                const index = this.kviOptions.findIndex(item => item.value === value);

                if (index > -1) (this as any)[this.getForDetailTableVariableName(filterModel)] = this.kviOptions[index];
            } else if (filterModel === 'ctm') {
                const index = this.ctmOptionsForDetailTable.findIndex(item => item.value === value);

                if (index > -1) (this as any)[this.getForDetailTableVariableName(filterModel)] = this.ctmOptionsForDetailTable[index];
            } else {
                (this as any)[this.getForDetailTableVariableName(filterModel)] = value;
            }

            // Сбрасываем пагинацию на первую страницу при изменении фильтра
            this.pagination.current = 1;
        }

        handleAllCheckboxChanged(value: boolean, filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
            this.filterAllCheckboxCheckedState[filterModel] = value;

            const variableName = this.getForDetailTableVariableName(filterModel);

            if (value) {
                (this as any)[variableName] = [
                    ...new Set([
                        ...(this as any)[variableName],
                        ...this.getFilterOptions(filterModel, filterOptionsKey, useRange).map((option: SelectBox<number>) => option.value),
                    ])
                ];
            } else {
                const optionValuesToDeselect = this.getFilterOptions(filterModel, filterOptionsKey, useRange).map((option: SelectBox<number>) => option.value);

                (this as any)[variableName] = (this as any)[variableName].filter((value: string) => !optionValuesToDeselect.includes(value));
            }
        }

        getFilterOptions(filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
            if (useRange) {
                return this.tableFilterOptions[filterOptionsKey].filter((option: SelectBox<number>) => {
                    if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && !(this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return option.value >= this.filterDropdownsRange.from[filterModel];
                    } else if (!(this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return option.value <= this.filterDropdownsRange.to[filterModel];
                    } else if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return this.filterDropdownsRange.from[filterModel] <= option.value && option.value <= this.filterDropdownsRange.to[filterModel];
                    } else {
                        return true;
                    }
                })
            } else {
                return this.tableFilterOptions[filterOptionsKey];
            }
        }

        getVariable(variableName: string) {
          return (this as any)[variableName];
        }

        getForDetailTableVariableName(filterModel: string): string {
            let key = filterModel;

            if (key === 'subCategoryName') key = 'subcategoryName'
            if (key === 'productSegmentName') key = 'segmentName'
            if (key === 'segment') key = 'segmentPrice'
            if (key === 'kvi') key = 'KVI'
            if (key === 'ctm') key = 'CTM'

            key = key.charAt(0).toUpperCase() + key.slice(1);

            return (this as any)[`select${key}ForDetailTable`] ? `select${key}ForDetailTable` : `select${key}sForDetailTable`;
        }

        handleResetFilters(withoutFetch: boolean = false) {
            this.filterValues = {
                groups: ["all"],
                categories: ["all"],
                subcategories: ["all"],
                storeFormat: ["all"],
                storeRegion: ["all"],
                storeCluster: ["all"],
            };

            // Сбрасываем пагинацию на первую страницу при сбросе фильтров
            this.pagination.current = 1;

            this.handleApplyFilters(withoutFetch);
        }

        prepareDataForPriceHistory(data: any) {
            return data.newPriceHistory.replace('\n', '').split(';').filter((historyItem: string) => historyItem.length).map((historyItem: string) => {
                let resultStr: string = '';
                let value = '';

                resultStr = historyItem.trim();

                if (historyItem.startsWith(this.$t('regular.tooltips.new') as string)) {
                    resultStr = resultStr.slice(6);
                }

                resultStr = resultStr.charAt(0).toUpperCase() + resultStr.slice(1);

                const equalsIndex = resultStr.lastIndexOf(' = ');

                if (equalsIndex !== -1) {
                    value = resultStr.slice(equalsIndex + 3);

                    resultStr = resultStr.slice(0, equalsIndex);
                }

                return {value, resultStr, priceColorClass: resultStr ? this.getPriceColorClass(resultStr) : ''};
            })
        }

    getPriceColorClass(text: string): string {
        const colorClass = Object.keys(this.historyItemsClasses).find(key => {
            return this.historyItemsClasses[key].findIndex((textItem: string) => textItem.toLowerCase() === text.trim().toLowerCase()) > -1;
        })

        return colorClass || '';
    }

    getDetailTableColumnsOrder() {
        const value = (() => {
            switch (this.reportType) {
                case 'promo':
                    return localStorage.getItem('skuDetailPromoColumnsOrder');
                case 'sales':
                    return localStorage.getItem('skuDetailSalesColumnsOrder');
                default:
                    return localStorage.getItem('skuDetailRegularColumnsOrder');
            }
        })();

        this.tableColumnsOrder = value ? value.split(',') : [];
    }

    getOrderedByDataIndexes(arrayForOrder: any[], orderedDataIndexes: string[]) {
        if (!orderedDataIndexes.length) {
            return arrayForOrder;
        }

        const resultArr = [];

        const objectsWithoutIndexes = arrayForOrder.filter((el: any) => !el.dataIndex);

        resultArr.push(...objectsWithoutIndexes);

        orderedDataIndexes.forEach(dataIndex => {
            const obj = arrayForOrder.find((obj: any) => obj.dataIndex === dataIndex);

            if (obj) {
                resultArr.push(obj);
            }
        });

        return resultArr;
    }
}
